/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /**  This represents the "Long" type which is a representation of java.lang.Long  */
  BigDecimal: { input: any; output: any }
  /** A RFC-3339 compliant date scalar that accepts string values in the format `yyyy-MM-dd`. */
  Date: { input: any; output: any }
  /** A RFC-3339 compliant date time scalar that accepts string values in the format `1996-12-19T16:39:57-08:00`. */
  DateTime: { input: any; output: any }
  /**  This represents the "Long" type which is a representation of java.lang.Long  */
  Long: { input: any; output: any }
  /** Vehicle identification number */
  VIN: { input: any; output: any }
  /** Represents the Master customer number */
  fc__customer__MCN: { input: any; output: any }
  /** Represents the Account Number */
  fmcc__account__AccountNumber: { input: any; output: any }
  /** Represents the Bank account Id */
  fmcc__customer__BankAccountId: { input: any; output: any }
  /** Represents the Customer Id */
  fmcc__customer__CustomerID: { input: any; output: any }
}

/** Represents whether the account type is `FCCA`, `FCUS`, `FCCL`, `LCCA`, `LCCL` or `LINC`. */
export enum AccountType {
  /** Indicates the account type is `FCCA`. */
  Fcca = 'FCCA',
  /** Indicates the account type is `FCCL`. */
  Fccl = 'FCCL',
  /** Indicates the account type is `FCUS`. */
  Fcus = 'FCUS',
  /** Indicates the account type is `LCCA`. */
  Lcca = 'LCCA',
  /** Indicates the account type is `LCCL`. */
  Lccl = 'LCCL',
  /** Indicates the account type is `LINC`. */
  Linc = 'LINC',
}

/** A set of input parameters changing a address. */
export type Address = {
  /** The first line of the street address. */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The second line of the street address. */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** The city name in the address. */
  city?: Maybe<Scalars['String']['output']>
  /** The country code in the address. */
  country?: Maybe<Scalars['String']['output']>
  /** The state in the address. */
  state?: Maybe<Scalars['String']['output']>
  /** The ZIP code in the address. */
  zip?: Maybe<Scalars['String']['output']>
}

/** Represents whether a customer is the primary buyer or a co-buyer. */
export enum ApplicantCode {
  /** Co-Buyer */
  Co = 'CO',
  /** Primary Buyer */
  Pr = 'PR',
}

/** Represents whether a customer is US or CA */
export enum Country {
  /** Canada */
  Ca = 'CA',
  /** United States */
  Us = 'US',
}

/** Represents whether a country code is USA or CAN */
export enum CountryCode {
  /** Canada */
  Can = 'CAN',
  /** United states */
  Usa = 'USA',
}

/** Represents whether the currency code is USD or CAD. */
export enum CurrencyCode {
  /** Indicates the currency code is `CAD` (Canadian dollars). */
  Cad = 'CAD',
  /** Indicates the currency code is `USD` (US dollars). */
  Usd = 'USD',
}

/** The customer's segment to show the appropriate offer for the customer. */
export enum CustomerSegment {
  /** Engagement Retail */
  EngagementRetail = 'ENGAGEMENT_RETAIL',
  /** First time lessee */
  FirstTimeLessee = 'FIRST_TIME_LESSEE',
  /** My retail advisor fourth year */
  MraFourthYear = 'MRA_FOURTH_YEAR',
  /** My retail advisor third year */
  MraThirdYear = 'MRA_THIRD_YEAR',
  /** Options customers */
  OptionsCustomers = 'OPTIONS_CUSTOMERS',
  /** Returning lease */
  ReturningLease = 'RETURNING_LEASE',
  /** Unset */
  Unset = 'UNSET',
}

/** A flag indicating the signature status of the DocuSign document for an extension */
export enum ExtensionSignatureStatus {
  /** The document has received all required signatures. */
  Completed = 'COMPLETED',
  /** The document requires signatures from both primary buyer and cobuyer, but the primary buyer has not signed yet. */
  PendingBuyer = 'PENDING_BUYER',
  /** The document requires signatures from both primary buyer and cobuyer, but the cobuyer has not signed yet. */
  PendingCobuyer = 'PENDING_COBUYER',
  /** The document has been sent, but it does not yet have any signature. */
  Sent = 'SENT',
}

/** MNV flags indicating certain features are enabled or disabled for the account */
export type FcAccountFlags = {
  __typename?: 'FcAccountFlags'
  /** Whether dealer changed or not */
  dealerChanged?: Maybe<Scalars['Boolean']['output']>
  /** Checks whether same trim or different trim for preferred vehicle */
  differentTrimForPreferredVehicle?: Maybe<Scalars['Boolean']['output']>
  /** Account is eligible to show equity or not */
  eligibleToShowEquity?: Maybe<Scalars['Boolean']['output']>
  /** Checks whether its eligible for Lincoln Rewards */
  eligibleToShowLincolnPopOver?: Maybe<Scalars['Boolean']['output']>
  /** Account is eligible for loyalty rewards */
  eligibleToShowLoyaltyRewards?: Maybe<Scalars['Boolean']['output']>
  /** Checks any loss messaging are happened */
  eligibleToShowTotalLossMessaging?: Maybe<Scalars['Boolean']['output']>
  /** Account is eligible for flexBuy or not */
  flexBuy?: Maybe<Scalars['Boolean']['output']>
}

export type FcAccountInformation = {
  __typename?: 'FcAccountInformation'
  /** The date on which this schedule was activated */
  activationDate?: Maybe<Scalars['Date']['output']>
  /** The ALFA agreement number */
  agreementNumber: Scalars['String']['output']
  /** Information regarding due date changes. In the future, this will include payment extensions too. */
  extensions: FcExtensionSummary
  /**
   * The financial summary provides high level summary information on the current position of the contract.
   * This includes any details of partial termination which may have been performed on the contract.
   */
  financialSummary?: Maybe<FcFinancialSummary>
  /** Information regarding payments for the account */
  payments: FcPaymentSummary
  /** Product code of the schedule */
  productCode?: Maybe<Scalars['String']['output']>
  /** Human-readable representation of the product code */
  productCodeDescription?: Maybe<Scalars['String']['output']>
  /** The ALFA schedule number */
  scheduleNumber: Scalars['Int']['output']
  /** The current position of the schedule in the lifecycle of a finance contract */
  scheduleStatus?: Maybe<FcScheduleStatus>
  /** The date on which the schedule started or will start */
  startDate?: Maybe<Scalars['Date']['output']>
  /** The number of months for which the contract is active. Alfa computes the schedule term based on the start date and maturity dates. */
  term?: Maybe<Scalars['Int']['output']>
}

/** Waivers for the account. */
export type FcAcountWaivers = {
  __typename?: 'FcAcountWaivers'
  /** Disposal fee waiver for the account. */
  disposalFeeWaiver?: Maybe<Scalars['Float']['output']>
  /** EWU waiver for the account. Differs from Ford/Lincoln */
  ewuWaiver?: Maybe<Scalars['Float']['output']>
  /** Wear care coverage amount for the account. Differs from Ford/Lincoln */
  wearCareCoverageAmount?: Maybe<Scalars['Float']['output']>
}

/** An address, populated from ALFA */
export type FcAddress = Address & {
  __typename?: 'FcAddress'
  /** The first line of the billing address. */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The second line of the billing address. */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** The city name in the billing address. */
  city?: Maybe<Scalars['String']['output']>
  /** The country name in the billing address. */
  country?: Maybe<Scalars['String']['output']>
  /** The state in the billing address. */
  state?: Maybe<Scalars['String']['output']>
  /** The ZIP code in the billing address. */
  zip?: Maybe<Scalars['String']['output']>
}

export type FcBankAccount = {
  __typename?: 'FcBankAccount'
  /** The last 4 digits of the bank account number */
  accountNumberLast4?: Maybe<Scalars['String']['output']>
  /** The type of bank account */
  accountType?: Maybe<FcBankAccountType>
  /** The country code of the bank account */
  countryCode?: Maybe<Scalars['String']['output']>
  /** Indicates whether this is the customer's default bank */
  isDefault: Scalars['Boolean']['output']
  /** The user-entered name of the bank account */
  nickname?: Maybe<Scalars['String']['output']>
  /** Identifies the bank account details within the customer information. */
  sequenceNumber?: Maybe<Scalars['Int']['output']>
}

/** Represents the type of bank account */
export enum FcBankAccountType {
  CommercialChecking = 'COMMERCIAL_CHECKING',
  CommercialSavings = 'COMMERCIAL_SAVINGS',
  ConsumerChecking = 'CONSUMER_CHECKING',
  ConsumerSavings = 'CONSUMER_SAVINGS',
  Current = 'CURRENT',
  Saving = 'SAVING',
  Transmission = 'TRANSMISSION',
}

/** Specific details about errors */
export type FcBankErrorDetails = {
  __typename?: 'FcBankErrorDetails'
  /** Receivable Account Number */
  accountNumber?: Maybe<Scalars['fmcc__account__AccountNumber']['output']>
  /** Flag that indicates whether the account is AutoPay-enrolled. */
  isAutoPayEnrolled?: Maybe<Scalars['Boolean']['output']>
  /** Flag that indicates whether the account has a scheduled multiple payment. */
  isMultiPayScheduled?: Maybe<Scalars['Boolean']['output']>
  /** Flag that indicates whether the account has a single payment scheduled. */
  isSinglePayScheduled?: Maybe<Scalars['Boolean']['output']>
}

export type FcChangeDueDateInput = {
  agreementNumber: Scalars['String']['input']
  /** If not entered, the next due date will be used */
  currentDueDate?: InputMaybe<Scalars['Date']['input']>
  newBillingDay: Scalars['Int']['input']
  scheduleNumber: Scalars['Int']['input']
}

export type FcChangeDueDateResponse = {
  __typename?: 'FcChangeDueDateResponse'
  code?: Maybe<Scalars['Int']['output']>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/**
 * Represents migration statuses for a FinSimple customer.
 * - **Eligible:** The customer is eligible to migrate from AM to FordPro, but has not taken any action yet.  They may or may not have logged into AM and seen the Migration message.
 * - **New:** The customer is eligible to migrate, they saw the pop up in AM explaining to them the migration process and have interacted with the pop up to trigger the next step.  There is a button on the pop up that, when clicked, will send the user a request to reset the password to their newly created FordPro account and to login to FordPro.
 * - **Password:** The customer has received the password reset email, have reset their password in FordPro and have successfully logged into FordPro for the first time.
 * - **Complete:** The customer has completed the FinSimple account linking process, they have linked their Ford Credit account with their FordPro account and have completed the migration.
 */
export enum FcCommercialCustomerMigrationStatus {
  /** complete */
  Complete = 'COMPLETE',
  /** eligible */
  Eligible = 'ELIGIBLE',
  /** new */
  New = 'NEW',
  /** password */
  Password = 'PASSWORD',
}

/** Commercial customer migration status result */
export type FcCommercialMigrationStatus = {
  __typename?: 'FcCommercialMigrationStatus'
  /** Commercial customer migration start timestamp */
  startedTimestamp?: Maybe<Scalars['DateTime']['output']>
  /** Commercial customer migration status */
  status?: Maybe<FcCommercialCustomerMigrationStatus>
}

/** Commercial customer notifications */
export type FcCommercialNotification = {
  __typename?: 'FcCommercialNotification'
  /** Associated icon for the commercial notifications */
  associatedIcon?: Maybe<Scalars['String']['output']>
  /** Description for the commercial notifications */
  description?: Maybe<Scalars['String']['output']>
  /** specifies the experience's platform (e.g. NGAM, GUX, FPG, ALL) */
  environment?: Maybe<Scalars['String']['output']>
  /** Id for the commercial notifications */
  id?: Maybe<Scalars['Int']['output']>
  /** Link for the commercial notifications */
  link?: Maybe<Scalars['String']['output']>
  /** Notification name for the commercial notifications */
  notificationName?: Maybe<Scalars['String']['output']>
  /** Priority for the commercial notifications */
  priority?: Maybe<Scalars['Int']['output']>
  /** Title for the commercial notifications */
  title?: Maybe<Scalars['String']['output']>
}

/**
 * Input for commercial registration.
 *
 * - If `accountNumber` is not provided, then `vinLast8` is required.
 * - If `accountNumber` is provided, then `vinLast8` is optional.
 */
export type FcCommercialRegistrationInput = {
  /** Receivable account number */
  accountNumber?: InputMaybe<Scalars['fmcc__account__AccountNumber']['input']>
  /** Country code */
  countryCode: Country
  /** The business's tax ID */
  taxId: Scalars['String']['input']
  /**
   * Last eight digits of the Vin.
   *
   * This field is only required if `accountNumber` is not present.
   */
  vinLast8?: InputMaybe<Scalars['String']['input']>
}

/** Common response for mutations */
export type FcCommonMutationResponse = {
  __typename?: 'FcCommonMutationResponse'
  /** The HTTP status code of the domain's response. */
  code: Scalars['Int']['output']
  /** The status message for the mutation indicating whether it was successful or what type of error occurred. */
  message: Scalars['String']['output']
  /** Indicates whether the mutation was successful. */
  success: Scalars['Boolean']['output']
}

/** Input to request creation of payment extension docuSign documents */
export type FcCreateDocuSignInput = {
  /** Account number to create and get docu sign */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Represents whether a customer is the primary buyer or a co-buyer. */
  applicantCode: ApplicantCode
  /** Company business code */
  companyBusinessCode: Scalars['Int']['input']
  /**
   * Represents to who created the request
   * @deprecated Use `requestUserID` instead.
   */
  createdBy?: InputMaybe<Scalars['String']['input']>
  /** Customer reasons for extension */
  extensionReason: Scalars['String']['input']
  /** Signifies whether the extension is a payment extension or due date change. */
  extensionTransactionType: FcExtensionType
  /**
   * Months Extended
   *
   * This field is required for Payment Extension. (If extensionTransactionType=PEX)
   */
  monthsExtended?: InputMaybe<Scalars['Int']['input']>
  /**
   * New Next Due Date
   *
   * This field is required for Due Date Change. (If extensionTransactionType=DDC)
   */
  newNextDueDate?: InputMaybe<Scalars['Date']['input']>
  /** Redirection Url after Signature */
  redirectionUrl: Scalars['String']['input']
  /** The CDSID of the user making the request, or the name of the application */
  requestUserID?: InputMaybe<Scalars['String']['input']>
  /**
   * System Name
   * @deprecated This field is no longer used. Graph will pass the value from experience-id header to the domains
   */
  systemName?: InputMaybe<Scalars['String']['input']>
}

/** Response for the CreateDocuSign mutation */
export type FcCreateDocuSignMutationResponse = {
  __typename?: 'FcCreateDocuSignMutationResponse'
  /** The HTTP status code for the transaction response */
  code: Scalars['Int']['output']
  /** If the transaction was unsuccessful, this list will be populated with codes signifying what went wrong */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message?: Maybe<Scalars['String']['output']>
  /** Information about the created DocuSign document */
  response?: Maybe<FcCreateDocuSignResponse>
  /** Indicates whether the transaction was successful */
  success: Scalars['Boolean']['output']
}

/** Information about the DocuSign document created by the CreateDocuSign mutation */
export type FcCreateDocuSignResponse = {
  __typename?: 'FcCreateDocuSignResponse'
  /** Case id */
  caseId?: Maybe<Scalars['String']['output']>
  /** Document link for buyer or co-buyer */
  docuSignLink?: Maybe<Scalars['String']['output']>
  /** Unique id for document */
  envelopeId?: Maybe<Scalars['String']['output']>
  /** Document request id */
  requestId?: Maybe<Scalars['String']['output']>
}

/** Currency codes, as per the ISO 4217 standard */
export enum FcCurrencyCode {
  /** Canadian Dollar */
  Cad = 'CAD',
  /** US Dollar */
  Usd = 'USD',
}

export enum FcCustomerClassification {
  /** CORPORATION */
  Corporation = 'CORPORATION',
  /** DEALERSHIP */
  Dealership = 'DEALERSHIP',
  /** INDIVIDUAL */
  Individual = 'INDIVIDUAL',
  /** SOLETRADER */
  Soletrader = 'SOLETRADER',
}

/** Commercial line of credit (CLOC) values for given customer. */
export type FcCustomerCloc = {
  __typename?: 'FcCustomerCloc'
  /** CLOC values for given customer */
  clocData?: Maybe<FcCustomerClocData>
  /** Determines what module should be displayed on the front end. */
  clocModuleToShow?: Maybe<Scalars['String']['output']>
}

export type FcCustomerClocData = {
  __typename?: 'FcCustomerClocData'
  /**
   * The percentage of the commercial line of credit (CLOC) being utilized, as a value between 0 and 100.
   *
   * The calculation for this is as follows: (`totalOutstandingBalance` ÷ `creditLine`) ⨉ 100.
   */
  clocUtilization?: Maybe<Scalars['Float']['output']>
  /** The credit line which is available now. */
  creditLine?: Maybe<Scalars['Int']['output']>
  /**
   * The actual remaining amount of credit.
   *
   * The calculation for this is as follows: `creditLine` - `totalOutstandingBalance`.
   */
  lineAmount?: Maybe<Scalars['Float']['output']>
  /** Whether or not the customer is eligible to request an increase to their CLOC amount */
  requestIncreaseEligibility?: Maybe<Scalars['Boolean']['output']>
  /** The sum of outstanding balance amounts for all accounts under a given Master Customer Number (MCN). */
  totalOutstandingBalance?: Maybe<Scalars['Float']['output']>
}

export type FcCustomerInformation = {
  __typename?: 'FcCustomerInformation'
  /** List of accounts on this customer (In alfa, each account is an agreement/schedule) */
  accounts?: Maybe<Array<FcAccountInformation>>
  /** The list of bank accounts for this customer */
  bankAccounts?: Maybe<Array<FcBankAccount>>
  /** The customer's billing address */
  billingAddress?: Maybe<FcAddress>
  /** The ALFA billing address number */
  billingAddressNumber: Scalars['Int']['output']
  /** The type of third party */
  customerClassification?: Maybe<FcCustomerClassification>
  /** Basic personal information (name and date of birth) */
  customerProfile?: Maybe<FcCustomerProfile>
  /** The list of the customer's email addresses */
  emails?: Maybe<Array<FcEmail>>
  /** The list of the customer's phone numbers */
  phones?: Maybe<Array<FcPhone>>
  /** The ALFA third party number */
  thirdPartyNumber: Scalars['String']['output']
}

/** Basic personal information fetched from Alfa (name and date of birth) */
export type FcCustomerProfile = {
  __typename?: 'FcCustomerProfile'
  /** The customer's date of birth */
  dateOfBirth?: Maybe<Scalars['Date']['output']>
  /** The customer's display name */
  displayName?: Maybe<Scalars['String']['output']>
  /** The customer's first name */
  firstName?: Maybe<Scalars['String']['output']>
  /** The customer's last name */
  lastName?: Maybe<Scalars['String']['output']>
  /** The customer's middle name */
  middleName?: Maybe<Scalars['String']['output']>
  /** The customer's title (e.g. Mr.) */
  title?: Maybe<Scalars['String']['output']>
}

/** Provides MultiPayment Inquiry DaysPastDueDetails. */
export type FcDaysPastDueDetails = {
  __typename?: 'FcDaysPastDueDetails'
  /** Number of days the account is delinquent, measured from the due date of the oldest payment that was missed */
  daysPastDue?: Maybe<Scalars['Int']['output']>
  /** Last date allowed for scheduling a payment (only applies when days past due is greater than 30)  */
  lastPaymentDateAvailable?: Maybe<Scalars['Date']['output']>
  /** Number of payment dates available for the PREVIOUS_DUE, TOTAL_AMOUNT_DUE, and OTHER payment options */
  numPaymentDatesAvailable?: Maybe<Scalars['Int']['output']>
}

/** This contains information about a dealer. */
export type FcDealer = {
  __typename?: 'FcDealer'
  /** The dealer's address. */
  dealerAddress?: Maybe<FcDealerAddress>
  /** Specifies whether this is the preferred dealer or originating dealer. */
  dealerSource?: Maybe<FcDealerSource>
  /** The dealer's name. */
  name?: Maybe<Scalars['String']['output']>
  /** The parts accessories code for this dealer. */
  partsAccessoriesCode?: Maybe<Scalars['String']['output']>
  /** The dealer's phone number. */
  phoneNumber?: Maybe<Scalars['String']['output']>
}

export type FcDealerAddress = Address & {
  __typename?: 'FcDealerAddress'
  /** The first line of the street address */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The second line of the street address */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** The city name in the address */
  city?: Maybe<Scalars['String']['output']>
  /** The country name in the address */
  country?: Maybe<Scalars['String']['output']>
  /** The state in the address */
  state?: Maybe<Scalars['String']['output']>
  /** The ZIP code in the address */
  zip?: Maybe<Scalars['String']['output']>
}

/** Specifies which dealer is being returned for a vehicle. */
export enum FcDealerSource {
  /** Indicates this is the vehicle's originating dealer. */
  OriginatingDealer = 'ORIGINATING_DEALER',
  /** Indicates this is the vehicle's preferred dealer. */
  PreferredDealer = 'PREFERRED_DEALER',
}

/** Input for deletion of pending payment extension */
export type FcDeletePendingExtensionInput = {
  /** Account number to delete transaction */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Represents whether the customer is a primary buyer or a co-buyer. */
  applicantCode: ApplicantCode
  /** CoBusCode */
  companyBusinessCode: Scalars['Int']['input']
  /** Envelope-Id for the Docusign Document */
  envelopeId: Scalars['String']['input']
  /** Signifies whether the extension is a payment extension or a due date change */
  extensionType: FcExtensionType
  /**
   * System Name
   * @deprecated This field is no longer used. Graph will pass the value from experience-id header to the domains
   */
  systemName?: InputMaybe<Scalars['String']['input']>
}

/** Return delete pending extension response */
export type FcDeletePendingExtensionResponse = {
  __typename?: 'FcDeletePendingExtensionResponse'
  /** The HTTP status code for the delete transaction response */
  code: Scalars['Int']['output']
  /** If the transaction was unsuccessful, this list will be populated with codes signifying what went wrong */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the delete transaction was successful */
  success: Scalars['Boolean']['output']
}

/** Information regarding an account's eligibility for due date changes */
export type FcDueDateChangeEligibility = {
  __typename?: 'FcDueDateChangeEligibility'
  /** The available dates which the due date can be changed to */
  eligibleDueDates?: Maybe<Array<Scalars['Date']['output']>>
  /**
   * Provides details for why an account is considered ineligible for due date changes.
   *
   * This field will only be populated if `isEligible` is `false`.
   */
  failedRules?: Maybe<Array<FcFailedRule>>
  /** Indicates whether the account is eligible for due date changes */
  isEligible?: Maybe<Scalars['Boolean']['output']>
  /** Indicates whether the applicant needs to provide a signature to make a due date change */
  isSignatureRequired?: Maybe<Scalars['Boolean']['output']>
  /** The payment amount after the due date change */
  postProcessPaymentAmount?: Maybe<Scalars['Float']['output']>
}

/** Info regarding due date change eligibility (Alfa) */
export type FcDueDateChangeEligibilityInfo = {
  __typename?: 'FcDueDateChangeEligibilityInfo'
  /** The dates on which the account is eligible for a due date change */
  eligibleDates?: Maybe<Array<Scalars['Date']['output']>>
  /** Indicates whether the account is eligible for a due date change */
  isEligible?: Maybe<Scalars['Boolean']['output']>
}

/** An ALFA contact method that is an email */
export type FcEmail = {
  __typename?: 'FcEmail'
  /** The email address */
  emailAddress?: Maybe<Scalars['String']['output']>
  /** Indicates whether this is the customer's primary email address */
  isPrimary: Scalars['Boolean']['output']
  /** The type of the email */
  type: FcEmailType
}

export enum FcEmailType {
  /** EML */
  PersonalEmail = 'PERSONAL_EMAIL',
  /** EMW */
  WorkEmail = 'WORK_EMAIL',
}

/** Information regarding payment extensions, and due date changes */
export type FcExtensionInformation = {
  __typename?: 'FcExtensionInformation'
  /** Information regarding this account's eligibility for due date changes */
  dueDateChangeEligibility?: Maybe<FcDueDateChangeEligibility>
  /**
   * Information regarding the current extension
   *
   * An "extension" is a payment extension or a due date change.
   */
  extensionStatus?: Maybe<FcExtensionStatus>
  /** Information regarding this account's eligibility for payment extensions */
  paymentExtensionEligibility: FcPaymentExtensionEligibility
}

/** Information regarding payment extensions, and due date changes */
export type FcExtensionInformationExtensionStatusArgs = {
  applicantCode: ApplicantCode
}

/** Information about a potential payment extension */
export type FcExtensionPayment = {
  __typename?: 'FcExtensionPayment'
  /** The remaining payment due amount for an account */
  duePaymentsRemaining?: Maybe<Scalars['Float']['output']>
  /** Amount of Late Charges that could be waived by an agent, whole or partial amount */
  extensionEligibleLateChargeWaiverAmount?: Maybe<Scalars['Float']['output']>
  /** The calculated fee for an extension */
  extensionFeeAmount?: Maybe<Scalars['Float']['output']>
  /** The final payment amount if this extension is applied */
  extensionFinalPaymentAmount?: Maybe<Scalars['Float']['output']>
  /** The revised annual percentage Rate used for Canadian accounts only */
  extensionRevisedApr?: Maybe<Scalars['Float']['output']>
  /** Revised cost for extension used for Canadian accounts only */
  extensionRevisedCost?: Maybe<Scalars['Float']['output']>
  /** Revised term for extension used for Canadian accounts only */
  extensionRevisedTerm?: Maybe<Scalars['Int']['output']>
  /** Number of days for revised term for an extension used for Canadian accounts only  */
  extensionRevisedTermDays?: Maybe<Scalars['Int']['output']>
  /** Extension revised total payments used for Canadian accounts only */
  extensionRevisedTotalPayments?: Maybe<Scalars['Float']['output']>
  /** Goods and Services Tax for the extension fee used for Canadian accounts only */
  iaExtensionFeeGstAmount?: Maybe<Scalars['Float']['output']>
  /** Provincial Sales Tax for the extension fee used for Canadian accounts only */
  iaExtensionFeePstAmount?: Maybe<Scalars['Float']['output']>
  /** Indicates whether the applicant needs to provide a signature to make a payment extension */
  isSignatureRequired?: Maybe<Scalars['Boolean']['output']>
  /**
   * The due date of the next payment before the extension is applied
   * @deprecated Use `pastDueDate` instead
   */
  nextPaymentDueDate?: Maybe<Scalars['Date']['output']>
  /** The number of payment terms (months) extended */
  paymentsExtended?: Maybe<Scalars['Int']['output']>
  /** The new, extended payment due date */
  postExtensionDueDate?: Maybe<Scalars['Date']['output']>
  /** The final payment date if this extension is applied */
  postExtensionFinalPaymentDueDate?: Maybe<Scalars['Date']['output']>
}

/**
 * Information regarding extension details
 *
 * An "extension" is a payment extension or a due date change.
 */
export type FcExtensionStatus = {
  __typename?: 'FcExtensionStatus'
  /** Link for docusign form */
  docusignFormLink?: Maybe<Scalars['String']['output']>
  /** Unique id for the DocuSign envelope */
  envelopeId?: Maybe<Scalars['String']['output']>
  /** If the extension is not signed by this date, it will be canceled */
  expirationDate?: Maybe<Scalars['Date']['output']>
  /** The fee for the extension */
  extensionFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Indicates whether the primary signer has signed */
  hasPrimarySigned?: Maybe<Scalars['Boolean']['output']>
  /** Indicates whether the secondary signer has signed */
  hasSecondarySigned?: Maybe<Scalars['Boolean']['output']>
  /** Due amount for next payment */
  nextDueAmount?: Maybe<Scalars['Float']['output']>
  /**
   * The new due date after the due date change is applied.
   *
   * This field will only be populated for due date changes (`processType` = `DDC`)
   */
  nextNewDueDate?: Maybe<Scalars['Date']['output']>
  /**
   * Due date of the next payment before the extension is applied
   * @deprecated Use `pastDueDate` instead
   */
  nextPaymentDueDate?: Maybe<Scalars['Date']['output']>
  /**
   * Number of payments (months) that the payment is extended
   *
   * This field will only be populated for payment extensions (`processType` = `PEX`)
   */
  numberOfPayments?: Maybe<Scalars['Int']['output']>
  /**
   * Reason for payment extension
   *
   * This field will only be populated for payment extensions (`processType` = `PEX`)
   */
  paymentExtensionReason?: Maybe<Scalars['String']['output']>
  /** Signifies whether the extension is a payment extension or a due date change */
  processType?: Maybe<FcExtensionType>
}

/**
 * Information regarding extension details
 *
 * An "extension" is a payment extension or a due date change.
 */
export type FcExtensionStatusDocusignFormLinkArgs = {
  redirectUrl?: InputMaybe<Scalars['String']['input']>
}

/** Information regarding due date changes. In the future, this will include payment extensions too. */
export type FcExtensionSummary = {
  __typename?: 'FcExtensionSummary'
  /** Information regarding due date change eligibility */
  dueDateChangeEligibility: FcDueDateChangeEligibilityInfo
}

/** Signifies whether an account extension is a payment extension or a due date change */
export enum FcExtensionType {
  /** Due Date Change */
  Ddc = 'DDC',
  /** Payment Extension */
  Pex = 'PEX',
}

/** Provides details for why an account is considered ineligible for due date changes */
export type FcFailedRule = {
  __typename?: 'FcFailedRule'
  /** Returns the description in case of failure */
  description?: Maybe<Scalars['String']['output']>
  /** Returns the reason of failure */
  name?: Maybe<Scalars['String']['output']>
  /** A flag indicating whether this ineligibility can be overridden. */
  overridableFlag?: Maybe<OverridableFlag>
}

/** This contains vehicle feature information */
export type FcFeature = {
  __typename?: 'FcFeature'
  /** The feature's description */
  description?: Maybe<Scalars['String']['output']>
  /** The feature's id */
  featureId?: Maybe<Scalars['String']['output']>
  /** The feature's name */
  name?: Maybe<Scalars['String']['output']>
}

/** The finance type selected in spc */
export enum FcFinanceType {
  /** Lease */
  Lease = 'LEASE',
  /** Retail */
  Retail = 'RETAIL',
}

/**
 * The financial summary provides high level summary information on the current position of the contract.
 * This includes any details of partial termination which may have been performed on the contract.
 */
export type FcFinancialSummary = {
  __typename?: 'FcFinancialSummary'
  /** A summary of the payments due on the next invoice */
  nextInvoiceDue?: Maybe<FcInvoiceDetails>
  /** A summary of the payments due on the previous invoice */
  previousInvoiceDue?: Maybe<FcInvoiceDetails>
}

/** Provides a vehicle's historical equity value for a specific month. */
export type FcHistoricalEquityRecord = {
  __typename?: 'FcHistoricalEquityRecord'
  /** The contract month */
  contractMonth?: Maybe<Scalars['Int']['output']>
  /** The equity value of the vehicle */
  equityValue?: Maybe<Scalars['Float']['output']>
}

/** Provides a vehicle's historical loan balance value for a specific month. */
export type FcHistoricalLoanBalanceRecord = {
  __typename?: 'FcHistoricalLoanBalanceRecord'
  /** The contract month */
  contractMonth?: Maybe<Scalars['Int']['output']>
  /** The loan balance of the vehicle */
  loanBalance?: Maybe<Scalars['Float']['output']>
}

/** Provides a vehicle's historical trade-in value for a specific month. */
export type FcHistoricalTradeInRecord = {
  __typename?: 'FcHistoricalTradeInRecord'
  /** The contract month */
  contractMonth?: Maybe<Scalars['Int']['output']>
  /** The trade-in value of the vehicle */
  tradeInValue?: Maybe<Scalars['Float']['output']>
}

/** Provides the Customer vehicle equity */
export type FcHistoricalVehicleEquity = {
  __typename?: 'FcHistoricalVehicleEquity'
  /** Equity Amount  */
  equityAmount?: Maybe<Scalars['Float']['output']>
  /** Pay off amount */
  payoffAmount?: Maybe<Scalars['Float']['output']>
  /** The date and time when this equity record was saved */
  timestamp?: Maybe<Scalars['DateTime']['output']>
  /** Trade in value */
  tradeInValue?: Maybe<Scalars['Float']['output']>
}

/** Provides historical vehicle equity response */
export type FcHistoricalVehicleEquityResponse = {
  __typename?: 'FcHistoricalVehicleEquityResponse'
  /** Contains historical vehicle equity values */
  historicalEquityValues?: Maybe<Array<Maybe<FcHistoricalEquityRecord>>>
  /** Contains historical loan balance values */
  historicalLoanBalanceValues?: Maybe<Array<Maybe<FcHistoricalLoanBalanceRecord>>>
  /** Contains historical trade in values */
  historicalTradeInValues?: Maybe<Array<Maybe<FcHistoricalTradeInRecord>>>
  /** True if the data returned in this object is simulated, and false if it is real */
  isDataSimulated?: Maybe<Scalars['Boolean']['output']>
}

/** Holds summary information about a collection of payments that all fall on the same date. */
export type FcInvoiceDetails = {
  __typename?: 'FcInvoiceDetails'
  /** The due date for the payments due on this date. */
  dueDate?: Maybe<Scalars['Date']['output']>
  /** The payment line gross total amount */
  grossTotal?: Maybe<FcMoney>
}

/** Loyalty points from Ford Pass Rewards/Lincoln Rewards */
export type FcLoyaltyPointsData = {
  __typename?: 'FcLoyaltyPointsData'
  /** The customer's loyalty points balance converted to a dollar amount */
  convertedAmount?: Maybe<Scalars['Int']['output']>
  /** The customer's loyalty points balance */
  pointsBalance?: Maybe<Scalars['Int']['output']>
}

/** Request body of MNV api for log interaction */
export type FcMnvInteractionInput = {
  /** The customer's receivable account number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** The customer's applicant code */
  applicantCode: ApplicantCode
  /** The interaction value */
  interactionTarget: Scalars['String']['input']
  /** Additional details on the interaction */
  interactionText?: InputMaybe<Scalars['String']['input']>
  /** The unique ID of the recommended vehicle */
  mnvMessageId: Scalars['Int']['input']
}

/** Return mnv api log interaction response */
export type FcMnvInteractionResponse = {
  __typename?: 'FcMnvInteractionResponse'
  /** The HTTP status code for the log interaction */
  code: Scalars['Int']['output']
  /** If the log interaction was unsuccessful, this list will be populated with message signifying what went wrong */
  errorCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message: Scalars['String']['output']
  /** Indicates whether the log interaction was successful */
  success: Scalars['Boolean']['output']
}

/** A My Next Vehicle (MNV) offer */
export type FcMnvOffer = {
  __typename?: 'FcMnvOffer'
  /** MNV flags indicating certain features are enabled or disabled for the account */
  accountFlags?: Maybe<FcAccountFlags>
  /** Waivers for the account. */
  accountWaivers?: Maybe<FcAcountWaivers>
  /** Information on the recommended vehicle */
  currentVehicleToken?: Maybe<FcVehicleToken>
  /** The customer's segment to show the appropriate offer for the customer. */
  customerSegment?: Maybe<CustomerSegment>
  /** The dealer pa code in which the recommended vehicles are from */
  dealerPaCode?: Maybe<Scalars['String']['output']>
  /** The equity that the customer has in the current vehicle */
  equity?: Maybe<Scalars['Int']['output']>
  /**
   * List of timestamped equity records for a customer vehicle
   * @deprecated Use fmcc__account__Account.historicalVehicleEquity
   */
  historicalVehicleEquity?: Maybe<Array<Maybe<FcHistoricalVehicleEquity>>>
  /** Loyalty points from Ford Pass Rewards / Lincoln Rewards */
  loyaltyPointsData?: Maybe<FcLoyaltyPointsData>
  /** Internal mnv account id */
  mnvAccountId?: Maybe<Scalars['Int']['output']>
  /** The customer's private offer incentive */
  privateOffer?: Maybe<FcPrivateOffer>
  /** Provides the list of recommended token details */
  recommendedVehicleTokenList?: Maybe<Array<Maybe<FcRecommendedVehicleToken>>>
  /** The saved Simple Payment Calculator(SPC) attributes */
  spcAttributes?: Maybe<FcSpcAttributes>
}

/** Represents a financial amount with a corresponding currency */
export type FcMoney = {
  __typename?: 'FcMoney'
  amount: Scalars['Float']['output']
  /** The currency code of the financial amount corresponding to the ISO 4217 format. */
  currencyCode: FcCurrencyCode
}

/** A marketing offer */
export type FcOffer = FcMnvOffer | FcPreEligibilityOffer | FcSalesForceOffer

/** Request body Offer data request of MNV api */
export type FcOfferDataRequest = {
  /** Represents whether a customer is the primary buyer or a co-buyer. */
  applicantCode: ApplicantCode
  /** Required dealer code */
  dealerPaCode?: InputMaybe<Scalars['Int']['input']>
  /** Indicator for mobile or desktop */
  isMobile?: InputMaybe<Scalars['Boolean']['input']>
  /** Vehicle of Interest data grabbed from FPS cookies */
  voiToken?: InputMaybe<FcVoiToken>
}

/** Information on the payment for the recommended vehicle */
export type FcPaymentDetails = {
  __typename?: 'FcPaymentDetails'
  /** The destination charges for the vehicle */
  destinationCharges?: Maybe<Scalars['Float']['output']>
  /**
   * The miles or kilometers per annum.
   * This value will be in miles for a US customer, or kilometers for a Canadian customer.
   */
  financePlan?: Maybe<FcFinanceType>
  /** The miles or kilometers per annum */
  milesOrKmPerAnnum?: Maybe<Scalars['Int']['output']>
  /** The MSRP of the vehicle */
  msrp?: Maybe<Scalars['Float']['output']>
  /** The options fee for the vehicle */
  options?: Maybe<Scalars['Float']['output']>
  /** The selling price of the vehicle */
  sellingPrice?: Maybe<Scalars['Float']['output']>
  /** The payment details of the recommended vehicle */
  termPaymentDetails?: Maybe<FcTermPaymentDetails>
  /** The trade-in vehicle information */
  tradeInVehicle?: Maybe<FcTradeInVehicle>
}

/** Information regarding an account's eligibility for payment extensions */
export type FcPaymentExtensionEligibility = {
  __typename?: 'FcPaymentExtensionEligibility'
  /** The available options for payment extension */
  extensionPayments?: Maybe<Array<FcExtensionPayment>>
  /** Provides details for why an account is considered ineligible for payment extension */
  failedRules?: Maybe<Array<FcFailedRule>>
  /** Indicates whether the account is eligible for payment extension changes */
  isEligible?: Maybe<Scalars['Boolean']['output']>
  /** Indicates whether the applicant needs to provide a signature to make a payment extension change */
  isSignatureRequired?: Maybe<Scalars['Boolean']['output']>
  /** The payment amount of the extended payment */
  postProcessPaymentAmount?: Maybe<Scalars['Float']['output']>
}

/** The payment-related data for an account */
export type FcPaymentSummary = {
  __typename?: 'FcPaymentSummary'
  /** Indicates whether the account is eligible to make a single payment. */
  isEligibleForSinglePayment?: Maybe<Scalars['Boolean']['output']>
}

/** This contains a vehicle's Preferred Equipment Package (PEP) code. */
export type FcPepCode = {
  __typename?: 'FcPepCode'
  /** The vehicle's pepCode's sales code */
  salesCode?: Maybe<Scalars['String']['output']>
}

/** An ALFA contact method that is either a telephone or a mobile phone */
export type FcPhone = {
  __typename?: 'FcPhone'
  /**
   * Indicates whether this is the primary phone.
   *
   * There can be one primary telephone, and one primary mobile phone, so it is possible to have two primary phones.
   */
  isPrimary: Scalars['Boolean']['output']
  /** The phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** The type of the phone */
  type: FcPhoneType
}

export enum FcPhoneType {
  /** TEL */
  HomeLandline = 'HOME_LANDLINE',
  /** MOB */
  PersonalMobile = 'PERSONAL_MOBILE',
  /** WTL */
  WorkLandline = 'WORK_LANDLINE',
  /** WMB */
  WorkMobile = 'WORK_MOBILE',
}

/** Returns pre eligibility Offer details */
export type FcPreEligibilityOffer = {
  __typename?: 'FcPreEligibilityOffer'
  /** Returns account number is black labeled dealer or not */
  blackLabelDealer?: Maybe<Scalars['Boolean']['output']>
  /** The customer's segment to show the appropriate offer for the customer. */
  customerSegment?: Maybe<CustomerSegment>
  /** A question presented to the user as part of pre-eligibility checks. */
  preEligibilityQuestion?: Maybe<FcPreEligibilityQuestion>
  /** Contains pre eligible Vehicle details */
  preEligibilityVehicleTree?: Maybe<FcPreEligibilityVehicleTree>
}

/** A question presented to the user as part of pre-eligibility checks. */
export type FcPreEligibilityQuestion = {
  __typename?: 'FcPreEligibilityQuestion'
  /** Pre-eligibility check question number */
  questionNumber?: Maybe<Scalars['Int']['output']>
  /** Pre-eligibility check question */
  questionText?: Maybe<Scalars['String']['output']>
}

/** Contains pre eligible Vehicle details */
export type FcPreEligibilityVehicleTree = {
  __typename?: 'FcPreEligibilityVehicleTree'
  /** Id of pre eligible Vehicle */
  id?: Maybe<Scalars['String']['output']>
  /** Vehicle Image */
  imageUrl?: Maybe<Scalars['String']['output']>
  /** name of pre eligible vehicle */
  name?: Maybe<Scalars['String']['output']>
  /** nodes of pre eligible vehicle */
  nodes?: Maybe<Array<FcPreEligibilityVehicleTree>>
}

/** Request body of MNV api for getPreferredVehicles */
export type FcPreferredVehiclesInput = {
  /** Represents whether a customer is the primary buyer or a co-buyer. */
  applicantCode: ApplicantCode
  /** The preferred vehicle tokens */
  vehicleOptions: Array<FcVehicleOptionsInput>
}

/** The customer's private offer incentive */
export type FcPrivateOffer = {
  __typename?: 'FcPrivateOffer'
  /** The certificate number */
  certificateNumber?: Maybe<Scalars['String']['output']>
  /** List of the text that the private offer contains */
  disclosureText?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The body text for the private offer */
  overMileageBodyText?: Maybe<Scalars['String']['output']>
  /** The private offer amount */
  privateOfferAmount?: Maybe<Scalars['Int']['output']>
  /** The body text for the private offer */
  privateOfferBodyText?: Maybe<Scalars['String']['output']>
  /** The expiration date of the private offer */
  privateOfferExpirationDate?: Maybe<Scalars['Date']['output']>
  /** The header text for the private offer */
  privateOfferHeaderText?: Maybe<Scalars['String']['output']>
  /** The header text of private offer for PDF */
  privateOfferPDFHeaderText?: Maybe<Scalars['String']['output']>
  /** The vehicle model that the private offer is for(eg: F-150) */
  privateOfferVehicleModel?: Maybe<Scalars['String']['output']>
  /** Incentive program number */
  vincentId?: Maybe<Scalars['String']['output']>
}

/** Ford Credit queries going to Alfa */
export type FcQuery = {
  __typename?: 'FcQuery'
  /** Fetches Alfa account information (Agreement/Schedule) */
  accountInformation?: Maybe<FcAccountInformation>
  /** Fetches the bank accounts for the given third party number and billing address number. */
  bankAccounts?: Maybe<Array<FcBankAccount>>
  /** Customer (third party) information */
  customerInformation?: Maybe<FcCustomerInformation>
  /** Fetches the financial summary for the given Alfa schedule */
  financialSummary?: Maybe<FcFinancialSummary>
}

/** Ford Credit queries going to Alfa */
export type FcQueryAccountInformationArgs = {
  agreementNumber: Scalars['String']['input']
  scheduleNumber: Scalars['Int']['input']
}

/** Ford Credit queries going to Alfa */
export type FcQueryBankAccountsArgs = {
  billingAddressNumber: Scalars['Int']['input']
  thirdPartyNumber: Scalars['String']['input']
}

/** Ford Credit queries going to Alfa */
export type FcQueryCustomerInformationArgs = {
  billingAddressNumber: Scalars['Int']['input']
  thirdPartyNumber: Scalars['String']['input']
}

/** Ford Credit queries going to Alfa */
export type FcQueryFinancialSummaryArgs = {
  agreementNumber: Scalars['String']['input']
  scheduleNumber: Scalars['Int']['input']
}

/** The rate of the finance plan */
export type FcRate = {
  __typename?: 'FcRate'
  /** The APR of the finance plan */
  apr?: Maybe<Scalars['Float']['output']>
  /** The money factor of the finance plan */
  markUp?: Maybe<Scalars['Float']['output']>
  /** The type of the finance plan */
  type?: Maybe<FcRateType>
}

/**  Defines the possible values for rateType */
export enum FcRateType {
  /** Defines 7 % apr when Nasapi rates not available for retail */
  Default = 'DEFAULT',
  /** Defines X5 Parms provided standard rate for lease */
  Standard = 'STANDARD',
  /** Defines Nasapi provided rate */
  Subvened = 'SUBVENED',
}

/** Provides the list of recommended token details */
export type FcRecommendedVehicleToken = {
  __typename?: 'FcRecommendedVehicleToken'
  /** The unique ID of the recommended vehicle */
  mnvMessageId?: Maybe<Scalars['Int']['output']>
  /** Information on the payment for the recommended vehicle */
  paymentDetails?: Maybe<Array<Maybe<FcPaymentDetails>>>
  /** The unique recommendation ID returned from Machine Learning */
  pegaId?: Maybe<Scalars['String']['output']>
  /** The URL to the recommended offer */
  recommendedOfferUrl?: Maybe<Scalars['String']['output']>
  /** Information on the recommended vehicle */
  vehicleToken?: Maybe<FcVehicleToken>
}

/** Retail Canadian account registration request */
export type FcRegisterAccountCanInput = {
  /** Receivable account number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Date of birth */
  dateOfBirth: Scalars['Date']['input']
  /** Last eight digits of the Vin */
  vinLast8?: InputMaybe<Scalars['String']['input']>
}

/** Retail US account registration request */
export type FcRegisterAccountUsaInput = {
  /** Receivable account number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Date of birth */
  dateOfBirth: Scalars['Date']['input']
  /** Last four digits of the SSN */
  lastFourSsn?: InputMaybe<Scalars['String']['input']>
}

/** Retail Canadian registration request */
export type FcRegisterCanInput = {
  /** Date of birth */
  dateOfBirth: Scalars['Date']['input']
  /** Last eight digits of the Vin */
  vinLast8: Scalars['String']['input']
}

/** Retail US registration request */
export type FcRegisterUsaInput = {
  /** Date of birth */
  dateOfBirth: Scalars['Date']['input']
  /** Last four digits of the SSN */
  lastFourSsn: Scalars['String']['input']
}

/** Request CLOC increase input */
export type FcRequestClocIncreaseInput = {
  /** The customer's CLOC request additional units */
  additionalUnits: Scalars['Int']['input']
  /** The customer's CLOC request increase amount */
  dollarAmount: Scalars['Float']['input']
  /** The customer's email address */
  email: Scalars['String']['input']
  /** The customer's first name */
  firstName: Scalars['String']['input']
  /** The customer's CLOC request increase reason */
  increaseReason: Scalars['String']['input']
  /** The customer's last name */
  lastName: Scalars['String']['input']
  /** Master customer number of the customer */
  masterCustomerNumber: Scalars['fc__customer__MCN']['input']
  /** The customer's phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  /** The customer's CLOC request replacement units */
  replacementUnits: Scalars['Int']['input']
}

/**
 * Input for retail registration.
 *
 * `countryCode` and `dateOfBirth` are required. The remaining arguments depend on the country, and
 * whether `accountNumber` is provided.
 *
 * - If `accountNumber` is not provided,
 *   - For `US`, `lastFourSsn` is mandatory,
 *   - For `CA`, `vinLast8` is mandatory.
 * - If `accountNumber` is provided,
 *   - For `US`, `lastFourSsn` is optional,
 *   - For `CA`, `vinLast8` is optional,
 */
export type FcRetailRegistrationInput = {
  /** Receivable account number */
  accountNumber?: InputMaybe<Scalars['fmcc__account__AccountNumber']['input']>
  /** Country code */
  countryCode: Country
  /** The customer's birth date. */
  dateOfBirth: Scalars['Date']['input']
  /**
   * Last four digits of the customer's Social Security Number (SSN).
   *
   * This field should only be given when `countryCode` is `US`. It is only
   * mandatory when `accountNumber` is not present.
   */
  lastFourSsn?: InputMaybe<Scalars['String']['input']>
  /**
   * Last eight digits of the Vin
   *
   * This field should only be given when `countryCode` is `CA`. It is only
   * mandatory when `accountNumber` is not present.
   */
  vinLast8?: InputMaybe<Scalars['String']['input']>
}

/** Contains InsureOffer data */
export type FcSalesForceOffer = {
  __typename?: 'FcSalesForceOffer'
  /**
   * Insure Offer body
   * @deprecated This will be removed by 2024-09-18
   */
  body?: Maybe<Scalars['String']['output']>
  /**
   * Insure offer brand
   * @deprecated This will be removed by 2024-09-18
   */
  brand?: Maybe<Scalars['String']['output']>
  /**
   * Whether eligible or not
   * @deprecated This will be removed by 2024-09-18
   */
  eligible?: Maybe<Scalars['Boolean']['output']>
  /**
   * The unique ID of the recommended vehicle
   * @deprecated This will be removed by 2024-09-18
   */
  mnvMessageId?: Maybe<Scalars['Int']['output']>
  /**
   * Offer name
   * @deprecated This will be removed by 2024-09-18
   */
  offerName?: Maybe<Scalars['String']['output']>
  /**
   * Script of Insure Offer
   * @deprecated This will be removed by 2024-09-18
   */
  script?: Maybe<Scalars['String']['output']>
  /**
   * Style
   * @deprecated This will be removed by 2024-09-18
   */
  style?: Maybe<Scalars['String']['output']>
}

export type FcScheduleSinglePaymentInput = {
  /** The Alfa agreement number for the schedule. */
  agreementNumber: Scalars['String']['input']
  /** The numerical value of this financial amount. */
  amount: Scalars['Float']['input']
  /** The sequence number of the bank account. This field corresponds to `FcBankAccount.sequenceNumber`. */
  bankAccountSequenceNumber: Scalars['Int']['input']
  /** The Alfa billing address number for the customer. */
  billingAddressNumber: Scalars['Int']['input']
  /** The currency code of the financial amount corresponding to the ISO 4217 format. */
  currency: FcCurrencyCode
  /** The date on which the payment is to be scheduled. */
  paymentDate: Scalars['Date']['input']
  /** The Alfa schedule number for the schedule. */
  scheduleNumber: Scalars['Int']['input']
  /** The Alfa third party number for the customer. */
  thirdPartyNumber: Scalars['String']['input']
}

export type FcScheduleSinglePaymentResponse = {
  __typename?: 'FcScheduleSinglePaymentResponse'
  code?: Maybe<Scalars['Int']['output']>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export enum FcScheduleStatus {
  Live = 'LIVE',
  Matured = 'MATURED',
  Terminated = 'TERMINATED',
}

/** The saved Simple Payment Calculator(SPC) attributes */
export type FcSpcAttributes = {
  __typename?: 'FcSpcAttributes'
  /** The annual miles entered in spc */
  annualMiles?: Maybe<Scalars['Int']['output']>
  /** The Annual percentage rate(apr) entered in spc */
  apr?: Maybe<Scalars['Float']['output']>
  /** The down payment amount entered in spc */
  downPayment?: Maybe<Scalars['Float']['output']>
  /** The finance type selected in spc */
  financeType: FcFinanceType
  /** The unique ID of the recommended vehicle */
  mnvMessageId: Scalars['Int']['output']
  /** The payment amount entered in spc */
  payment: Scalars['Float']['output']
  /** The signing amount entered in spc */
  signingAmount?: Maybe<Scalars['Float']['output']>
  /** The term selected in spc */
  term?: Maybe<Scalars['Int']['output']>
  /** The trade in amount entered in spc */
  tradeIn?: Maybe<Scalars['Float']['output']>
}

/** Input to process an extension */
export type FcSubmitExtensionInput = {
  /** Account number to create and get Process Payments */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Represents whether the customer is primary buyer or a co-buyer. */
  applicantCode: ApplicantCode
  /** Branch Code */
  enteredBranchCode: Scalars['String']['input']
  /** Unique id for document */
  envelopeId: Scalars['String']['input']
  /**
   * System Name
   * @deprecated This field is no longer used. Graph will pass the value from experience-id header to the domains
   */
  systemName?: InputMaybe<Scalars['String']['input']>
}

/** Return status for process extension */
export type FcSubmitExtensionResponse = {
  __typename?: 'FcSubmitExtensionResponse'
  /** The HTTP status code of the underlying call */
  code: Scalars['Int']['output']
  /** Permanent storage content id */
  contentId?: Maybe<Scalars['String']['output']>
  /** Permanent storage content location */
  contentLocation?: Maybe<Scalars['String']['output']>
  /** If the transaction was unsuccessful, this list will be populated with codes signifying what went wrong */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /**
   * Indicates whether the submission could be processed. This value depends on the status of the
   * signed document. It will only be true if `signatureStatus = COMPLETED`.
   */
  processed?: Maybe<Scalars['Boolean']['output']>
  /**
   * The signature status of the DocuSign document. Every value other than `COMPLETED` indicates
   * that the submission could not be processed because of pending required signatures.
   */
  signatureStatus?: Maybe<ExtensionSignatureStatus>
  /**
   * Indicates whether the underlying HTTP call was successful. Note that a success does not guarantee that
   * the submission was processed in the back-end. For that, check the `processed` field.
   */
  success: Scalars['Boolean']['output']
}

/** The payment details of the recommended vehicle */
export type FcTermPaymentDetails = {
  __typename?: 'FcTermPaymentDetails'
  /** The acquisition fee */
  acquisitionFee?: Maybe<Scalars['Float']['output']>
  /** The adjusted capital cost */
  adjustedCapitalCost?: Maybe<Scalars['Float']['output']>
  /** The amount financed */
  amountFinanced?: Maybe<Scalars['Float']['output']>
  /** The total of monthly payments */
  baseMonthlyPayment?: Maybe<Scalars['Float']['output']>
  /** The cash due at signing */
  cashDueAtSigning?: Maybe<Scalars['Float']['output']>
  /** The cash price */
  cashPrice?: Maybe<Scalars['Float']['output']>
  /** The total amount due at signing */
  deposit?: Maybe<Scalars['Float']['output']>
  /** The total of monthly payments */
  dispositionFee?: Maybe<Scalars['Int']['output']>
  /** The estimated adjusted cap cost */
  estimatedAdjustedCapCost?: Maybe<Scalars['Float']['output']>
  /** The estimated cap cost reduction */
  estimatedCapCostReduction?: Maybe<Scalars['Float']['output']>
  /** The estimated gross cap cost */
  estimatedGrossCapCost?: Maybe<Scalars['Float']['output']>
  /** The total of monthly payments */
  estimatedMonthlyVehiclePayment?: Maybe<Scalars['Float']['output']>
  /** Informational message */
  infoMessage?: Maybe<Scalars['String']['output']>
  /** The monthly payment */
  monthlyPayment?: Maybe<Scalars['Float']['output']>
  /** The rate of the finance plan */
  rate?: Maybe<FcRate>
  /** The residual amount */
  residualAmount?: Maybe<Scalars['Float']['output']>
  /** The residual percentage */
  residualPercentage?: Maybe<Scalars['Float']['output']>
  /** The term of the finance plan */
  term?: Maybe<Scalars['Int']['output']>
  /** The total amount due at signing */
  totalAmountDueAtSigning?: Maybe<Scalars['Float']['output']>
  /** The total incentives amount */
  totalIncentivesAmount?: Maybe<Scalars['Float']['output']>
  /** The total of payments */
  totalOfPayments?: Maybe<Scalars['Float']['output']>
}

/** The trade-in vehicle information */
export type FcTradeInVehicle = {
  __typename?: 'FcTradeInVehicle'
  /** Allowance for trade */
  tradeAllowance?: Maybe<Scalars['Float']['output']>
  /** Payoff for trade */
  tradePayoff?: Maybe<Scalars['Float']['output']>
}

/** This contains vehicle trim details */
export type FcTrim = {
  __typename?: 'FcTrim'
  /** The vehicle's trim ID */
  id?: Maybe<Scalars['String']['output']>
  /** The vehicle's trim name */
  name?: Maybe<Scalars['String']['output']>
}

/** Update commercial migration status input */
export type FcUpdateCommercialMigrationStatusInput = {
  /** Commercial customer migration status */
  status?: InputMaybe<FcCommercialCustomerMigrationStatus>
}

/** Information about a vehicle color. */
export type FcVehicleColor = {
  __typename?: 'FcVehicleColor'
  /** The vehicle's color description */
  description?: Maybe<Scalars['String']['output']>
  /** The vehicle's color hex code */
  hexCode?: Maybe<Scalars['String']['output']>
  /** The vehicle's color sales code */
  salesCode?: Maybe<Scalars['String']['output']>
}

/** This contains vehicle feature information */
export type FcVehicleFeatureInformation = {
  __typename?: 'FcVehicleFeatureInformation'
  /** The vehicle's city fuel economy in miles per gallon (MPG). */
  cityMileage?: Maybe<Scalars['Float']['output']>
  /** Vehicle drive description (e.g. All-Wheel Drive (AWD)) */
  driveDescription?: Maybe<Scalars['String']['output']>
  /** Vehicle engine description (e.g. 3.7L 4V PFI V6 NA Gas) */
  engineDescription?: Maybe<Scalars['String']['output']>
  /** The vehicle's exterior color */
  exteriorColor?: Maybe<FcVehicleColor>
  /** The vehicle's features */
  features?: Maybe<Array<Maybe<FcFeature>>>
  /** The vehicle's highway fuel economy in miles per gallon (MPG). */
  highwayMileage?: Maybe<Scalars['Float']['output']>
  /** The vehicle's image token */
  imageToken?: Maybe<Scalars['String']['output']>
  /** The vehicle's interior color */
  interiorColor?: Maybe<FcVehicleColor>
  /** The localized make of the vehicle (e.g. Ford) */
  make?: Maybe<Scalars['String']['output']>
  /** The localized model of the vehicle (e.g. Mustang) */
  model?: Maybe<Scalars['String']['output']>
  /** The vehicle's Preferred Equipment Package (PEP) code. */
  pepCode?: Maybe<FcPepCode>
  /** The vehicle's segment */
  segment?: Maybe<Scalars['String']['output']>
  /** Vehicle transmission description (e.g. 6 Speed Manual Transmission-MT82) */
  transmissionDescription?: Maybe<Scalars['String']['output']>
  /** The vehicle's trim details */
  trim?: Maybe<FcTrim>
  /** The associated VIN for this vehicle feature information. */
  vin: Scalars['VIN']['output']
  /** The URL to window sticker information for the vehicle. */
  windowStickerURL?: Maybe<Scalars['String']['output']>
  /** The model year of the vehicle (e.g. 2020) */
  year?: Maybe<Scalars['Int']['output']>
}

/** The preferred vehicle tokens */
export type FcVehicleOptionsInput = {
  /** Required dealer code */
  dealerPaCode?: InputMaybe<Scalars['String']['input']>
  /** The make of the vehicle */
  make: Scalars['String']['input']
  /** The model of the vehicle */
  model: Scalars['String']['input']
  /** The vehicle's trim ID */
  trimId: Scalars['String']['input']
  /** The vehicle's trim name */
  trimName: Scalars['String']['input']
  /** The year of the vehicle */
  year: Scalars['String']['input']
  /** The zip code of the vehicle */
  zipCode?: InputMaybe<Scalars['String']['input']>
}

/** Returns Preferred Vehicle Selection Offer */
export type FcVehicleSelectionOffer = {
  __typename?: 'FcVehicleSelectionOffer'
  /** Checks whether same trim or different trim for preferred vehicle */
  differentTrimForPreferredVehicle?: Maybe<Scalars['Boolean']['output']>
  /** The URL to the recommended offer */
  recommendedOfferUrl?: Maybe<Scalars['String']['output']>
  /** Information on the recommended vehicle */
  vehicleToken?: Maybe<FcVehicleToken>
}

/** Information on the recommended vehicle */
export type FcVehicleToken = {
  __typename?: 'FcVehicleToken'
  /** The vehicle's display name */
  displayName?: Maybe<Scalars['String']['output']>
  /** The vehicle's engine type */
  engineType?: Maybe<Scalars['String']['output']>
  /** The vehicle's image token to grab images from DIG */
  imageToken?: Maybe<Scalars['String']['output']>
  /** The localized make of the vehicle (e.g. Ford) */
  make?: Maybe<Scalars['String']['output']>
  /** The localized model of the vehicle (e.g. Mustang) */
  model?: Maybe<Scalars['String']['output']>
  /** The vehicle's trim ID */
  trimID?: Maybe<Scalars['String']['output']>
  /** The vehicle's trim name */
  trimName?: Maybe<Scalars['String']['output']>
  /** The vehicle's type */
  vehicleType?: Maybe<VehicleType>
  /** Contains Vehicle Value and Manufacturer code */
  vin?: Maybe<Scalars['VIN']['output']>
  /** Link to the vehicle's window sticker */
  windowSticker?: Maybe<Scalars['String']['output']>
  /** The model year of the vehicle (e.g. 2020) */
  year?: Maybe<Scalars['String']['output']>
}

/** Vehicle of Interest data grabbed from FPS cookies */
export type FcVoiToken = {
  /** The make of the vehicle */
  make?: InputMaybe<Scalars['String']['input']>
  /** The localized model of the vehicle (e.g. Mustang) */
  model?: InputMaybe<Scalars['String']['input']>
  /** VOI Trim */
  trim?: InputMaybe<Scalars['String']['input']>
  /** Vehicle identification number */
  vin?: InputMaybe<Scalars['VIN']['input']>
  /** The model year of the vehicle (e.g. 2020) */
  year?: InputMaybe<Scalars['String']['input']>
}

/** A set of input parameters needed to add or update a location for a business. */
export type FpiAddOrUpdateLocationInput = {
  /** Holds the first Address Line of the location */
  addressLine1: Scalars['String']['input']
  /** Holds the second Address Line of the location */
  addressLine2?: InputMaybe<Scalars['String']['input']>
  /** The city name in the address. */
  city: Scalars['String']['input']
  /**
   * This field holds the business type code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as NAICS
   */
  naicsCode: Scalars['String']['input']
  /**
   * This field holds the business category code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as SIC code
   */
  sicCode: Scalars['String']['input']
  /** Holds the State Id for the location (e.g : 20 for Illinois) */
  stateId: Scalars['String']['input']
  /** The location's 5 digit zip code used for identifying the postal area */
  zip: Scalars['String']['input']
}

/** Response type for the AddLocation and UpdateLocation mutations. */
export type FpiAddOrUpdateLocationResponse = {
  __typename?: 'FpiAddOrUpdateLocationResponse'
  /** The Origami HTTP status code for the add location response */
  code?: Maybe<Scalars['Int']['output']>
  /** Record ID of location */
  locationId?: Maybe<Scalars['Int']['output']>
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message?: Maybe<Scalars['String']['output']>
  /** Indicated whether the location was added successfully */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** "Payments Information which provides details of paid amount and payment date  */
export type FpiPaymentsInfo = {
  __typename?: 'FpiPaymentsInfo'
  /** Payment amount */
  paidAmount?: Maybe<Scalars['Float']['output']>
  /** Payment date */
  paymentDate?: Maybe<Scalars['DateTime']['output']>
}

/** Represents the Vehicle Coverage information  */
export type FpiVehicleCoverage = {
  __typename?: 'FpiVehicleCoverage'
  /** Coverage limit applicable for the vehicle. */
  coverageLimit?: Maybe<Scalars['BigDecimal']['output']>
  /** Refers to Premium amount for vehicle Coverage */
  coveragePremium?: Maybe<Scalars['BigDecimal']['output']>
  /** Refers to coverage type name. */
  description: Scalars['String']['output']
  /** Vehicle Coverage ID. */
  id: Scalars['Int']['output']
}

/** Represents whether the language code is `EN`, `ES` or `FC`. */
export enum LanguageCode {
  /** Indicates the language code is `EN` (English). */
  En = 'EN',
  /** Indicates the language code is `ES` (Spanish). */
  Es = 'ES',
  /** Indicates the language code is `FC` (French Canadian). */
  Fc = 'FC',
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Changes the due date for an Alfa account */
  fcChangeDueDate: FcChangeDueDateResponse
  /** Creates a DocuSign document for a new request for a payment extension or a due date change */
  fcCreateDocuSign: FcCreateDocuSignMutationResponse
  /** Deletes a pending payment extension or due date change */
  fcDeletePendingExtension: FcDeletePendingExtensionResponse
  /** Log interactions on an MNV offer */
  fcMnvInteraction: FcMnvInteractionResponse
  /**
   * Mutation to create registration for commercial users.
   *
   * - If `accountNumber` is not provided, then `vinLast8` is required.
   * - If `accountNumber` is provided, then `vinLast8` is optional.
   */
  fcRegisterCommercial: FcCommonMutationResponse
  /**
   * Mutation to create registration for retail users.
   *
   * `countryCode` and `dateOfBirth` are required. The remaining arguments depend on the country, and
   * whether `accountNumber` is provided.
   *
   * - If `accountNumber` is not provided,
   *   - For `US`, `lastFourSsn` is mandatory,
   *   - For `CA`, `vinLast8` is mandatory.
   * - If `accountNumber` is provided,
   *   - For `US`, `lastFourSsn` is optional,
   *   - For `CA`, `vinLast8` is optional,
   */
  fcRegisterRetail: FcCommonMutationResponse
  /** Mutation to request CLOC increase for a FinSimple customer */
  fcRequestClocIncrease: FcCommonMutationResponse
  /** Mutation to schedule/claim single payments (Alfa) */
  fcScheduleSinglePayment: FcScheduleSinglePaymentResponse
  /** Submits a payment extension or a due date change */
  fcSubmitExtension: FcSubmitExtensionResponse
  /** Mutation to update migration status for a FinSimple customer */
  fcUpdateCommercialMigrationStatus: FcCommonMutationResponse
  /** Mutation to update notification on account level */
  fc__account__updateNotificationPreferences: Fc__Account__UpdateNotificationPreferencesResponse
  /** Updates Commercial User details based on GUID */
  fc__customer__updateCommercialUser: Fc__Customer__CommercialUserUpdateResponse
  /** Mutation to bulk update notification preferences on the customer level */
  fc__customer__updateNotificationPreferences: Fc__Customer__UpdateNotificationPreferencesResponse
  /** Mutation to cancel multiple payments */
  fc__payment__cancelMultiplePayments: Fc__Payment__CancelMultiplePayResponse
  /** Mutation to schedule multiple payments */
  fc__payment__scheduleMultiplePayments: Fc__Payment__ScheduleMultiplePayResponse
  /** Mutation to update auto pay */
  fc__payment__updateAutoPay: Fc__Payment__UpdateAutoPayResponse
  /** Mutation to update garagingAddress on account level */
  fmcc__account__updateGaragingAddress: Fmcc__Account__GaragingAddressResponse
  /** Mutation to update nickName on account level */
  fmcc__account__updateNickname: Fmcc__Account__UpdateNicknameResponse
  /** Mutation for adding the bank account. */
  fmcc__bank__AddBankAccount: Fmcc__Bank__AddBankAccountResponse
  /** Mutation for deleting bank account. */
  fmcc__bank__DeleteBankAccount: Fmcc__Bank__DeleteBankAccountResponse
  /** Mutation for updating the bank account. */
  fmcc__bank__UpdateBankAccount: Fmcc__Bank__UpdateBankAccountResponse
  /** Update or delete a billing customer's address. */
  fmcc__customer__updateBillingAddress: Fmcc__Customer__BillingAddressResponse
  /** Add, update, or delete a customer's email addresses. */
  fmcc__customer__updateEmails: Fmcc__Customer__EmailResponse
  /** Add, update, or delete a customer's phone numbers. */
  fmcc__customer__updatePhones: Fmcc__Customer__PhoneResponse
  /** Mutation to cancel auto payment */
  fmcc__payment__cancelAutoPayment?: Maybe<Fmcc__Payment__CancelAutoPayResponse>
  /** Mutation to cancel single payment */
  fmcc__payment__cancelSinglePayment: Fmcc__Payment__CancelSinglePaymentResponse
  /** Mutation to enroll auto pay */
  fmcc__payment__enrollAutoPay: Fmcc__Payment__EnrollAutoPayResponse
  /** Mutation to schedule single  payment */
  fmcc__payment__scheduleSinglePayment: Fmcc__Payment__ScheduleSinglePaymentResponse
  /** Add a business location in Origami */
  fpiAddLocation: FpiAddOrUpdateLocationResponse
  /** Update a business location. */
  fpiUpdateLocation: FpiAddOrUpdateLocationResponse
  /** Add a vehicle driver for a proposal ID in Origami */
  fpi__quote__AddDriver: Fpi__Quote__UpdateDriverResponse
  /** Add additional details about applicant's insurance history to receive a quote */
  fpi__quote__AddInsuranceHistory: Fpi__Quote__UpdateInsuranceHistoryResponse
  /** Add Loss History record in origami for a given proposal Id */
  fpi__quote__AddLossHistory: Fpi__Quote__SaveLossHistoryResponse
  /** Add a vehicle to be included in quote submission using idNumber or year, make, and model */
  fpi__quote__AddVehicle: Fpi__Quote__UpdateVehicleResponse
  /** Bind quote with member id and proposal Id */
  fpi__quote__BindQuote: Fpi__Quote__BindQuoteResponse
  /** Requests a user to be called back from a fleet specialist to customize their quote or continue the quote journey. */
  fpi__quote__CallBackUser: Fpi__Quote__CallBackUserResponse
  /** create proposal in origami using BusinessInfo details & contact Info details */
  fpi__quote__CreateProposal: Fpi__Quote__UpdateProposalResponse
  /** Delete a vehicle driver for a proposal ID in Origami */
  fpi__quote__DeleteDriver: Fpi__Quote__UpdateDriverResponse
  /** Delete a vehicle from the quote using vehicleId */
  fpi__quote__DeleteVehicle: Fpi__Quote__UpdateVehicleResponse
  /** Run MVR Clue Report after default coverages are added with initial rating */
  fpi__quote__MVRClueReport?: Maybe<Fpi__Quote__RateQuoteResponse>
  /** Run a rating with proposal ID after business information is complete */
  fpi__quote__RateDefaultCoverage?: Maybe<Fpi__Quote__RateQuoteResponse>
  /** Run a rating with proposal ID after business information is complete - used after updating coverages to determine new rating */
  fpi__quote__RunRating?: Maybe<Fpi__Quote__RateQuoteResponse>
  /** Sends and email to a user with the provided url, enabling the user to save their quote and continue later. */
  fpi__quote__SaveAndContinue: Fpi__Quote__SaveAndContinueResponse
  /** Perform atomic operation to Insert, Update and Delete vehicle,policy and state coverages in Origami  */
  fpi__quote__UpdateCoverage?: Maybe<Fpi__Quote__UpdateCoverageResponse>
  /** Update a vehicle driver for a proposal ID and driver ID in Origami */
  fpi__quote__UpdateDriver: Fpi__Quote__UpdateDriverResponse
  /** Update insurance history details using insuranceHistoryId to receive a quote */
  fpi__quote__UpdateInsuranceHistory: Fpi__Quote__UpdateInsuranceHistoryResponse
  /** Update Loss History record in origami for a given proposal Id */
  fpi__quote__UpdateLossHistory: Fpi__Quote__SaveLossHistoryResponse
  /** save proposal in origami using BusinessInfo details & contact Info details */
  fpi__quote__UpdateProposal: Fpi__Quote__UpdateProposalResponse
  /** Update a vehicle to be included in quote submission using idNumber or year, make, and model */
  fpi__quote__UpdateVehicle: Fpi__Quote__UpdateVehicleResponse
  /**
   * Mutation to create a account registration for Canada
   * @deprecated Use `retailRegistration` instead.
   */
  registerAccountCAN: FcCommonMutationResponse
  /**
   * Mutation to create a account registration for US
   * @deprecated Use `retailRegistration` instead.
   */
  registerAccountUSA: FcCommonMutationResponse
  /**
   * Mutation to create a registration for Canada
   * @deprecated Use `retailRegistration` instead.
   */
  registerCAN: FcCommonMutationResponse
  /**
   * Mutation to create a registration for US
   * @deprecated Use `retailRegistration` instead.
   */
  registerUSA: FcCommonMutationResponse
}

export type MutationFcChangeDueDateArgs = {
  input: FcChangeDueDateInput
}

export type MutationFcCreateDocuSignArgs = {
  input: FcCreateDocuSignInput
}

export type MutationFcDeletePendingExtensionArgs = {
  input: FcDeletePendingExtensionInput
}

export type MutationFcMnvInteractionArgs = {
  input: FcMnvInteractionInput
}

export type MutationFcRegisterCommercialArgs = {
  input: FcCommercialRegistrationInput
}

export type MutationFcRegisterRetailArgs = {
  input: FcRetailRegistrationInput
}

export type MutationFcRequestClocIncreaseArgs = {
  input: FcRequestClocIncreaseInput
}

export type MutationFcScheduleSinglePaymentArgs = {
  input: FcScheduleSinglePaymentInput
}

export type MutationFcSubmitExtensionArgs = {
  input: FcSubmitExtensionInput
}

export type MutationFcUpdateCommercialMigrationStatusArgs = {
  input: FcUpdateCommercialMigrationStatusInput
}

export type MutationFc__Account__UpdateNotificationPreferencesArgs = {
  input: Fc__Account__NotificationPreferencesRequest
}

export type MutationFc__Customer__UpdateCommercialUserArgs = {
  input: Fc__Customer__UpdateCommercialUserRequest
}

export type MutationFc__Customer__UpdateNotificationPreferencesArgs = {
  input: Fc__Customer__NotificationPreferencesRequest
}

export type MutationFc__Payment__CancelMultiplePaymentsArgs = {
  input: Fc__Payment__CancelMultiplePaymentInput
}

export type MutationFc__Payment__ScheduleMultiplePaymentsArgs = {
  input?: InputMaybe<Fc__Payment__ScheduleMultiplePaymentInput>
}

export type MutationFc__Payment__UpdateAutoPayArgs = {
  input?: InputMaybe<Fc__Payment__UpdateAutoPayRequest>
}

export type MutationFmcc__Account__UpdateGaragingAddressArgs = {
  input: Fmcc__Account__GaragingAddressRequest
}

export type MutationFmcc__Account__UpdateNicknameArgs = {
  input: Fmcc__Account__UpdateNicknameRequest
}

export type MutationFmcc__Bank__AddBankAccountArgs = {
  input: Fmcc__Bank__AddBankAccountRequest
}

export type MutationFmcc__Bank__DeleteBankAccountArgs = {
  input: Fmcc__Bank__DeleteBankAccountRequest
}

export type MutationFmcc__Bank__UpdateBankAccountArgs = {
  input: Fmcc__Bank__UpdateBankAccountRequest
}

export type MutationFmcc__Customer__UpdateBillingAddressArgs = {
  input: Fmcc__Customer__BillingAddressRequest
}

export type MutationFmcc__Customer__UpdateEmailsArgs = {
  input: Fmcc__Customer__EmailRequest
}

export type MutationFmcc__Customer__UpdatePhonesArgs = {
  input: Fmcc__Customer__PhoneRequest
}

export type MutationFmcc__Payment__CancelAutoPaymentArgs = {
  input?: InputMaybe<Fmcc__Payment__CancelPaymentRequest>
}

export type MutationFmcc__Payment__CancelSinglePaymentArgs = {
  input?: InputMaybe<Fmcc__Payment__CancelPaymentRequest>
}

export type MutationFmcc__Payment__EnrollAutoPayArgs = {
  input?: InputMaybe<Fmcc__Payment__EnrollAutoPayRequest>
}

export type MutationFmcc__Payment__ScheduleSinglePaymentArgs = {
  input: Fmcc__Payment__ScheduleSinglePaymentRequest
}

export type MutationFpiAddLocationArgs = {
  proposalId: Scalars['Int']['input']
  request: FpiAddOrUpdateLocationInput
}

export type MutationFpiUpdateLocationArgs = {
  locationId: Scalars['Int']['input']
  proposalId: Scalars['Int']['input']
  request: FpiAddOrUpdateLocationInput
}

export type MutationFpi__Quote__AddDriverArgs = {
  input?: InputMaybe<Fpi__Quote__AddDriverRequest>
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__AddInsuranceHistoryArgs = {
  input?: InputMaybe<Fpi__Quote__InsuranceHistoryRequest>
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__AddLossHistoryArgs = {
  input?: InputMaybe<Fpi__Quote__LossHistoryRequest>
}

export type MutationFpi__Quote__AddVehicleArgs = {
  input?: InputMaybe<Fpi__Quote__AddVehicleRequest>
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__BindQuoteArgs = {
  billingFrequencyCode: Scalars['String']['input']
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__CallBackUserArgs = {
  input?: InputMaybe<Fpi__Quote__CallBackUserRequest>
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__CreateProposalArgs = {
  input?: InputMaybe<Fpi__Quote__CreateProposalRequest>
  request?: InputMaybe<ProposalFlow>
}

export type MutationFpi__Quote__DeleteDriverArgs = {
  driverId: Scalars['Int']['input']
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__DeleteVehicleArgs = {
  proposalId: Scalars['Int']['input']
  vehicleId: Scalars['Int']['input']
}

export type MutationFpi__Quote__MvrClueReportArgs = {
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__RateDefaultCoverageArgs = {
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__RunRatingArgs = {
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__SaveAndContinueArgs = {
  customerEmail: Scalars['String']['input']
  proposalId: Scalars['Int']['input']
  saveAndContinueUrl: Scalars['String']['input']
}

export type MutationFpi__Quote__UpdateCoverageArgs = {
  coverageCustomization: Fpi__CoverageCustomizationSectionInput
  input?: InputMaybe<Fpi__Quote__UpdateCoverageRequest>
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__UpdateDriverArgs = {
  driverId: Scalars['Int']['input']
  input?: InputMaybe<Fpi__Quote__UpdateDriverRequest>
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__UpdateInsuranceHistoryArgs = {
  input?: InputMaybe<Fpi__Quote__InsuranceHistoryRequest>
  insuranceHistoryId: Scalars['Int']['input']
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__UpdateLossHistoryArgs = {
  clueDriverId: Scalars['Int']['input']
  input?: InputMaybe<Fpi__Quote__LossHistoryRequest>
  lossHistoryId: Scalars['Int']['input']
}

export type MutationFpi__Quote__UpdateProposalArgs = {
  input?: InputMaybe<Fpi__Quote__UpdateProposalRequest>
  memberId: Scalars['Int']['input']
  proposalId: Scalars['Int']['input']
}

export type MutationFpi__Quote__UpdateVehicleArgs = {
  input?: InputMaybe<Fpi__Quote__UpdateVehicleRequest>
  proposalId: Scalars['Int']['input']
  vehicleId: Scalars['Int']['input']
}

export type MutationRegisterAccountCanArgs = {
  input: FcRegisterAccountCanInput
}

export type MutationRegisterAccountUsaArgs = {
  input: FcRegisterAccountUsaInput
}

export type MutationRegisterCanArgs = {
  input: FcRegisterCanInput
}

export type MutationRegisterUsaArgs = {
  input: FcRegisterUsaInput
}

/** A flag indicating whether this ineligibility can be overridden */
export enum OverridableFlag {
  /** Non Overridable */
  NonOverridable = 'NON_OVERRIDABLE',
  /** Overridable */
  Overridable = 'OVERRIDABLE',
  /** Supervisor Overridable */
  SupervisorOverridable = 'SUPERVISOR_OVERRIDABLE',
}

/** (Optional) If given, the response will be paginated with the specified number of documents on each page. */
export type PaginationInput = {
  /** The zero-indexed page number. (For the first page, set this value to `0`) */
  pageNumber: Scalars['Int']['input']
  /** The number of elements to return in each page. */
  pageSize: Scalars['Int']['input']
}

/** Enum for determining the request for proposal creation  */
export enum ProposalFlow {
  MemberFirst = 'MEMBER_FIRST',
  ProposalFirst = 'PROPOSAL_FIRST',
}

/** Root query type. */
export type Query = {
  __typename?: 'Query'
  /** Namespace for Alfa queries */
  fcQuery?: Maybe<FcQuery>
  /** Query for all ford credit data */
  fmcc?: Maybe<Fmcc__Query>
  /** Top level query */
  fpi?: Maybe<Fpi__Query>
  /** Testing get reference-id query */
  getReferenceId?: Maybe<Scalars['String']['output']>
}

/**
 * Represents the payment plan of an account
 *
 * If this value is `null`, then the account is neither a balloon payment nor a single payment loan.
 */
export enum SingleOrBalloonCode {
  /** Advanced payment plan */
  A = 'A',
  /** Balloon loan */
  B = 'B',
  /** Customer Option Plan (COP) */
  C = 'C',
  /** Single payment loan */
  S = 'S',
}

/** Represents whether the system name is AMO or SYSMSD or FCMOBILE */
export enum SystemName {
  /** Account manager */
  Amo = 'AMO',
  /** Ford credit mobile */
  Fcmobile = 'FCMOBILE',
  /** Sysmsd */
  Sysmsd = 'SYSMSD',
}

/** JS Power vehicle information and details */
export type VehicleInfo = {
  __typename?: 'VehicleInfo'
  /**
   * Refers to the estimated Manufacturer's Suggested Retail Price (MSRP)
   *  of a vehicle when it was originally built or manufactured
   */
  asBuiltEstimatedMSRP?: Maybe<Scalars['String']['output']>
  /** The body style of the vehicle. (e.g  Crew Cab , Sport Utility) */
  bodyStyle?: Maybe<Scalars['String']['output']>
  /** The body style Id configured in Origami for the above body style. */
  bodyStyleId?: Maybe<Scalars['Int']['output']>
  /**  the total weight of a vehicle when fully loaded with passengers, cargo, and any additional equipment. */
  grossVehicleWeight?: Maybe<Scalars['String']['output']>
  /** The localized make of the vehicle (e.g. Ford) */
  make?: Maybe<Scalars['String']['output']>
  /** The localized model of the vehicle (e.g. Mustang) */
  model?: Maybe<Scalars['String']['output']>
  /** Represents the initial cost or price of the vehicle when it was brand new */
  originalCostNew?: Maybe<Scalars['String']['output']>
  /** The weight of a vehicle without any passengers or cargo. */
  standardCurbWeight?: Maybe<Scalars['String']['output']>
  /** The standard weight units used to measure the weight of vehicles. */
  standardWeightUnits?: Maybe<Scalars['String']['output']>
  /** Represents vehicle identifier Number. */
  vin?: Maybe<Scalars['VIN']['output']>
  /** The model year of the vehicle (e.g. 2020) */
  year?: Maybe<Scalars['String']['output']>
}

/** The vehicle's type */
export enum VehicleType {
  /** Electric vehicle */
  Bev = 'BEV',
  /** Future Vehicle of Interest */
  FutureVoi = 'FUTURE_VOI',
  /** Machine Learning updated */
  MlUpdated = 'ML_UPDATED',
  /** Preferred  */
  Preferred = 'PREFERRED',
  /** Selected */
  Selected = 'SELECTED',
  /** Updated */
  Updated = 'UPDATED',
  /** Upgraded */
  Upgraded = 'UPGRADED',
  /** Vehicle of Interest */
  Voi = 'VOI',
}

/** Represents whether Account notification channel is Email or SMS */
export enum Fc__AccountNotificationChannel {
  /** Email Notification channel */
  Email = 'EMAIL',
  /** SMS Notification channel */
  Sms = 'SMS',
}

/** Represents whether Account notification type is paperless billing or online statement or payment reminder or payment received */
export enum Fc__AccountNotificationType {
  /** Account notification type for online statement availability */
  OnlineStatementAvailability = 'ONLINE_STATEMENT_AVAILABILITY',
  /** Account notification type for paperless billing */
  PaperlessBilling = 'PAPERLESS_BILLING',
  /** Account notification type for payment received */
  PaymentReceived = 'PAYMENT_RECEIVED',
  /** Account notification type for payment remainder */
  PaymentReminder = 'PAYMENT_REMINDER',
}

/** Represents whether Customer notification channel is Email. */
export enum Fc__CustomerNotificationChannel {
  /** email */
  Email = 'EMAIL',
}

/**
 * Represents whether Customer notification type is paperless billing or marketing or
 * electronic correspondence or online statement or payment reminder or payment received.
 */
export enum Fc__CustomerNotificationType {
  /** electronic correspondence */
  ElectronicCorrespondence = 'ELECTRONIC_CORRESPONDENCE',
  /** marketing */
  Marketing = 'MARKETING',
  /** online statement availability */
  OnlineStatementAvailability = 'ONLINE_STATEMENT_AVAILABILITY',
  /** paperless billing */
  PaperlessBilling = 'PAPERLESS_BILLING',
  /** payment received */
  PaymentReceived = 'PAYMENT_RECEIVED',
  /** payment remainder */
  PaymentReminder = 'PAYMENT_REMINDER',
}

export enum Fc__OdometerSourceId {
  FordPassNonPii = 'FORD_PASS_NON_PII',
}

/**  Defines the possible units for odometer data */
export enum Fc__OdometerValueUnit {
  Kilometers = 'KILOMETERS',
  Miles = 'MILES',
}

/** An addon for an account */
export type Fc__Account__Addon = {
  __typename?: 'fc__account__Addon'
  /** The date a specific Account Charge is cancelled. Example: 1992-06-01 OR 2001-03-01 */
  accountChargeCancelDate?: Maybe<Scalars['Date']['output']>
  /**
   * Describes the type of the charges on the contract or lease agreement, both financed and not financed.
   * EXAMPLE: 0001 = Outside Credit Insurance OR 0046 = Rental Tax Comment: Every charge item on a contract or
   * lease agreement consists of an Account Charge Original Amount.
   * Each Account Charge is identified by a unique code
   */
  accountChargeCode?: Maybe<Scalars['Int']['output']>
  /**
   * The date when the “soft add on” is added to contract and could equal to the Insurance Policy Effective Date.
   * If Insurance Policy Effective Date is unavailable, field will be populated with Contract Date.
   */
  addOnEffectiveDate?: Maybe<Scalars['Date']['output']>
  /** The date when the “soft add on” is no longer applicable for the contract. */
  addOnExpirationDate?: Maybe<Scalars['Date']['output']>
  /**
   * A unique identifier for a company or a business.
   * Examples: 0001 = Ford Credit OR 0002 = Primus OR 0003 = Fairlane Credit
   */
  companyBusinessCode?: Maybe<Scalars['Int']['output']>
  /**
   * Represents the Ford Credit or PRIMUS branch that originated the discounting of an offering.
   * EXAMPLES: FT OR AB
   */
  discountingOriginalBranchCode?: Maybe<Scalars['String']['output']>
}

export type Fc__Account__MarketingOffer = {
  __typename?: 'fc__account__MarketingOffer'
  /** true if eligible; false if not */
  isEligible?: Maybe<Scalars['Boolean']['output']>
  /** HTML Code */
  offerContent?: Maybe<Scalars['String']['output']>
  /** fixed values {AccessoryGeneric; Insure; Accessory-BF23} */
  offerName?: Maybe<Scalars['String']['output']>
}

/** Represents the predictive mileage status of a leased vehicle, such as on track, under, or over the limit. */
export enum Fc__Account__MileageStatus {
  /** Indicates that the predictive mileage status of a leased vehicle is under the limit. */
  AtRisk = 'AT_RISK',
  /** Indicates that the predictive mileage status of a leased vehicle is on track for the limit. */
  Good = 'GOOD',
  /** Indicates that the predictive mileage status of a leased vehicle is over the limit. */
  Over = 'OVER',
}

/** A set of input parameters common to update preferences */
export type Fc__Account__NotificationParameters = {
  /** Receivable account number of the account whose preferences you are updating */
  accountNumber: Scalars['String']['input']
  /** Company indicator 1=FordCredit,2=PRIMUS */
  companyBusinessCode: Scalars['Int']['input']
  /** The master customer number of the customer whose preferences you are updating */
  masterCustomerNumber: Scalars['Int']['input']
  /**
   * Identifier of the user making the request
   *
   * This can be a system ID or a CDSID
   * This will be used for writing the Pinnacle Contacts
   */
  updatedBy: Scalars['String']['input']
}

/** Contains Notification preferences details to be updated */
export type Fc__Account__NotificationPreferenceRequest = {
  /**
   * The channel preferred by the customer for notification preferences, such as email or SMS
   * If the permissionType is set to PAPERLESS_BILLING, then this must be set to EMAIL
   */
  channel: Fc__AccountNotificationChannel
  /** Indicates whether the given notification should be enabled on the given channel */
  enabled: Scalars['Boolean']['input']
  /** The type of notification to update */
  notificationType: Fc__AccountNotificationType
  /**
   * The number of days prior to remind the customer for payment
   * This is required only when the channel is EMAIL or SMS, and permissionType is PAYMENT_REMINDER
   */
  paymentReminderDays?: InputMaybe<Scalars['Int']['input']>
  /**
   * The phone ID number of the customer
   * This is required when the channel is SMS and permissionType is one of the following: ONLINE_STATEMENT_AVAILABILITY,
   * PAYMENT_CONFIRMATION, PAYMENT_RECEIVED, or PAYMENT_REMINDER.
   */
  phoneIdNumber?: InputMaybe<Scalars['Int']['input']>
}

/** Input for updating the Notification preference on account level */
export type Fc__Account__NotificationPreferencesRequest = {
  /** A set of input parameters common to update preferences */
  parameters: Fc__Account__NotificationParameters
  /** Contains Notification preferences details to be updated */
  preferences: Array<Fc__Account__NotificationPreferenceRequest>
}

/** Return fields from customer account overview response */
export type Fc__Account__PinnacleAccount = {
  __typename?: 'fc__account__PinnacleAccount'
  /** AccountNumber to get data from the downstream APIs referencing receivables system. Currently maps to receivable account number */
  accountNumber?: Maybe<Scalars['Int']['output']>
  /** Commercial Account status */
  accountStatus?: Maybe<Scalars['String']['output']>
  /** Commercial Account status code */
  accountStatusCode?: Maybe<Scalars['Int']['output']>
  /** Represents whether a customer is the primary buyer or a co-buyer. */
  applicantType?: Maybe<Scalars['String']['output']>
  /** Bankruptcy status - Y/N */
  bankruptcyStatus?: Maybe<Scalars['String']['output']>
  /** Company indicator 1=FordCredit,2=PRIMUS */
  companyBusinessCode?: Maybe<Scalars['Int']['output']>
  /** Contract date */
  contractDate?: Maybe<Scalars['Date']['output']>
  /** Address where vehicle is physically located, used for taxation purposes */
  garagingAddress?: Maybe<Fmcc__Account__Address>
  /** Number of Check Returned */
  numberOfCheckReturned?: Maybe<Scalars['Int']['output']>
  /** Number of Payment Extensions */
  numberOfPaymentExtensions?: Maybe<Scalars['Int']['output']>
  /** Outstanding balance */
  outstandingBalance?: Maybe<Scalars['Float']['output']>
  /** Date payment due */
  paymentDueDate?: Maybe<Scalars['Date']['output']>
  /** Product code indicates the type of account (e.g. 1 - Retail, 2 - Red carpet lease/Lease, 5 - TRAC) */
  productCode?: Maybe<Scalars['Int']['output']>
  /**
   * Product description for Ford-Pro experience based on the product code.
   *
   * These values are maintained by the Customer Account Overview API.
   */
  productDescription?: Maybe<Scalars['String']['output']>
  /** Vehicle color (e.g. ABSOLUTE BLACK) */
  vehicleColor?: Maybe<Scalars['String']['output']>
  /** Vehicle identification number  */
  vehicleIdentificationNumber?: Maybe<Scalars['VIN']['output']>
  /** The localized make of the vehicle (e.g. Ford) */
  vehicleMake?: Maybe<Scalars['String']['output']>
  /** The localized model of the vehicle (e.g. Mustang) */
  vehicleModel?: Maybe<Scalars['String']['output']>
  /** Vehicle nickname */
  vehicleNickname?: Maybe<Scalars['String']['output']>
  /** The model year of the vehicle (e.g. 2020) */
  vehicleYear?: Maybe<Scalars['Int']['output']>
}

/** Update notification preferences response  */
export type Fc__Account__UpdateNotificationPreferencesResponse = {
  __typename?: 'fc__account__UpdateNotificationPreferencesResponse'
  /** The HTTP status code for the notification response */
  code: Scalars['Int']['output']
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the notification change was successful */
  success: Scalars['Boolean']['output']
}

export enum Fc__ApplicationSourceCode {
  AccountManager = 'ACCOUNT_MANAGER',
  Bridge = 'BRIDGE',
  CommunicationPreferenceCenter = 'COMMUNICATION_PREFERENCE_CENTER',
  FcMobileApp = 'FC_MOBILE_APP',
  GlobalCollectionSystems = 'GLOBAL_COLLECTION_SYSTEMS',
  GlobalLoanOriginations = 'GLOBAL_LOAN_ORIGINATIONS',
  Messaging = 'MESSAGING',
  MicrosoftDynamics = 'MICROSOFT_DYNAMICS',
  PinnacleAccountServicing = 'PINNACLE_ACCOUNT_SERVICING',
  SalesforceContactCenter = 'SALESFORCE_CONTACT_CENTER',
  Workflow = 'WORKFLOW',
}

/** Provides customer notification preferences for an account */
export type Fc__Customer__AccountPreferences = {
  __typename?: 'fc__customer__AccountPreferences'
  /** Customer account details */
  account?: Maybe<Fmcc__Account__Account>
  /** Preferences configured on Account level */
  preferences?: Maybe<Array<Fc__Customer__Preferences>>
}

/**  Represents different types of Addresses .  */
export enum Fc__Customer__AddressTypeCodeEnum {
  AuditOrInventor = 'AUDIT_OR_INVENTOR',
  BillingAddress = 'BILLING_ADDRESS',
  EmployerAddress = 'EMPLOYER_ADDRESS',
  GaragingAddress = 'GARAGING_ADDRESS',
  MailingAddress = 'MAILING_ADDRESS',
  Other = 'OTHER',
  PhysicalAddress = 'PHYSICAL_ADDRESS',
  PreviousEmployerAddress = 'PREVIOUS_EMPLOYER_ADDRESS',
  PreviousResidence = 'PREVIOUS_RESIDENCE',
  Residence = 'RESIDENCE',
  TitleAddress = 'TITLE_ADDRESS',
}

/** A Ford Credit address */
export type Fc__Customer__BillingAddress = Address & {
  __typename?: 'fc__customer__BillingAddress'
  /** The first line of the billing address. */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The second line of the billing address. */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** The third line of the billing address. */
  addressLine3?: Maybe<Scalars['String']['output']>
  /** Address Sequence Number */
  addressSequenceNumber?: Maybe<Scalars['Int']['output']>
  /** Address Type Code */
  addressTypeCode?: Maybe<Fc__Customer__AddressTypeCodeEnum>
  /** The city name in the billing address. */
  city?: Maybe<Scalars['String']['output']>
  /** The country name in the billing address. */
  country?: Maybe<Scalars['String']['output']>
  /**
   * This field is deprecated use the field country.
   * @deprecated Use country instead.
   */
  countryCode?: Maybe<Scalars['String']['output']>
  /** OtherCountry */
  otherCountry?: Maybe<Scalars['String']['output']>
  /** Other Post Code */
  otherPostCode?: Maybe<Scalars['String']['output']>
  /** Other State */
  otherState?: Maybe<Scalars['String']['output']>
  /** The state in the billing address. */
  state?: Maybe<Scalars['String']['output']>
  /** The ZIP code in the billing address. */
  zip?: Maybe<Scalars['String']['output']>
}

/** Customer registration completion status along with their MCN */
export type Fc__Customer__CommercialRegistrationStatus = {
  __typename?: 'fc__customer__CommercialRegistrationStatus'
  /** Registration completion status */
  isRegistered?: Maybe<Scalars['Boolean']['output']>
  /** Master customer number of the customer */
  masterCustomerNumber?: Maybe<Scalars['fc__customer__MCN']['output']>
}

/** Commercial user update response status and confirmation */
export type Fc__Customer__CommercialUserUpdateResponse = {
  __typename?: 'fc__customer__CommercialUserUpdateResponse'
  /** The HTTP status code of the domain's response. */
  code: Scalars['Int']['output']
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the Commercial user updates were successful. */
  success: Scalars['Boolean']['output']
}

/** Represents a type of customer (commercial or personal). */
export enum Fc__Customer__CustomerType {
  Commercial = 'COMMERCIAL',
  Personal = 'PERSONAL',
}

/**
 * A channel through which digital communications can be sent to a customer.
 *
 * This can represent either emails or mobile push notifications.
 */
export type Fc__Customer__DigitalCommunication = {
  __typename?: 'fc__customer__DigitalCommunication'
  /** Digital Communication Id Number */
  idNumber?: Maybe<Scalars['Int']['output']>
  /** Digital Communication Nickname */
  nickname?: Maybe<Scalars['String']['output']>
  /**
   * Represents the position of this digital communication should appear in the list on the page.
   *
   * Items should be ordered by sequence number, increasing.
   */
  sequenceNumber?: Maybe<Scalars['Int']['output']>
  /** For emails, this field provides the email address. For push notifications, this field provides the device ID. */
  text?: Maybe<Scalars['String']['output']>
  /** Describes whether this digital communication is an email or an Android/iOS push notification */
  type?: Maybe<Fc__Customer__DigitalCommunicationType>
}

/** Represents a type of digital communication channel (email or push notification) */
export enum Fc__Customer__DigitalCommunicationType {
  Android = 'ANDROID',
  Apple = 'APPLE',
  BusinessEmail = 'BUSINESS_EMAIL',
  PersonalEmail = 'PERSONAL_EMAIL',
  ProviderContactEmail = 'PROVIDER_CONTACT_EMAIL',
  ProviderRebateEmail = 'PROVIDER_REBATE_EMAIL',
}

/** A set of input parameters common to all notification preference updates. */
export type Fc__Customer__NotificationParameters = {
  /** Company business code is 1 for North America */
  companyBusinessCode: Scalars['Int']['input']
  /** The master customer number of the customer whose preferences you are updating. */
  masterCustomerNumber: Scalars['Int']['input']
  /**
   * Identifier of the user making the request.
   *
   * This can be a system ID or a CDSID.
   * This will be used for writing the Pinnacle Contacts.
   */
  updatedBy: Scalars['String']['input']
}

/** Contains Notification preferences details to be updated. */
export type Fc__Customer__NotificationPreferenceRequest = {
  /**
   * Channel preferred by customer for preferences such as Email/SMS.
   *
   * Currently, only EMAIL is supported for customer-level notification preferences.
   */
  channel: Fc__CustomerNotificationChannel
  /** Indicates whether the given notification should be enabled on the given channel. */
  enabled: Scalars['Boolean']['input']
  /** Indicates which notification to update. */
  notificationType: Fc__CustomerNotificationType
}

/** Query for providing notification preferences for a given customer */
export type Fc__Customer__NotificationPreferences = {
  __typename?: 'fc__customer__NotificationPreferences'
  /** Preferences configured on Account level */
  accountPreferences?: Maybe<Array<Fc__Customer__AccountPreferences>>
  /** CompanyBusinessCode value is 1 for North America */
  companyBusinessCode: Scalars['Int']['output']
  /** Preferences configured on MCN level */
  customerPreferences?: Maybe<Array<Fc__Customer__Preferences>>
  /** Channel preferred by customer for preferences */
  customerPreferredChannel?: Maybe<Scalars['String']['output']>
}

/** Input for updating the Notification preference on customer level. */
export type Fc__Customer__NotificationPreferencesRequest = {
  /** A set of input parameters common to all notification preference updates. */
  parameters: Fc__Customer__NotificationParameters
  /** The list of preferences to update. */
  preferences: Array<Fc__Customer__NotificationPreferenceRequest>
}

/** Provides the list of permission history for customer and account */
export type Fc__Customer__PermissionUpdateRecord = {
  __typename?: 'fc__customer__PermissionUpdateRecord'
  /** The timestamp when we received the request to change */
  actualRequestTimestamp?: Maybe<Scalars['DateTime']['output']>
  /** The timestamp of when the update was made */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>
}

/** Provides Customer preferences for notifications */
export type Fc__Customer__Preferences = {
  __typename?: 'fc__customer__Preferences'
  /** Channel preferred by customer for preferences such as Email/SMS */
  channel: Scalars['String']['output']
  /** Days prior to remind the customer for payment */
  paymentReminderDaysPrior?: Maybe<Scalars['Int']['output']>
  /** Enable/disable notification preferences */
  permission: Scalars['Boolean']['output']
  /** The historical changes made for a particular preference */
  permissionHistory?: Maybe<Array<Fc__Customer__PermissionUpdateRecord>>
  /** Type of preferences which customer wants to update */
  permissionType: Scalars['String']['output']
  /** Phone id number of customer */
  phoneIdNumber?: Maybe<Scalars['String']['output']>
  /** Boolean field describes the phone validation done by customer */
  phoneValidated?: Maybe<Scalars['Boolean']['output']>
}

/** Provides the reward points detail for the customer */
export type Fc__Customer__RewardPointsDetail = {
  __typename?: 'fc__customer__RewardPointsDetail'
  /** Describes whether the customer accepted the Rewards Terms & Conditions or not. It will be ‘true’ if the customer accepted T&C’s */
  consentAccepted?: Maybe<Scalars['Boolean']['output']>
  /** Total number of Ford Pass Rewards (FPR) or Lincoln Access Rewards (LAR) Point balance the customer holds */
  points?: Maybe<Scalars['Int']['output']>
}

/** Provides the reward points to redeem for Ford and Lincoln */
export type Fc__Customer__RewardPointsSummary = {
  __typename?: 'fc__customer__RewardPointsSummary'
  /** Total available points to redeem for Ford reward programs */
  ford?: Maybe<Fc__Customer__RewardPointsDetail>
  /** Total available points to redeem for Lincoln reward programs */
  lincoln?: Maybe<Fc__Customer__RewardPointsDetail>
}

/** Provides the unified billing summary details */
export type Fc__Customer__UnifiedBillingSummary = {
  __typename?: 'fc__customer__UnifiedBillingSummary'
  /** Total Number Of Accounts */
  totalNumberOfAccounts?: Maybe<Scalars['Int']['output']>
  /** Total Number Of Lease Accounts */
  totalNumberOfLeaseAccounts?: Maybe<Scalars['Int']['output']>
  /** Total Number Of Retail Accounts */
  totalNumberOfRetailAccounts?: Maybe<Scalars['Int']['output']>
  /** Total Number Of Trac Accounts */
  totalNumberOfTracAccounts?: Maybe<Scalars['Int']['output']>
}

/**  Commercial user details to be updated  */
export type Fc__Customer__UpdateCommercialUserRequest = {
  /** Currently maps to receivable account number */
  accountNumbers: Array<InputMaybe<Scalars['fmcc__account__AccountNumber']['input']>>
  /** It represents the name of the app making the call */
  systemName: Scalars['String']['input']
  /** GUID of the commercial user to be updated */
  userId: Scalars['String']['input']
}

/** Update notification preferences response. */
export type Fc__Customer__UpdateNotificationPreferencesResponse = {
  __typename?: 'fc__customer__UpdateNotificationPreferencesResponse'
  /** The HTTP status code of the domain's response. */
  code: Scalars['Int']['output']
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the notification preference updates were successful. */
  success: Scalars['Boolean']['output']
}

/** Provides freeze window and eligibility information to the customer for Auto Pay. */
export type Fc__Payment__AutoPayEligibility = {
  __typename?: 'fc__payment__AutoPayEligibility'
  /** A list of errors regarding Auto Pay eligibility. If the eligibility is false this will return the reasons for the ineligibility. */
  errors?: Maybe<Array<Maybe<Fc__Payment__AutoPayEligibilityFailure>>>
  /** Returns True/False based on the Auto Pay eligibility. */
  isEligible?: Maybe<Scalars['Boolean']['output']>
  /** Returns True/False if the account is in Freeze window for payments. */
  isFreezeWindow?: Maybe<Scalars['Boolean']['output']>
}

/** Provides detailed information on an error which occurred when retrieving Auto Pay eligibility information for a customer. */
export type Fc__Payment__AutoPayEligibilityFailure = {
  __typename?: 'fc__payment__AutoPayEligibilityFailure'
  /** The error code when retrieving Auto Pay eligibility. */
  code?: Maybe<Scalars['String']['output']>
  /** The error message when retrieving Auto Pay eligibility. */
  message?: Maybe<Scalars['String']['output']>
}

/** MultiPayment Cancel Response */
export type Fc__Payment__CancelMultiplePayResponse = {
  __typename?: 'fc__payment__CancelMultiplePayResponse'
  /** MultiPayments Cancel Response. This will not be present if the mutation was not successful. */
  cancelMultiplePaymentsResponse?: Maybe<Fc__Payment__CancelMultiplePaymentsResponse>
  /** The HTTP status code for the Cancel Multiple Payment response. */
  code: Scalars['Int']['output']
  /** If the request is not successful, this will contain a list of error codes from the multiple payment API. */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the Cancel Multiple Payment is successful. */
  success: Scalars['Boolean']['output']
}

/** Cancel Multiple Payment Request Object .  */
export type Fc__Payment__CancelMultiplePaymentInput = {
  /** The unique identifier generated for the payment scheduled by the customer */
  customerTransactionId: Scalars['Long']['input']
  /** MasterCustomerNumber */
  masterCustomerNumber: Scalars['Int']['input']
}

/** Cancel MultiPayment Response Object. */
export type Fc__Payment__CancelMultiplePaymentsResponse = {
  __typename?: 'fc__payment__CancelMultiplePaymentsResponse'
  /** Cancel Vehicle Payment Account Detail */
  cancelVehiclePaymentAccountDetails?: Maybe<Array<Fc__Payment__CancelVehiclePaymentAccountDetailResponse>>
  /** Payment Customer Transaction Id */
  customerTransactionId?: Maybe<Scalars['Long']['output']>
  /** Payment Records count */
  numberOfPaymentRecords?: Maybe<Scalars['Int']['output']>
  /** Payment Scheduled Date */
  scheduledDate?: Maybe<Scalars['Date']['output']>
  /** Total Payment Amount */
  totalAmount?: Maybe<Scalars['Float']['output']>
  /** Total Principal Payment Amount */
  totalPrincipalAmount?: Maybe<Scalars['Float']['output']>
}

/** MultiPayment Cancel Vehicle Account Detail response. */
export type Fc__Payment__CancelVehiclePaymentAccountDetailResponse = {
  __typename?: 'fc__payment__CancelVehiclePaymentAccountDetailResponse'
  /** Receivable Account Number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['output']
  /** Already Cancelled */
  alreadyCancelled?: Maybe<Scalars['Boolean']['output']>
  /** Payment due amount. Must be between 1.01 and 99999.99 */
  amount: Scalars['Float']['output']
  /** Principal Payment Amount */
  principalAmount: Scalars['Float']['output']
}

/** The past payment due details for an account */
export type Fc__Payment__PaymentAggregate = {
  __typename?: 'fc__payment__PaymentAggregate'
  /** History of payments due. */
  paymentDues?: Maybe<Array<Fc__Payment__PaymentDue>>
}

export type Fc__Payment__PaymentDue = {
  __typename?: 'fc__payment__PaymentDue'
  /** dueAmount for payment */
  dueAmount?: Maybe<Scalars['Float']['output']>
  /** dueDate for payment */
  dueDate?: Maybe<Scalars['Date']['output']>
}

/** Failed Rules for payoff */
export type Fc__Payment__PayoffFailedRule = {
  __typename?: 'fc__payment__PayoffFailedRule'
  /** Reason for rule failure */
  description: Scalars['String']['output']
  /** Failed rule name */
  name: Scalars['String']['output']
}

/** MultiPayment Schedule Response */
export type Fc__Payment__ScheduleMultiplePayResponse = {
  __typename?: 'fc__payment__ScheduleMultiplePayResponse'
  /** The HTTP status code for the Schedule Multiple Payment response. */
  code: Scalars['Int']['output']
  /** If the request is not successful, this will contain a list of error codes from the multiple payment API. */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** MultiPayments Schedule Response. This will not be present if the mutation was not successful. */
  scheduleMultiplePaymentsResponse?: Maybe<Fc__Payment__ScheduleMultiplePaymentsResponse>
  /** Indicates whether the Schedule Multiple Payment is successful. */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Schedule Multiple Payment Request Object. */
export type Fc__Payment__ScheduleMultiplePaymentInput = {
  /** Bank Account Id */
  bankAccountId: Scalars['Int']['input']
  /** Country Code detail */
  countryCode: Scalars['String']['input']
  /** Currency type based on the country code */
  currency: Scalars['String']['input']
  /** Flag for customer's electronic consent for all types of payment */
  isElectronicPaymentConsent: Scalars['Boolean']['input']
  /** Flag for customer's principal payment consent if payment option is TOTAL_AMOUNT_DUE_AND_PRINCIPAL and PRINCIPAL_ONLY */
  isPrincipalPaymentConsent: Scalars['Boolean']['input']
  /** MasterCustomerNumber */
  masterCustomerNumber: Scalars['Int']['input']
  /** Number Of Payment Records */
  numberOfPaymentRecords: Scalars['Int']['input']
  /** Payment Date */
  paymentDate: Scalars['String']['input']
  /** Payment Option detail */
  paymentOption: Scalars['String']['input']
  /** Total Amount detail */
  totalAmount: Scalars['Float']['input']
  /** Total Principal Amount */
  totalPrincipalAmount: Scalars['Float']['input']
  /** Vehicle Payment Account Details Request */
  vehiclePaymentAccountDetails: Array<InputMaybe<Fc__Payment__VehiclePaymentAccountDetailsInput>>
}

/** Schedule MultiPayment Response Object. */
export type Fc__Payment__ScheduleMultiplePaymentsResponse = {
  __typename?: 'fc__payment__ScheduleMultiplePaymentsResponse'
  /** Payment Customer Transaction Id */
  customerTransactionId?: Maybe<Scalars['Long']['output']>
  /** Payment Records count */
  numberOfPaymentRecords?: Maybe<Scalars['Int']['output']>
  /** Generated Payment Authorization Agreement Document Url */
  paymentAgreementUri?: Maybe<Scalars['String']['output']>
  /** Payment Scheduled Date */
  scheduledDate?: Maybe<Scalars['Date']['output']>
  /** Total Payment Amount */
  totalAmount?: Maybe<Scalars['Float']['output']>
  /** Total Principal Payment Amount */
  totalPrincipalAmount?: Maybe<Scalars['Float']['output']>
  /** Vehicle Payment Account Details Response */
  vehiclePaymentAccountDetails?: Maybe<Array<Fc__Payment__VehiclePaymentAccountDetailsResponse>>
}

/** Update AutoPay Payment Request Object. */
export type Fc__Payment__UpdateAutoPayRequest = {
  /** The client must provide 8 digit account number value for which the payment transactions are being performed. */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** The client must provide bank account Id value for which the payment transactions are being performed. */
  bankAccountId?: InputMaybe<Scalars['Int']['input']>
  /** The client must provide the electronic consent for all types of payment. */
  hasElectronicPaymentConsent?: InputMaybe<Scalars['Boolean']['input']>
  /** master customer number for any given customer */
  masterCustomerNumber: Scalars['String']['input']
}

/** Enroll Autopay mutation response status and confirmation */
export type Fc__Payment__UpdateAutoPayResponse = {
  __typename?: 'fc__payment__UpdateAutoPayResponse'
  /** The HTTP status code for the update autoPay response. */
  code: Scalars['Int']['output']
  /** If the request is not successful, this will contain a list of error codes from the payment API. */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** Provides error messages from business */
  errors?: Maybe<Array<Maybe<Fmcc__CommonErrorResponse>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the update autoPay was successful. */
  success?: Maybe<Scalars['Boolean']['output']>
  /**
   * Information confirming a successful autopay update.
   * This field will not be present if the mutation was unsuccessful.
   */
  updateAutoPaymentResponse?: Maybe<Fc__Payment__UpdateAutoPaymentResponse>
}

/** Enroll AutoPay Response Object */
export type Fc__Payment__UpdateAutoPaymentResponse = {
  __typename?: 'fc__payment__UpdateAutoPaymentResponse'
  /** AccountNumber to get data from the downstream APIs referencing receivables system.Currently maps to receivable account number */
  accountNumber?: Maybe<Scalars['fmcc__account__AccountNumber']['output']>
  /** Bank account nick name associated with the autopay. */
  bankAccountNickName?: Maybe<Scalars['String']['output']>
  /** Masked bank account number associated with the autopay. */
  bankAccountNumber?: Maybe<Scalars['String']['output']>
  /** Bank account type associated with the autopay. */
  bankAccountType?: Maybe<Scalars['String']['output']>
  /** Next due date for the autopay. */
  nextDueDate?: Maybe<Scalars['Date']['output']>
  /** Generated document url of the scheduled payment. */
  paymentAgreementUri?: Maybe<Scalars['String']['output']>
  /** Payment Confirmation Number Value. */
  paymentConfirmationNumber?: Maybe<Scalars['String']['output']>
}

/** MultiPayment Vehicle Account Details Input. */
export type Fc__Payment__VehiclePaymentAccountDetailsInput = {
  /** Receivable Account Number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Payment due amount. Must be between 1.01 and 99999.99 */
  amount: Scalars['Float']['input']
  /** Principal Payment Amount */
  principalAmount: Scalars['Float']['input']
}

/** MultiPayment Schedule Vehicle Account Detail response. */
export type Fc__Payment__VehiclePaymentAccountDetailsResponse = {
  __typename?: 'fc__payment__VehiclePaymentAccountDetailsResponse'
  /** Receivable Account Number */
  accountNumber?: Maybe<Scalars['fmcc__account__AccountNumber']['output']>
  /** Payment due amount. Must be between 1.01 and 99999.99 */
  amount?: Maybe<Scalars['Float']['output']>
  /** Principal Payment Amount */
  principalAmount?: Maybe<Scalars['Float']['output']>
}

/** Provides the account number and vehicle invoice statement dates */
export type Fc__Statement__AccountStatementDates = {
  __typename?: 'fc__statement__AccountStatementDates'
  /** Receivable account number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['output']
  /** Invoice statement dates for the account number */
  dates: Array<Scalars['Date']['output']>
}

/** A Ford Credit address */
export type Fmcc__Address = Address & {
  __typename?: 'fmcc__Address'
  /** The first line of the billing address. */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The second line of the billing address. */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** The third line of the billing address. */
  addressLine3?: Maybe<Scalars['String']['output']>
  /** The city name in the billing address. */
  city?: Maybe<Scalars['String']['output']>
  /** The country name in the billing address. */
  country?: Maybe<Scalars['String']['output']>
  /**
   * This field is deprecated use the field country.
   * @deprecated Use country instead.
   */
  countryCode?: Maybe<Scalars['String']['output']>
  /** The state in the billing address. */
  state?: Maybe<Scalars['String']['output']>
  /** The ZIP code in the billing address. */
  zip?: Maybe<Scalars['String']['output']>
}

/** Provides error messages from business */
export type Fmcc__CommonErrorResponse = {
  __typename?: 'fmcc__CommonErrorResponse'
  /** This is the error code returned by domain APIs. */
  code?: Maybe<Scalars['String']['output']>
  /** This field is resolved by localized message configured in AEM for the specified business code. */
  message?: Maybe<Scalars['String']['output']>
}

/** Root query type for types in the `fmcc` namespace. */
export type Fmcc__Query = {
  __typename?: 'fmcc__Query'
  /** Contains queries regarding account */
  account?: Maybe<Fmcc__Account__Query>
  /** Contains queries regarding bank */
  bank?: Maybe<Fmcc__Bank__Query>
  /** Contains queries regarding customers */
  customer?: Maybe<Fmcc__Customer__Query>
  /** Contains queries regarding documents */
  document?: Maybe<Fmcc__Document__Query>
  /** Contains queries regarding payment */
  payment?: Maybe<Fmcc__Payment__Query>
  /** Contains queries regarding statement */
  statement?: Maybe<Fmcc__Statement__Query>
  /** Contains queries regarding vehicles */
  vehicle?: Maybe<Fmcc__Vehicle__Query>
}

/**  Account Lease information  */
export type Fmcc__Account_LeaseInformation = {
  __typename?: 'fmcc__account_LeaseInformation'
  /**  No. of term months extended for the lease */
  termMonthsExtended?: Maybe<Scalars['Int']['output']>
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__Account = {
  __typename?: 'fmcc__account__Account'
  /** Returns account audit accrual includes non-sufficient fund information  */
  accountAuditAccrual?: Maybe<Fmcc__Account__AccountAuditAccrual>
  /** LA account status */
  accountStatus?: Maybe<Scalars['String']['output']>
  /** LA account status */
  accountStatusCode?: Maybe<Scalars['String']['output']>
  /** A list of all the transactions that have taken place on this account. */
  accountTransactionHistory?: Maybe<Array<Fmcc__Statement__AccountTransaction>>
  /** Total late charges assessed since account inception */
  accumulatedFeeAssessedIncept?: Maybe<Scalars['Float']['output']>
  /** Total other fees assessed since account inception */
  accumulatedOtherFeeAssessedIncept?: Maybe<Scalars['Float']['output']>
  /** Total other fees due amount */
  accumulatedOtherFeeDue?: Maybe<Scalars['Float']['output']>
  /** Returns account identification information */
  additionalInformation?: Maybe<Fmcc__Account__AdditionalInformation>
  addons?: Maybe<Array<Fc__Account__Addon>>
  /** Returns autoCollateral information */
  autoCollateral?: Maybe<Fmcc__Account__AutoCollateral>
  /** A code which describes the billing method */
  billingDefinitionMethod?: Maybe<Scalars['String']['output']>
  /** Populated if account marked as closed in LA, but not yet Archived */
  closedDate?: Maybe<Scalars['Date']['output']>
  /** Company indicator 1=FordCredit,2=PRIMUS */
  companyBusinessCode?: Maybe<Scalars['Int']['output']>
  /** Acquisition Cost for Lease, High Credit for Retail  */
  contractAmount?: Maybe<Scalars['Float']['output']>
  /** Specifies Country of loan origination */
  contractCountryCode?: Maybe<Country>
  /**
   * The total mileage for a lease vehicle as per contract. For US it is represented in miles. For CA it is in Kilometers.
   * The value is as is coming from account lookup service. No additional calculations or adjustments were made.
   */
  contractMileage?: Maybe<Scalars['Int']['output']>
  /** Represents Loan/Lease start date  */
  contractStartDate?: Maybe<Scalars['Date']['output']>
  /** Contract state */
  contractStateCode?: Maybe<Scalars['String']['output']>
  /** Number of months at inception */
  contractTermInMonths?: Maybe<Scalars['Int']['output']>
  /** Total length of account in months, may not be same as original due to extensions */
  currentTerm?: Maybe<Scalars['Int']['output']>
  /** Next unpaid due date. can be future or past dated */
  daysPastDue?: Maybe<Scalars['Int']['output']>
  /** Help to get the Dealer information */
  dealerDistributorLessorParentAccountNumber?: Maybe<Scalars['Int']['output']>
  /** Delinquency summary include days past due buckets  */
  delinquencySummary?: Maybe<Fmcc__Account__DelinquencySummary>
  /** Includes information about delinquent accounts, such as the Debt Manager phase and any pending cure notice date  */
  delinquentAccountInformation?: Maybe<Fmcc__Account__DelinquentAccountInformation>
  /** A paginated list of documents for this account. */
  documents?: Maybe<Fmcc__Document__DocumentMetadataPage>
  /** Total miles allowed during term of the lease. Includes original miles + contractual annual miles allowed */
  estimatedMileageKilometerNumber?: Maybe<Scalars['Int']['output']>
  /** Actual amount charged for prepaid mileage at lease termination */
  excessMileageKilometerPrepaidChargePerMile?: Maybe<Scalars['Float']['output']>
  /**
   * The charge for each mile or kilometer over the contract amount that is driven.
   * For US accounts, this is US dollars per mile.For CA accounts, this is CA dollars per kilometer.
   */
  excessMileageTerminationChargeRate?: Maybe<Scalars['Float']['output']>
  /** Contains information regarding payment extensions, lease end extensions, and due date changes */
  extensions?: Maybe<FcExtensionInformation>
  /** Amount of unpaid fees other than late charges */
  feesDue?: Maybe<Scalars['Float']['output']>
  /** Date last payment due */
  finalPaymentDate?: Maybe<Scalars['Date']['output']>
  /** Specifies financeLabel e.g.LINC-LincolnUS,FCUS=FordCreditUS,FCCA=FordCreditCanada */
  financeLabel?: Maybe<Scalars['String']['output']>
  /**
   * FinanceLabelName which is retrieved from Code Description Service.
   * If country and language are not provided, they will default to the
   * country being mapped to AccountCountryCode
   * and the language being mapped to WrittenLanguage.
   */
  financeLabelDescription?: Maybe<Scalars['String']['output']>
  /** Date first payment due */
  firstPaymentDueDate?: Maybe<Scalars['Date']['output']>
  /** ford account details */
  fordCreditSpecialPurchaseCode?: Maybe<Scalars['String']['output']>
  /** Address where vehicle is physically located, used for taxation purposes */
  garagingAddress?: Maybe<Fmcc__Account__Address>
  /** Provides historical vehicle equity information. */
  historicalVehicleEquity?: Maybe<FcHistoricalVehicleEquityResponse>
  /** Receivable account number */
  id?: Maybe<Scalars['fmcc__account__AccountNumber']['output']>
  /**
   * Indicates whether the account is its primary buyer's first lease.
   *
   * A "First-time lessee" is defined as a lessee with an active Red Carpet Lease (RCL) contract but no prior history with FMCC in the RCL product.
   */
  isFirstTimeLessee?: Maybe<Scalars['Boolean']['output']>
  /** Specifies if the account is of the type Lease. */
  isLease?: Maybe<Scalars['Boolean']['output']>
  /** Specifies if the account is of the type Retail. */
  isRetail?: Maybe<Scalars['Boolean']['output']>
  /** Specifies if the account is of the type Trac. */
  isTRAC?: Maybe<Scalars['Boolean']['output']>
  /** Date of last Delinquent extension */
  lastDelinquentExtendedDate?: Maybe<Scalars['Date']['output']>
  /** Amount of last payment applied to account */
  lastPaymentAmount?: Maybe<Scalars['Float']['output']>
  /** Date last payment due */
  lastPaymentDate?: Maybe<Scalars['Date']['output']>
  /** Prior year interest paid */
  lastYearToDateInterestPaid?: Maybe<Scalars['Float']['output']>
  /** Amount of unpaid late charges */
  lateChargeDue?: Maybe<Scalars['Float']['output']>
  /** Returns lease information of account */
  leaseInformation?: Maybe<Fmcc__Account_LeaseInformation>
  /** Contractual payment amount */
  leaseTotalPmt?: Maybe<Scalars['Float']['output']>
  /** Bankruptcy detai */
  legalStatusCd?: Maybe<Scalars['String']['output']>
  /**
   * Indicates if the vehicle has been bought back by Ford.
   *
   * This field will only be populated for lease accounts.
   */
  manufacturerRepurchaseIndicator?: Maybe<Scalars['Boolean']['output']>
  /** returns the applicable insure or accessory offer html for the receivable account number/vin */
  marketingOffer?: Maybe<Fc__Account__MarketingOffer>
  /** Represents Loan/Lease end date  */
  maturityDate?: Maybe<Scalars['Date']['output']>
  /** Account message code descriptions in same order as message type codes */
  messageTypeCodeDescriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Account Message detail */
  messageTypeCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Mileage status of a leased vehicle */
  mileageStatus?: Maybe<Fc__Account__MileageStatus>
  /** Next billing schedule due date, not the same as the actual due date on the account if delinquent or paid ahead */
  nextDueDate?: Maybe<Scalars['Date']['output']>
  /** Provides all the available statement dates */
  nonCombinedBillStatementDates?: Maybe<Array<Scalars['Date']['output']>>
  /** Number of contractual payments remaining */
  numberPaymentsRemaining?: Maybe<Scalars['Int']['output']>
  /** Contains information offerData request for myNextVehicle API */
  offerData?: Maybe<FcOffer>
  /** Acquisition cost for lease, High Credit for Retail */
  originalLoanAmount?: Maybe<Scalars['Float']['output']>
  /** Amount applied to next scheduled due amount if customer paid amounts different from scheduled monthly payment */
  partialPayment?: Maybe<Scalars['Float']['output']>
  /** The due date of the next payment */
  pastDueDate?: Maybe<Scalars['Date']['output']>
  /** The past payment due details for an account */
  paymentAggregate?: Maybe<Fc__Payment__PaymentAggregate>
  /** Provides the payment breakdown details based on account. */
  paymentBreakdown?: Maybe<Fmcc__Payment__PaymentBreakdown>
  /** Provides the payment utility details based on account. */
  paymentUtility?: Maybe<Fmcc__Payment__PaymentUtility>
  /** Provides details for Paying Off lease amount. */
  payoffDetails?: Maybe<Fmcc__Payment__PayOffDetails>
  /** Provides information about pending auto pay details. */
  pendingAutoPayDetails?: Maybe<Array<Fmcc__Payment__PendingAutoPayDetails>>
  /** Daily interest charge, Retail only */
  perDiem?: Maybe<Scalars['Float']['output']>
  /** Count of months extended since loan inception with Reason Code = P */
  perExtensions?: Maybe<Scalars['Int']['output']>
  /** Numeric Pinnacle Account Status, provides more options than LA account status codes */
  pinnacleAccountStatusCode?: Maybe<Scalars['Int']['output']>
  /** Quotient of excessMileageKilometerPurchasedAmount over excessMileageKilometerPrepaidChargePerMile */
  prePaidMilesOrKilometers?: Maybe<Scalars['Float']['output']>
  /** Contains information preferredVehicles request for myNextVehicle API */
  preferredVehicles?: Maybe<Array<Maybe<FcVehicleSelectionOffer>>>
  /** Specifies the same info as the financeLable, e.g.LINC-LincolnUS,FCUS=FordCreditUS,FCCA=FordCreditCanada */
  privateLabel?: Maybe<Scalars['String']['output']>
  /** Type of account e.g. LOI = Lease, RSI = Retail */
  productType?: Maybe<Scalars['String']['output']>
  /**
   * LaProductTypeCodeDescription which is retrieved from Code Description Service.
   * If country and language are not provided, they will default to the
   * country being mapped to AccountCountryCode
   * and the language being mapped to WrittenLanguage.
   */
  productTypeDescription?: Maybe<Scalars['String']['output']>
  /** Date of last Promo extension */
  promoLastExtendedDate?: Maybe<Scalars['Date']['output']>
  /** Purchase Option Amount */
  purchaseOptionAmount?: Maybe<Scalars['Float']['output']>
  /**
   * Do not use this field.
   * @deprecated Use `id`.
   */
  receivableAccountNumber?: Maybe<Scalars['fmcc__account__AccountNumber']['output']>
  /** Contractual Payment Amount  */
  scheduledPaymentAmount?: Maybe<Scalars['Float']['output']>
  /** Specifies the region the account was assigned to */
  serviceCenter?: Maybe<Scalars['String']['output']>
  /** Branch code the account is assigned to */
  servicingBranchCode?: Maybe<Scalars['String']['output']>
  /**
   * Tells whether the account is a single payment, balloon payment, or customer option plan.
   *
   * If it is `null`, the account is neither a balloon nor a single payment loan.
   */
  singleOrBalloonCode?: Maybe<SingleOrBalloonCode>
  /** Total payment and fees due amount (all fees in this example) */
  totalAmountDue?: Maybe<Scalars['Float']['output']>
  /** Remaining total due from customer (Lease only) */
  totalOutstandingBalanceAmount?: Maybe<Scalars['Float']['output']>
  /** Amount of unpaid charges */
  totalPastDueAmount?: Maybe<Scalars['Float']['output']>
  /** Difference between currentTerm and originalTerm */
  totalTermExtensionMonthCount?: Maybe<Scalars['Int']['output']>
  /**
   * A list of all the transactions that have taken place on this account
   *
   * This field is deprecated and has been removed from all lower environments. Please use `accountTransactionHistory` instead.
   * @deprecated Use `accountTransactionHistory`. This field has been removed from all lower environments.
   */
  transactionHistory?: Maybe<Array<Fmcc__Statement__TransactionHistory>>
  /** Provides the vehicle information  */
  vehicle?: Maybe<Fmcc__Vehicle__Vehicle>
  /**
   * An all-caps abbreviated representation of the vehicle make (e.g. `"FORD"`, `"LINC"`)
   *
   * Use this field as a fallback if `fmcc__vehicle__Vehicle.make` is not available (i.e. non-Ford vehicles).
   */
  vehicleMake?: Maybe<Scalars['String']['output']>
  /**
   * An all-caps abbreviated representation of the vehicle model (e.g. `"BRONSP"` for Bronco Sport)
   *
   * Use this field as a fallback if `fmcc__vehicle__Vehicle.model` is not available (i.e. non-Ford vehicles).
   */
  vehicleModel?: Maybe<Scalars['String']['output']>
  /** Use this field as a fallback if `fmcc__vehicle__Vehicle.year` is not available (i.e. non-Ford vehicles) */
  vehicleYear?: Maybe<Scalars['Int']['output']>
  /** Current year interest paid YTD */
  yearToDateInterestPaid?: Maybe<Scalars['Float']['output']>
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountAccountTransactionHistoryArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>
  startDate?: InputMaybe<Scalars['Date']['input']>
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountFinanceLabelDescriptionArgs = {
  country?: InputMaybe<Country>
  language?: InputMaybe<Scalars['String']['input']>
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountHistoricalVehicleEquityArgs = {
  applicantCode: ApplicantCode
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountOfferDataArgs = {
  input: FcOfferDataRequest
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountPayoffDetailsArgs = {
  effectiveDate?: InputMaybe<Scalars['Date']['input']>
  numberOfDays?: InputMaybe<Scalars['Int']['input']>
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountPreferredVehiclesArgs = {
  input: FcPreferredVehiclesInput
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountProductTypeDescriptionArgs = {
  country?: InputMaybe<Country>
  language?: InputMaybe<Scalars['String']['input']>
}

/** Return fields from account Lookup service response */
export type Fmcc__Account__AccountTransactionHistoryArgs = {
  accountType: AccountType
  endDate?: InputMaybe<Scalars['String']['input']>
  languageCode: LanguageCode
  startDate?: InputMaybe<Scalars['String']['input']>
}

/**  Account Audit Accrual includes non-sufficient fund information */
export type Fmcc__Account__AccountAuditAccrual = {
  __typename?: 'fmcc__account__AccountAuditAccrual'
  /** Count of times extended (not same as months) since loan inception with Reason Code = D */
  delinquencyNumberExtendedInceptionToDate?: Maybe<Scalars['Int']['output']>
  /** Date of last returned payment due to NSF */
  lastNonSufficientFundsDate?: Maybe<Scalars['Date']['output']>
  /** Count of times extended (not same as months) since loan inception with Reason Code = P */
  promotionNumberExtendedInceptionToDate?: Maybe<Scalars['Int']['output']>
  /** Count of returned payments due to NSF */
  timesNonSufficientFunds?: Maybe<Scalars['Int']['output']>
}

/** Additional information of the Account */
export type Fmcc__Account__AdditionalInformation = {
  __typename?: 'fmcc__account__AdditionalInformation'
  /** Provides annual percentage Rate detail */
  apr?: Maybe<Scalars['Float']['output']>
  /** The original loan amount */
  contractAmount?: Maybe<Scalars['Int']['output']>
  /** Disposal fee amount */
  disposalFeeAmount?: Maybe<Scalars['Int']['output']>
  /** User description */
  userDescription?: Maybe<Scalars['String']['output']>
}

/** Provides address details of the account */
export type Fmcc__Account__Address = Address & {
  __typename?: 'fmcc__account__Address'
  /** The first line of the garaging street address */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The second line of the garaging street address */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** The city name in the garaging address */
  city?: Maybe<Scalars['String']['output']>
  /** The country name in the garaging address */
  country?: Maybe<Scalars['String']['output']>
  /** The date at which this address was last changed, in yyyy-MM-dd format. */
  lastModifiedDate?: Maybe<Scalars['Date']['output']>
  /** The state in the garaging address */
  state?: Maybe<Scalars['String']['output']>
  /** The ZIP code in the garaging address */
  zip?: Maybe<Scalars['String']['output']>
}

/** A set of input parameters changing a Garaging Address */
export type Fmcc__Account__AddressInput = {
  /** The first line of the garaging street address */
  addressLine1: Scalars['String']['input']
  /** The second line of the garaging street address */
  addressLine2?: InputMaybe<Scalars['String']['input']>
  /** The city name in the garaging address */
  city: Scalars['String']['input']
  /** The country name in the garaging address */
  country: Scalars['String']['input']
  /** The state in the garaging address */
  state: Scalars['String']['input']
  /** The ZIP code in the garaging address */
  zip: Scalars['String']['input']
}

/** Auto Collateral information of the Account */
export type Fmcc__Account__AutoCollateral = {
  __typename?: 'fmcc__account__AutoCollateral'
  /** Ignition key code */
  ignitionKeyCode?: Maybe<Scalars['String']['output']>
  /** Licensing country */
  licenseCountry?: Maybe<Scalars['String']['output']>
  /** License plate information */
  licenseNumber?: Maybe<Scalars['String']['output']>
  /** Licensing state */
  licenseState?: Maybe<Scalars['String']['output']>
  /** Vehicle condition i.e. used or new */
  newUsedCode?: Maybe<Scalars['String']['output']>
  /** Nick name of customer */
  nickname?: Maybe<Scalars['String']['output']>
  /** Age of the vehicle in years at the time of purchase */
  originalAge?: Maybe<Scalars['Int']['output']>
  /** Trunk key code */
  trunkKeyCode?: Maybe<Scalars['String']['output']>
}

/** Delinquency summary include days past due buckets */
export type Fmcc__Account__DelinquencySummary = {
  __typename?: 'fmcc__account__DelinquencySummary'
  /**  Region Identifier Code in LA- FCNA, FCE, etc.  */
  controlNumber1?: Maybe<Scalars['Int']['output']>
  /**  Country Code Identifier in LA- US, Canada, etc  */
  controlNumber2?: Maybe<Scalars['Int']['output']>
  /**  Describes the delinquency status of the account  */
  creditBureauAccountStatusCode?: Maybe<Scalars['String']['output']>
  /**  Field provides ability to add specific comment codes related to credit bureau  */
  creditBureauCommentCode?: Maybe<Scalars['String']['output']>
  /**
   * Field allows for specific compliance codes related to credit bureau. These codes reflect a condition that is
   * required for legal compliance according to the Fair Credit Reporting Act (FCRA) or Fair Credit Billing Act (FCBA).
   */
  creditBureauComplianceCode?: Maybe<Scalars['String']['output']>
  /**  Date of the first 30-day delinquency that resulted in a change of account status. */
  creditBureauDelinquencyDate?: Maybe<Scalars['Date']['output']>
  /**
   * Similar to account status code. The payment rating populates always in LA but is reported to the credit bureau at
   * payoff or close of the account. The payment rating generally reflects the status of the account before it was paid off.
   */
  creditBureauPaymentRatingCode?: Maybe<Scalars['String']['output']>
  /**  Total payment amount reported to bureaus as 30 days past due  */
  currentAmountPastDue30?: Maybe<Scalars['Float']['output']>
  /**  Number of payments made 30-59 days late  */
  daysPastDue30?: Maybe<Scalars['Int']['output']>
  /**  Number of payments made 60-89 days late  */
  daysPastDue60?: Maybe<Scalars['Int']['output']>
  /**  Number of payments made 90-119 days late  */
  daysPastDue90?: Maybe<Scalars['Int']['output']>
  /**  Number of payments made 120-149 days late  */
  daysPastDue120?: Maybe<Scalars['Int']['output']>
  /**  Number of payments made 150-179 days late  */
  daysPastDue150?: Maybe<Scalars['Int']['output']>
  /**  Number of payments made 180+ days late  */
  daysPastDue180?: Maybe<Scalars['Int']['output']>
  /**  Count of total days extended current YTD. Ex. 1 mo extension would show 30 or 31  */
  delinquencyDaysExtendedYTD?: Maybe<Scalars['Int']['output']>
  /**  Number of months extended current YTD. Can vary from number of payments due to bi-weekly accounts  */
  delinquencyMonthsExtendedYTD?: Maybe<Scalars['Int']['output']>
  /**  Number of delinquency extensions (not months) current YTD  */
  delinquencyNumberExtendedYTD?: Maybe<Scalars['Int']['output']>
  /**  Number of payments extended current YTD  */
  delinquencyPaymentsExtendedYTD?: Maybe<Scalars['Int']['output']>
  /**  Oldest past due date at time of last extension processed  */
  dueDateAtLastExtension?: Maybe<Scalars['Date']['output']>
  /**  Number of payments made more than 11 days late  */
  pastDueCount?: Maybe<Scalars['Int']['output']>
  /**
   * Most recent data starts at pmtHistoryCd1. The first Cd1 represents the current account status
   * followed by the prior 24 months payment bureaus history. This information is reported to the credit bureaus.
   */
  pmtHistoryCd1?: Maybe<Scalars['String']['output']>
  pmtHistoryCd2?: Maybe<Scalars['String']['output']>
  pmtHistoryCd3?: Maybe<Scalars['String']['output']>
  pmtHistoryCd4?: Maybe<Scalars['String']['output']>
  pmtHistoryCd5?: Maybe<Scalars['String']['output']>
  pmtHistoryCd6?: Maybe<Scalars['String']['output']>
  pmtHistoryCd7?: Maybe<Scalars['String']['output']>
  pmtHistoryCd8?: Maybe<Scalars['String']['output']>
  pmtHistoryCd9?: Maybe<Scalars['String']['output']>
  pmtHistoryCd10?: Maybe<Scalars['String']['output']>
  pmtHistoryCd11?: Maybe<Scalars['String']['output']>
  pmtHistoryCd12?: Maybe<Scalars['String']['output']>
  pmtHistoryCd13?: Maybe<Scalars['String']['output']>
  pmtHistoryCd14?: Maybe<Scalars['String']['output']>
  pmtHistoryCd15?: Maybe<Scalars['String']['output']>
  pmtHistoryCd16?: Maybe<Scalars['String']['output']>
  pmtHistoryCd17?: Maybe<Scalars['String']['output']>
  pmtHistoryCd18?: Maybe<Scalars['String']['output']>
  pmtHistoryCd19?: Maybe<Scalars['String']['output']>
  pmtHistoryCd20?: Maybe<Scalars['String']['output']>
  pmtHistoryCd21?: Maybe<Scalars['String']['output']>
  pmtHistoryCd22?: Maybe<Scalars['String']['output']>
  pmtHistoryCd23?: Maybe<Scalars['String']['output']>
  pmtHistoryCd24?: Maybe<Scalars['String']['output']>
  pmtHistoryCd25?: Maybe<Scalars['String']['output']>
  /**  Number of Goodwill/Promotional payments extended current YTD  */
  promotionPaymentsExtendedYTD?: Maybe<Scalars['Int']['output']>
}

/** Delinquency Account Information */
export type Fmcc__Account__DelinquentAccountInformation = {
  __typename?: 'fmcc__account__DelinquentAccountInformation'
  /** Debt Manager call phase */
  debtManagerPhase?: Maybe<Scalars['Int']['output']>
  /** Populated if a cure date is pending due to a pre-repo notice */
  preRepossessionCureNoticeDate?: Maybe<Scalars['Date']['output']>
}

/** Input for updating the garaging address on account level */
export type Fmcc__Account__GaragingAddressRequest = {
  /** A set of input parameters changing a Garaging address */
  address: Fmcc__Account__AddressInput
  /** A set of input parameters common to many CRUD operations */
  parameters: Fmcc__Account__Parameters
}

/** Provides response for garaging address */
export type Fmcc__Account__GaragingAddressResponse = {
  __typename?: 'fmcc__account__GaragingAddressResponse'
  /** The HTTP status code for the garaging address response */
  code: Scalars['Int']['output']
  /** A set of output parameters changing a garaging address */
  garagingAddress?: Maybe<Fmcc__Account__Address>
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the garaging address change was successful */
  success: Scalars['Boolean']['output']
}

/** A set of input parameters common to many CRUD operations. */
export type Fmcc__Account__Parameters = {
  /** AccountNumber to get data from the downstream APIs referencing receivables system. Currently maps to receivable account number */
  accountNumber: Scalars['Int']['input']
  /** It represents the Pinnacle activity action code */
  activityActionCode: Scalars['Int']['input']
  /** It represents the Pinnacle category code */
  activityCategoryCode: Scalars['Int']['input']
  /** It represents the Pinnacle party code */
  activityPartyCode: Scalars['Int']['input']
  /** Represents whether a customer is the primary buyer or a co-buyer. */
  applicantCode: ApplicantCode
  /** It represents the Pinnacle comments. */
  comment: Scalars['String']['input']
  /** Company indicator 1=FordCredit,2=PRIMUS */
  companyBusinessCode: Scalars['Int']['input']
  /** It represents the Branch code entered */
  enteredBranchCode: Scalars['String']['input']
  /** It will usually be the CDSID of the user making the request. */
  requestUserID: Scalars['String']['input']
  /**
   * It represents the name of the app making the call
   * @deprecated This field is no longer used. Graph will pass the value from experience-id header to the domains
   */
  systemName?: InputMaybe<SystemName>
}

/** Returns Account details based on the account number or master customer number */
export type Fmcc__Account__Query = {
  __typename?: 'fmcc__account__Query'
  /** Provides the account data for the given account number */
  accountByAccountNumber?: Maybe<Fmcc__Account__Account>
  /** Provides data for all the accounts for the given master customer number */
  accountsByMCN?: Maybe<Array<Fc__Account__PinnacleAccount>>
}

/** Returns Account details based on the account number or master customer number */
export type Fmcc__Account__QueryAccountByAccountNumberArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
}

/** Returns Account details based on the account number or master customer number */
export type Fmcc__Account__QueryAccountsByMcnArgs = {
  mcn: Scalars['fc__customer__MCN']['input']
}

/** Input for updating the nick name on account level */
export type Fmcc__Account__UpdateNicknameRequest = {
  /** Account number to update nickname */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Company indicator 1=FordCredit,2=PRIMUS */
  companyBusinessCode: Scalars['Int']['input']
  /** Nick name of customer */
  nickname: Scalars['String']['input']
}

/** Update nick name response */
export type Fmcc__Account__UpdateNicknameResponse = {
  __typename?: 'fmcc__account__UpdateNicknameResponse'
  /** The HTTP status code for the update nick name response. */
  code: Scalars['Int']['output']
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the nick name change was successful. */
  success: Scalars['Boolean']['output']
}

/** Action indicates which type of change is requested, Possible values include INS (insert), UPD (update), or DEL (delete) */
export enum Fmcc__ActionEnum {
  /** delete */
  Del = 'DEL',
  /** insert */
  Ins = 'INS',
  /** update */
  Upd = 'UPD',
}

/** Input for adding the bank account */
export type Fmcc__Bank__AddBankAccountRequest = {
  /** Type of account e.g savings or checking */
  accountType: Scalars['String']['input']
  /** Name of the account holder */
  bankAccountHolderName: Scalars['String']['input']
  /** Nick name for the bank account */
  bankAccountNickName: Scalars['String']['input']
  /** Indicates the bank account number */
  bankAccountNumber: Scalars['String']['input']
  /** Indicates name of the bank */
  bankName?: InputMaybe<Scalars['String']['input']>
  /** Represents the country code */
  countryCode: Scalars['String']['input']
  /** Marks whether this is the user's default bank account. */
  isDefault: Scalars['Boolean']['input']
  /** Represents the master customer number */
  masterCustomerNumber: Scalars['Int']['input']
  /** Routing number provides the identity of the bank */
  routingNumber: Scalars['String']['input']
}

/** Response parameters for add bank account. */
export type Fmcc__Bank__AddBankAccountResponse = {
  __typename?: 'fmcc__bank__AddBankAccountResponse'
  /** Provides the bank account id which is generated when the customer adds a bank account */
  bankAccountId?: Maybe<Scalars['ID']['output']>
  /** The HTTP status code for the add bank account response. */
  code: Scalars['Int']['output']
  /** Provides error messages from business */
  errors?: Maybe<Array<Maybe<Fmcc__CommonErrorResponse>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the bank account added was successful. */
  success: Scalars['Boolean']['output']
}

/** This contains Bank account data for the given master customer number */
export type Fmcc__Bank__BankAccount = {
  __typename?: 'fmcc__bank__BankAccount'
  /** Type of account must be `savings` or `checking` */
  accountType?: Maybe<Scalars['String']['output']>
  /** Name of the bank account holder */
  bankAccountHolderName?: Maybe<Scalars['String']['output']>
  /** Nick name for the bank account */
  bankAccountNickName?: Maybe<Scalars['String']['output']>
  /** Indicates the bank account number */
  bankAccountNumber?: Maybe<Scalars['String']['output']>
  /** Indicates name of the bank */
  bankName?: Maybe<Scalars['String']['output']>
  /** Represents the country code */
  countryCode?: Maybe<Scalars['String']['output']>
  /** Bank account id is generated when a customer adds a bank account */
  id?: Maybe<Scalars['ID']['output']>
  /** Marks whether this is the user's default bank account. */
  isDefault?: Maybe<Scalars['Boolean']['output']>
  /** Routing number provides the identity of the bank */
  routingNumber?: Maybe<Scalars['String']['output']>
}

/** Input for deleting the bank account */
export type Fmcc__Bank__DeleteBankAccountRequest = {
  /** Provides the bank account id which was generated when the customer added the bank account */
  bankAccountId: Scalars['ID']['input']
  /** Represents the master customer number */
  masterCustomerNumber: Scalars['Int']['input']
}

/** Response parameters for a delete bank account. */
export type Fmcc__Bank__DeleteBankAccountResponse = {
  __typename?: 'fmcc__bank__DeleteBankAccountResponse'
  /** The HTTP status code for the delete bank account response. */
  code: Scalars['Int']['output']
  /** Returns specific details about the error if provided by downstream API. E.g in case of httpStatus 409 this will provide details of why the bank cannot be deleted */
  errorDetails?: Maybe<Array<Maybe<FcBankErrorDetails>>>
  /** Provides error messages from business */
  errors?: Maybe<Array<Maybe<Fmcc__CommonErrorResponse>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the bank account delete was successful. */
  success: Scalars['Boolean']['output']
}

/** Provides the bank information */
export type Fmcc__Bank__Query = {
  __typename?: 'fmcc__bank__Query'
  /** Provides the bank accounts for the given master customer number */
  bankAccounts?: Maybe<Array<Fmcc__Bank__BankAccount>>
  /** Provides the bank details for the given master customer number and bank account Id */
  bankDetails: Fmcc__Bank__BankAccount
}

/** Provides the bank information */
export type Fmcc__Bank__QueryBankAccountsArgs = {
  masterCustomerNumber: Scalars['Int']['input']
}

/** Provides the bank information */
export type Fmcc__Bank__QueryBankDetailsArgs = {
  bankAccountId: Scalars['ID']['input']
  masterCustomerNumber: Scalars['Int']['input']
}

/** Input for updating the bank account */
export type Fmcc__Bank__UpdateBankAccountRequest = {
  /** Provides the bank account id which was generated when the customer added the bank account */
  bankAccountId: Scalars['ID']['input']
  /** Nick name of the bank account */
  bankAccountNickName?: InputMaybe<Scalars['String']['input']>
  /** Marks whether this is the user's default bank account. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** Represents the master customer number */
  masterCustomerNumber: Scalars['Int']['input']
}

/** Response parameters for a update bank account. */
export type Fmcc__Bank__UpdateBankAccountResponse = {
  __typename?: 'fmcc__bank__UpdateBankAccountResponse'
  /** Provides the bank accounts for the given master customer number */
  bankAccount?: Maybe<Fmcc__Bank__BankAccount>
  /** The HTTP status code for the update bank account response. */
  code: Scalars['Int']['output']
  /** Provides error messages from business */
  errors?: Maybe<Array<Maybe<Fmcc__CommonErrorResponse>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the bank account change was successful. */
  success: Scalars['Boolean']['output']
}

/** A set of input parameters changing a customer's address. */
export type Fmcc__Customer__Address = {
  /** The first line of the customer's street address. */
  addressLine1: Scalars['String']['input']
  /** The second line of the customer's street address. */
  addressLine2?: InputMaybe<Scalars['String']['input']>
  /** The city name in the customer's address. */
  city: Scalars['String']['input']
  /** The country name in the customer's address. */
  country: Scalars['String']['input']
  /** The state in the customer's address. */
  state: Scalars['String']['input']
  /** The ZIP code in the customer's address. */
  zip: Scalars['String']['input']
}

/** A set of input parameters changing a customer's billing address. */
export type Fmcc__Customer__BillingAddressRequest = {
  /** A set of input parameters changing a customer's address. */
  address: Fmcc__Customer__Address
  /** A set of input parameters common to many CRUD operations. */
  parameters: Fmcc__Customer__Parameters
}

/** A set of response parameters for a billing address change. */
export type Fmcc__Customer__BillingAddressResponse = {
  __typename?: 'fmcc__customer__BillingAddressResponse'
  /** The HTTP status code for the billing address response. */
  code: Scalars['Int']['output']
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the billing address change was successful. */
  success: Scalars['Boolean']['output']
}

/** A set of input parameters for contact activity to log pinnacle system. */
export type Fmcc__Customer__ContactActivity = {
  /** Indicates the category of contact activity */
  category: Scalars['Int']['input']
  /** Represents the comments */
  comments: Scalars['String']['input']
  /** Indicates the reason of contact activity */
  reason: Scalars['Int']['input']
  /** Indicates the result of contact activity */
  result: Scalars['Int']['input']
  /** Indicates the root cause of contact activity */
  rootCause: Scalars['Int']['input']
  /** Indicates the type of contact activity */
  type: Scalars['Int']['input']
  /** Indicates the who type of contact activity */
  who: Scalars['Int']['input']
}

/** Provides the customer account relation details */
export type Fmcc__Customer__CustomerAccountRelation = {
  __typename?: 'fmcc__customer__CustomerAccountRelation'
  /** Provides the account information */
  account: Fmcc__Account__Account
  /** Represents whether a customer is the primary buyer or a co-buyer */
  applicantCode: ApplicantCode
  /** Provides the details of customer profile */
  customerProfile?: Maybe<Fmcc__Customer__CustomerProfile>
  /** Provides the experience qualification summary based on account number */
  experienceQualification?: Maybe<Fmcc__Customer__ExperienceQualification>
  /** Notification preferences based MCN and Customer accounts */
  notificationPreferences?: Maybe<Fc__Customer__NotificationPreferences>
  /** Represents the payment option to customer */
  paymentOptions?: Maybe<Array<Fmcc__Payment__PaymentOptions>>
  /** Represents the scheduled payment details to customer */
  scheduledPayments?: Maybe<Array<Fmcc__Payment__ScheduledPayment>>
}

/** Provides the information about the customer profile */
export type Fmcc__Customer__CustomerProfile = {
  __typename?: 'fmcc__customer__CustomerProfile'
  /** The list of accounts associated with the customer that owns this profile. */
  accounts?: Maybe<Array<Fmcc__Account__Account>>
  /** Provides the bank accounts for the given master customer number */
  bankAccounts?: Maybe<Array<Fmcc__Bank__BankAccount>>
  /** Billing address of the customer */
  billingAddress?: Maybe<Fc__Customer__BillingAddress>
  /** The customer's birth date */
  birthDate?: Maybe<Scalars['Date']['output']>
  /** Provides all the available Combined Billing statement dates for the given `receivableCustomerNumber` and `billGroupNumber` */
  combinedBillStatementDates?: Maybe<Array<Maybe<Fmcc__Statement__CombinedBillStatementDate>>>
  /** If true, the customer is shown the commercial experience in Account Manager */
  commercialExperienceIndicator?: Maybe<Scalars['Boolean']['output']>
  /** The company name of the customer */
  companyName?: Maybe<Scalars['String']['output']>
  /** The country name in the customer profile */
  country?: Maybe<Scalars['String']['output']>
  /** Customer Country Code */
  customerCountryCode?: Maybe<Scalars['String']['output']>
  /** Customer Type */
  customerType?: Maybe<Fc__Customer__CustomerType>
  /** A list of digital communication channels (emails or mobile push notifications) set up for the customer */
  digitalCommunications?: Maybe<Array<Fc__Customer__DigitalCommunication>>
  /**
   * Email address of customer in the customer profile
   * @deprecated Use `digitalCommunications.text` instead.
   */
  emailAddress?: Maybe<Scalars['String']['output']>
  /** First name of the customer in the customer profile */
  firstName?: Maybe<Scalars['String']['output']>
  /** Generation */
  generation?: Maybe<Scalars['String']['output']>
  /** Customer Id */
  id: Scalars['fmcc__customer__CustomerID']['output']
  /** Last name of the customer in the customer profile */
  lastName?: Maybe<Scalars['String']['output']>
  /** Master customer number of the customer */
  masterCustomerNumber?: Maybe<Scalars['Int']['output']>
  /** multi Payment information available to the customer */
  multiPaymentInformation?: Maybe<Fmcc__Payment__MultiPaymentInformation>
  /** multiPayment information available to the customer using stream endpoint. */
  multiPaymentStreamInformation?: Maybe<Fmcc__Payment__MultiPaymentStreamInformation>
  /** Probability of payment applicant percent */
  paymentProbabilityPercentage?: Maybe<Scalars['Int']['output']>
  /** Probability of payment rescore percent */
  paymentRescorePercentage?: Maybe<Scalars['Int']['output']>
  /** Phone numbers of the customer */
  phoneNumbers?: Maybe<Array<Fmcc__PhoneNumber>>
  /** Receivable customer number of the customer */
  receivableCustomerNumber?: Maybe<Scalars['String']['output']>
  /** Title */
  title?: Maybe<Scalars['String']['output']>
  /** Written Language of Choice Code */
  writtenLanguageOfChoiceCode?: Maybe<Scalars['String']['output']>
}

/** Provides the information about the customer profile */
export type Fmcc__Customer__CustomerProfileCombinedBillStatementDatesArgs = {
  billGroupNumber: Scalars['Int']['input']
}

/** A set of input parameters changing a customer's email. */
export type Fmcc__Customer__EmailRequest = {
  /** A set of input parameters changing a customer's email address. */
  emailRequest: Fmcc__Customer__EmailRequestInput
  /** A set of input parameters common to many CRUD operations. */
  parameters: Fmcc__Customer__Parameters
}

/** A set of input parameters changing a customer's email address. */
export type Fmcc__Customer__EmailRequestInput = {
  /** A value indicating which type of change is requested for the email address. Possible values include INS (insert), UPD (update), or DEL (delete) */
  action: Fmcc__ActionEnum
  /** The new email address. */
  emailAddress: Scalars['String']['input']
}

/** A set of response parameters for an email address change. */
export type Fmcc__Customer__EmailResponse = {
  __typename?: 'fmcc__customer__EmailResponse'
  /** The HTTP status code for the email address response. */
  code: Scalars['Int']['output']
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the email address change was successful. */
  success: Scalars['Boolean']['output']
}

/** Provides the experience qualification summary based on account number */
export type Fmcc__Customer__ExperienceQualification = {
  __typename?: 'fmcc__customer__ExperienceQualification'
  /** Specifies if the customer is a commercial account */
  commercial?: Maybe<Scalars['Boolean']['output']>
  /** Specifies if the customer is qualified to login */
  login?: Maybe<Scalars['Boolean']['output']>
}

/** A set of input parameters common to many CRUD operations. */
export type Fmcc__Customer__Parameters = {
  /** AccountNumber to get data from the downstream APIs referencing receivables system. Currently maps to receivable account number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Represents whether a customer is the primary buyer or a co-buyer. */
  applicantCode: ApplicantCode
  /** Represents the source code for an application */
  applicationSourceCode: Fc__ApplicationSourceCode
  /**
   * Represents the branch code in case of transaction originating from Contact centers
   * For online transactions, this will be agreed upon value between the domain and the experience
   * e.g MR for account manager WEB
   */
  branchCode: Scalars['String']['input']
  /** The companyBusinessCode changes based on country, and it's always 1 in USA or CAN */
  companyBusinessCode: Scalars['Int']['input']
  /** parameters for logging pinnacle contact activity */
  contactActivity: Fmcc__Customer__ContactActivity
  /** This is either CDS ID for agent initiated workflow or application name to represent the system originating the transaction */
  requestUserID: Scalars['String']['input']
  /**
   * It represents the name of the app making the call
   * @deprecated This field is no longer used. Graph will pass the value from experience-id header to the domains
   */
  systemName?: InputMaybe<Scalars['String']['input']>
}

/** A set of input parameters for a phone number. */
export type Fmcc__Customer__Phone = {
  /** Indicates whether this phone is a mobile phone or a landline phone. */
  category?: InputMaybe<Fmcc__PhoneCategory>
  /** Indicates whether this is a home phone, work phone, or other. */
  location: Fmcc__PhoneLocation
  /**
   * The three digit area code of the phone number.
   * For example, if the full phone number is 313-555-1234, the `phoneAreaCode` will be `"313"`.
   */
  phoneAreaCode: Scalars['String']['input']
  /** Represents the extension of the phone number. */
  phoneExtension?: InputMaybe<Scalars['String']['input']>
  /**
   * The unformatted phone number, excluding the area code.
   * For example, if the full phone number is 313-555-1234, the `phoneNumber` will be `"5551234"`.
   */
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  /**
   * Represents the order that this phone number appears in.
   * For example the phone number with sequence number 2 is the second phone number in the list.
   */
  sequenceNumber: Scalars['Int']['input']
}

/** A set of input parameters changing a customer's phone number */
export type Fmcc__Customer__PhoneRequest = {
  /** A set of input parameters common to many CRUD operations. */
  parameters: Fmcc__Customer__Parameters
  /** A set of input parameters changing a customer's phone number. */
  phoneRequest: Array<Fmcc__Customer__PhoneRequestInput>
}

/** A set of input parameters changing a customer's phone number */
export type Fmcc__Customer__PhoneRequestInput = {
  /** A value indicating which type of change is requested for phone. Possible values include INS (insert), UPD (update), or DEL (delete) */
  action: Fmcc__ActionEnum
  /** A set of input parameters for a phone number. */
  phone: Fmcc__Customer__Phone
}

/** A set of response parameters for a phone number change. */
export type Fmcc__Customer__PhoneResponse = {
  __typename?: 'fmcc__customer__PhoneResponse'
  /** The HTTP status code for the phone number response. */
  code: Scalars['Int']['output']
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the phone number change was successful. */
  success: Scalars['Boolean']['output']
}

/** Queries relating to customers */
export type Fmcc__Customer__Query = {
  __typename?: 'fmcc__customer__Query'
  /** Commercial line of credit data based on FinSimple customer's MCN */
  clocModule?: Maybe<FcCustomerCloc>
  /** Migration Status for Commercial FinSimple customers */
  commercialMigrationStatus?: Maybe<FcCommercialMigrationStatus>
  /** Notifications for a commercial FinSimple customer */
  commercialNotifications?: Maybe<Array<Maybe<FcCommercialNotification>>>
  /** Customer registration completion status along with their MCN based on user id */
  commercialRegistrationStatus?: Maybe<Fc__Customer__CommercialRegistrationStatus>
  /**
   * Returns which Account Manager experience is allowed for a user ID.
   * Domain is resolving the User ID using CCN user-profile based on reference-id header.
   */
  commercialUserExperience?: Maybe<Scalars['String']['output']>
  /** Customer account relation based on the account number */
  customerAccountRelation?: Maybe<Fmcc__Customer__CustomerAccountRelation>
  /** Total available points to redeem for Ford and Lincoln reward programs */
  rewardPoints: Fc__Customer__RewardPointsSummary
  /** Unified billing summary based customer's MCN */
  unifiedBillingSummary?: Maybe<Fc__Customer__UnifiedBillingSummary>
}

/** Queries relating to customers */
export type Fmcc__Customer__QueryClocModuleArgs = {
  mcn: Scalars['fc__customer__MCN']['input']
}

/** Queries relating to customers */
export type Fmcc__Customer__QueryCommercialRegistrationStatusArgs = {
  userId: Scalars['String']['input']
}

/** Queries relating to customers */
export type Fmcc__Customer__QueryCustomerAccountRelationArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  applicantCode: ApplicantCode
}

/** Queries relating to customers */
export type Fmcc__Customer__QueryRewardPointsArgs = {
  customerGUID: Scalars['String']['input']
  programCountry: Country
}

/** Queries relating to customers */
export type Fmcc__Customer__QueryUnifiedBillingSummaryArgs = {
  mcn: Scalars['fc__customer__MCN']['input']
}

/** Documents metadata for update contract from new endpoint */
export type Fmcc__Document__DocumentMetadata = {
  __typename?: 'fmcc__document__DocumentMetadata'
  /**
   * Name of the document which customer rep or user put it before
   * Uploading the document
   */
  displayName?: Maybe<Scalars['String']['output']>
  /** Actual file name which was uploaded */
  fileName?: Maybe<Scalars['String']['output']>
  /** Absolute URL of the file which was uploaded */
  locationUrl?: Maybe<Scalars['String']['output']>
  /** The time document was uploaded */
  timestamp?: Maybe<Scalars['String']['output']>
  /** represents documents type */
  typeCode?: Maybe<Scalars['String']['output']>
  /** Human readable description of the document type code */
  typeDescription?: Maybe<Scalars['String']['output']>
}

/** A paginated document response. Contains a list of documents, along with pagination data. */
export type Fmcc__Document__DocumentMetadataPage = {
  __typename?: 'fmcc__document__DocumentMetadataPage'
  /** The documents in this page. */
  content?: Maybe<Array<Fmcc__Document__DocumentMetadata>>
  /** Indicates whether it has next page or not. */
  hasNextPage: Scalars['Boolean']['output']
  /** Indicates whether it has previous page or not. */
  hasPreviousPage: Scalars['Boolean']['output']
  /**
   * The zero-indexed page number.
   * If pagination is requested, this will be the requested page number.
   * If no pagination is requested, this will be null.
   */
  pageNumber?: Maybe<Scalars['Int']['output']>
  /**
   * The number of documents in each page.
   * If pagination is requested, this will be the requested page size.
   * If no pagination is requested, this will be null.
   */
  pageSize?: Maybe<Scalars['Int']['output']>
  /** The total number of documents across all pages. */
  totalElements: Scalars['Int']['output']
  /**
   * The total number of pages of the requested size.
   * If no pagination is requested, this will be null.
   */
  totalPages?: Maybe<Scalars['Int']['output']>
}

/** Contains queries regarding documents */
export type Fmcc__Document__Query = {
  __typename?: 'fmcc__document__Query'
  /** A paginated list of documents for the given account. */
  documents?: Maybe<Fmcc__Document__DocumentMetadataPage>
}

/** Contains queries regarding documents */
export type Fmcc__Document__QueryDocumentsArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  pagination?: InputMaybe<PaginationInput>
}

/** Response status and data from canceling auto-payment */
export type Fmcc__Payment__CancelAutoPayResponse = {
  __typename?: 'fmcc__payment__CancelAutoPayResponse'
  /**
   * Confirmation numbers of the canceled payments for each affected account.
   * This field will not be present if the mutation was unsuccessful.
   */
  cancelAutoPayment?: Maybe<Array<Maybe<Fmcc__Payment__CancelAutoPayment>>>
  /** The HTTP status code for the cancel autoPay response. */
  code: Scalars['Int']['output']
  /** If the request is not successful, this will contain a list of error codes from the payment API. */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** Provides error messages from business */
  errors?: Maybe<Array<Maybe<Fmcc__CommonErrorResponse>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the cancelled autoPay was successful. */
  success: Scalars['Boolean']['output']
}

/** Confirmation of autopay cancelation. This is returned to the user when they cancel autopay. */
export type Fmcc__Payment__CancelAutoPayment = {
  __typename?: 'fmcc__payment__CancelAutoPayment'
  /** The receivable account number of the account that the new payment is applied to. */
  accountNumber?: Maybe<Scalars['Int']['output']>
  /** It is an unique number for the confirmed payment */
  paymentConfirmationNumber?: Maybe<Scalars['String']['output']>
}

/** Eligibility details available to the customer */
export type Fmcc__Payment__EligibilityDetails = {
  __typename?: 'fmcc__payment__EligibilityDetails'
  /** Customer eligibility status to enroll in automatic payment */
  autoPayEligibilityStatus?: Maybe<Fmcc_Payment_EligibilityStatus>
  /** Account delinquency days past due details */
  daysPastDueDetails?: Maybe<FcDaysPastDueDetails>
  /** Customer eligibility status to make payments */
  eligibilityStatus?: Maybe<Fmcc_Payment_EligibilityStatus>
  /** Payment options available to the customer. */
  eligiblePaymentOptions?: Maybe<Array<Maybe<Fmcc__Payment__EligiblePaymentOption>>>
  /** Indicating whether the account is Active or Not */
  isAccountActive?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is closed or Not */
  isAccountClosed?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is Delinquent or not */
  isAccountDelinquentCheck?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account has previous due amount greater than 0 */
  isAccountPastDue?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is eligible for repossession or not */
  isAccountRepossessionCheck?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is enrolled for auto pay or Not */
  isAutoPayEnrolled?: Maybe<Scalars['Boolean']['output']>
  /** Returns True/False if the account is in Freeze window for automatic payment. */
  isAutoPayInFreezingWindow?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether It is Borrower or Not */
  isBorrower?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is CombinedBillingAccount or Not */
  isCombinedBillingAccount?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is Commercial lease or not */
  isCommercialLeaseCheck?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is ContractorAssigned or Not */
  isContractorAssigned?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether Bankruptcy or Not */
  isInBankruptcy?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is paid off or Not */
  isPaidOffAccount?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the Payment is Scheduled or Not */
  isPaymentScheduled?: Maybe<Scalars['Boolean']['output']>
  /** Indicating whether the account is PayrollDeduct or Not */
  isPayrollDeduct?: Maybe<Scalars['Boolean']['output']>
}

/** Eligibility error available to the customer */
export type Fmcc__Payment__EligibilityError = {
  __typename?: 'fmcc__payment__EligibilityError'
  errorCode?: Maybe<Scalars['String']['output']>
  /** A human-readable description of the error. */
  errorCodeDescription?: Maybe<Scalars['String']['output']>
}

/** Payment Eligible Options */
export type Fmcc__Payment__EligiblePaymentOption = {
  __typename?: 'fmcc__payment__EligiblePaymentOption'
  /** Maximum Payment Amount */
  maximumPaymentAmount?: Maybe<Scalars['Float']['output']>
  /** Minimum Payment Amount */
  minimumPaymentAmount?: Maybe<Scalars['Float']['output']>
  /** Payment eligibility dates */
  paymentEligibleDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>
  /** Payment Option (e.g. OTHER, PREVIOUS_DUE, PRINCIPAL_ONLY, TOTAL_AMOUNT_DUE, TOTAL_AMOUNT_DUE_AND_PRINCIPAL) */
  paymentOption?: Maybe<Scalars['String']['output']>
}

/**  Enroll AutoPay Payment Request Object  */
export type Fmcc__Payment__EnrollAutoPayRequest = {
  /** AccountNumber to get data from the downstream APIs referencing receivables system.Currently maps to receivable account number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** The client must provide bank account Id value for which the payment transactions are being performed. */
  bankAccountId?: InputMaybe<Scalars['Int']['input']>
  /** The client must provide the electronic consent for all types of payment. */
  hasElectronicPaymentConsent?: InputMaybe<Scalars['Boolean']['input']>
  /** The client must provide the payment agreement required for all types of payment. */
  isPaymentAgreementRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** The client must provide buyer or co-buyer source customer number value which is associated with the specific receivable account number. */
  masterCustomerNumber: Scalars['String']['input']
}

/** Enroll Autopay mutation response status and confirmation */
export type Fmcc__Payment__EnrollAutoPayResponse = {
  __typename?: 'fmcc__payment__EnrollAutoPayResponse'
  /** The HTTP status code for the enroll auto pay response. */
  code: Scalars['Int']['output']
  /** Enroll AutoPay Response Object. This will not be present if the mutation was not successful. */
  enrollAutoPaymentResponse?: Maybe<Fmcc__Payment__EnrollAutoPaymentResponse>
  /** If the request is not successful, this will contain a list of error codes from the payment API. */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** Provides error messages from business */
  errors?: Maybe<Array<Maybe<Fmcc__CommonErrorResponse>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the enroll auto pay was successful. */
  success: Scalars['Boolean']['output']
}

/**  Enroll AutoPay Response Object  */
export type Fmcc__Payment__EnrollAutoPaymentResponse = {
  __typename?: 'fmcc__payment__EnrollAutoPaymentResponse'
  /** AccountNumber to get data from the downstream APIs referencing receivables system.Currently maps to receivable account number */
  accountNumber?: Maybe<Scalars['fmcc__account__AccountNumber']['output']>
  /** Bank account nick name of the autopay. */
  bankAccountNickName?: Maybe<Scalars['String']['output']>
  /** Masked bank account number of the autopay. */
  bankAccountNumber?: Maybe<Scalars['String']['output']>
  /** Bank account type of the autopay. */
  bankAccountType?: Maybe<Scalars['String']['output']>
  /** Next due date of the autopay. */
  nextDueDate?: Maybe<Scalars['Date']['output']>
  /** Generated document url of the scheduled payment. */
  paymentAgreementUri?: Maybe<Scalars['String']['output']>
  /** Payment Confirmation Number Value. */
  paymentConfirmationNumber?: Maybe<Scalars['String']['output']>
}

/** Multi Payoff details available to the customer */
export type Fmcc__Payment__MultiPayOffDetails = {
  __typename?: 'fmcc__payment__MultiPayOffDetails'
  /** Maximum PaidOff Amount */
  maximumPayOffAmount?: Maybe<Scalars['Float']['output']>
  /** Minimum PaidOff Amount */
  minimumPayOffAmount?: Maybe<Scalars['Float']['output']>
  /** PaidOff Amount detail */
  payOffAmount?: Maybe<Scalars['Float']['output']>
  /** Paid Change Date */
  payOffChangeDate?: Maybe<Scalars['Date']['output']>
  /** PaidOff Daily Amount */
  payOffDailyAmount?: Maybe<Scalars['Float']['output']>
  /** Principal Balance Payment */
  principalBalance?: Maybe<Scalars['Float']['output']>
}

/** multi Payment fields available to the customer */
export type Fmcc__Payment__MultiPaymentAccountInformation = {
  __typename?: 'fmcc__payment__MultiPaymentAccountInformation'
  /** Provides the account Information */
  account?: Maybe<Fmcc__Account__Account>
  /** Bill Group Detail */
  billGroup?: Maybe<Scalars['String']['output']>
  /** Provides the multipayment pay off details */
  payOffDetails?: Maybe<Fmcc__Payment__MultiPayOffDetails>
  /** Due date of next payment */
  paymentDueDate?: Maybe<Scalars['Date']['output']>
  /** Payment eligibility details */
  paymentEligibilityDetails?: Maybe<Fmcc__Payment__EligibilityDetails>
  /** Provides previous due amount */
  previousDueAmount?: Maybe<Scalars['Float']['output']>
  /** Provides the receivable customer number */
  receivableCustomerNumber?: Maybe<Scalars['Long']['output']>
  /** Provides the scheduled payment details */
  scheduledPaymentDetails?: Maybe<Array<Maybe<Fmcc__Payment__ScheduledPaymentDetails>>>
  /** Total payment and fees due in the next payment */
  totalAmountDue?: Maybe<Scalars['Float']['output']>
}

/** multi Payment information available to the customer */
export type Fmcc__Payment__MultiPaymentInformation = {
  __typename?: 'fmcc__payment__MultiPaymentInformation'
  /** Cumulative Amount Due */
  cumulativeAmountDue?: Maybe<Scalars['Float']['output']>
  /**  Multi Payment fields available to the customer  */
  multiPaymentAccountInformation?: Maybe<Array<Maybe<Fmcc__Payment__MultiPaymentAccountInformation>>>
}

/** multi Payment information available to the customer using stream endpoint */
export type Fmcc__Payment__MultiPaymentStreamInformation = {
  __typename?: 'fmcc__payment__MultiPaymentStreamInformation'
  /** Cumulative Amount Due */
  cumulativeAmountDue?: Maybe<Scalars['Float']['output']>
  /**  Multi Payment fields available to the customer  */
  multiPaymentAccountInformation?: Maybe<Array<Maybe<Fmcc__Payment__MultiPaymentAccountInformation>>>
}

/** Pay off details available to the customer. */
export type Fmcc__Payment__PayOffDetails = {
  __typename?: 'fmcc__payment__PayOffDetails'
  /** The sum of `payoffAmount` and the dealer markup amount. */
  customerPurchasePrice?: Maybe<Scalars['Float']['output']>
  /**
   * If the account is not eligible for payoff, this list will be populated with a list
   * of failed eligibility rules, and all other payoff fields will be `null`. Otherwise,
   * if the account is eligible for payoff, this list will be `null`.
   */
  failedRules?: Maybe<Array<Fc__Payment__PayoffFailedRule>>
  /** Represents good thru date. */
  goodThruDate?: Maybe<Scalars['Date']['output']>
  /** Provides late charge apply amount. */
  lateChargeApplyAmount?: Maybe<Scalars['Float']['output']>
  /** Provides late charge current balance. */
  lateChargeCurrentBalance?: Maybe<Scalars['Float']['output']>
  /** Indicates lease requires security deposit. */
  leaseRequiredSecurityDeposit?: Maybe<Scalars['Float']['output']>
  /** Represents original scheduled termination date. */
  originalScheduledTerminationDate?: Maybe<Scalars['Date']['output']>
  /** The amount to be paid off. This does not include the dealer markup amount. */
  payoffAmount?: Maybe<Scalars['Float']['output']>
  /** Represents the product type. */
  productType?: Maybe<Scalars['String']['output']>
}

/** Payment break down details available to the customer */
export type Fmcc__Payment__PaymentBreakdown = {
  __typename?: 'fmcc__payment__PaymentBreakdown'
  /** Indicates whether account is enrolled in autoPay */
  autoDebitIndicator?: Maybe<Scalars['Boolean']['output']>
  /**
   * Provides the next due date.
   *
   * This field is deprecated. Use `nextPaymentDueDate`, which enforces the standard date format. This field has been from lower environments.
   * @deprecated Use `nextPaymentDueDate`, which enforces the standard date format. This field has been removed from lower environments.
   */
  nextDueDate?: Maybe<Scalars['String']['output']>
  /** The date when the next payment is due */
  nextPaymentDueDate?: Maybe<Scalars['Date']['output']>
  /** Provides the previous due amount. */
  previousDueAmount?: Maybe<Scalars['Float']['output']>
  /** Provides the principal balance. */
  principalBalance?: Maybe<Scalars['Float']['output']>
  /** Provides the total amount due. */
  totalAmountDue?: Maybe<Scalars['Float']['output']>
}

/** Confirmation of a scheduled payment. This is returned to the user when they schedule a payment. */
export type Fmcc__Payment__PaymentConfirmationResponse = {
  __typename?: 'fmcc__payment__PaymentConfirmationResponse'
  /** The receivable account number of the account that the new payment is applied to. */
  accountNumber?: Maybe<Scalars['String']['output']>
  /** The payment type applied  */
  ceftPaymentType?: Maybe<Scalars['String']['output']>
  /** The confirmation number of the payment. */
  confirmationNumber?: Maybe<Scalars['String']['output']>
  /** The bank account number of the account that the new payment is applied to. */
  maskedBankAccount?: Maybe<Scalars['String']['output']>
  /**
   * DEPRECATED. This field is always null. It has been removed from lower environments.
   * @deprecated This field is always null. It has been removed from lower environments.
   */
  nextAutoDebitDate?: Maybe<Scalars['String']['output']>
  /** The payment Type for the scheduled payment. */
  paymentType?: Maybe<Scalars['String']['output']>
  /** The amount of the payment scheduled */
  scheduledAmount?: Maybe<Scalars['Float']['output']>
  /** The date the payment is scheduled for */
  scheduledDate?: Maybe<Scalars['Date']['output']>
}

/** A payment option available to the customer. */
export type Fmcc__Payment__PaymentOptions = {
  __typename?: 'fmcc__payment__PaymentOptions'
  /** Represents the type of currency. */
  currency?: Maybe<Scalars['String']['output']>
  /** A single payment can only be scheduled on one of these dates */
  eligibleDates?: Maybe<Array<Scalars['Date']['output']>>
  /** Provides the maximum payment amount. */
  maximumPaymentAmount?: Maybe<Scalars['Float']['output']>
  /** Provides the minimum payment amount. */
  minimumPaymentAmount?: Maybe<Scalars['Float']['output']>
  /**
   * Provides the payment eligible dates.
   *
   * This field is deprecated. Use `eligibleDates`, which enforces the standard format. This field has been removed from lower environments.
   * @deprecated Use `eligibleDates`, which enforces the standard format. This field has been removed from lower environments.
   */
  paymentEligibleDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Provides the Payment option. */
  paymentOption?: Maybe<Scalars['String']['output']>
  /** Provides the total amount due. */
  totalAmountDue?: Maybe<Scalars['Float']['output']>
}

/** Payment utility fields available to the customer. */
export type Fmcc__Payment__PaymentUtility = {
  __typename?: 'fmcc__payment__PaymentUtility'
  /** Number of payments made by the customer on Loan/Lease account */
  numberOfPaymentsMade?: Maybe<Scalars['Int']['output']>
  /** Number of payments remaining to be made by the customer on Loan/Lease account */
  numberOfPaymentsRemaining?: Maybe<Scalars['Int']['output']>
  /** Payment progress for the existing Loan/Lease account */
  paymentProgress?: Maybe<Scalars['Float']['output']>
  /** Total number of payment as per the contract */
  totalNumberOfPayments?: Maybe<Scalars['Int']['output']>
}

/** Provides the information about pending auto pay details. */
export type Fmcc__Payment__PendingAutoPayDetails = {
  __typename?: 'fmcc__payment__PendingAutoPayDetails'
  /** Provides the bank account nick name. */
  bankAccountNickName?: Maybe<Scalars['String']['output']>
  /** Provides the bank account number. */
  bankAccountNumber?: Maybe<Scalars['String']['output']>
  /** Provides the bank account type. */
  bankAccountType?: Maybe<Scalars['String']['output']>
  /**
   * Represents the next due date.
   *
   * This field is deprecated. Use `nextPaymentDueDate`, which enforces the standard date format. This field has been removed from lower environments.
   * @deprecated Use `nextPaymentDueDate`, which enforces the standard date format. This field has been removed from lower environments.
   */
  nextDueDate?: Maybe<Scalars['String']['output']>
  /** The date when the next payment is due */
  nextPaymentDueDate?: Maybe<Scalars['Date']['output']>
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__Query = {
  __typename?: 'fmcc__payment__Query'
  /** Provides the detail, if the account is eligible for Auto Pay and if the account is in the freeze window. */
  autoPayEligibility?: Maybe<Fc__Payment__AutoPayEligibility>
  /** multiPayment information available to the customer. */
  multiPaymentInformation?: Maybe<Fmcc__Payment__MultiPaymentInformation>
  /** multiPayment information available to the customer using stream endpoint. */
  multiPaymentStreamInformation?: Maybe<Fmcc__Payment__MultiPaymentStreamInformation>
  /** The past payment due details for an account */
  paymentAggregate?: Maybe<Fc__Payment__PaymentAggregate>
  /** Provides the payment breakdown details for a specific customer based on the receivable account number. */
  paymentBreakdown?: Maybe<Fmcc__Payment__PaymentBreakdown>
  /** Provides all the eligible Payment Options, Dates, Amounts for a specific customer based on receivable account number. */
  paymentOptions?: Maybe<Array<Fmcc__Payment__PaymentOptions>>
  /** Provides the number of payments made, payments remaining, total number of payments and payment progress for a specific customer based on the receivable account number. */
  paymentUtility?: Maybe<Fmcc__Payment__PaymentUtility>
  /** Provides details for Paying Off lease amount. */
  payoffDetails?: Maybe<Fmcc__Payment__PayOffDetails>
  /** Provides information about pending auto pay details. */
  pendingAutoPayDetails?: Maybe<Array<Fmcc__Payment__PendingAutoPayDetails>>
  /** Provides all scheduledPayments detail for a specific customer based on receivable account number. */
  scheduledPayments?: Maybe<Array<Fmcc__Payment__ScheduledPayment>>
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryAutoPayEligibilityArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  applicantCode: ApplicantCode
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryMultiPaymentInformationArgs = {
  country: Country
  masterCustomerNumber: Scalars['Int']['input']
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryMultiPaymentStreamInformationArgs = {
  country: Country
  masterCustomerNumber: Scalars['Int']['input']
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryPaymentAggregateArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryPaymentBreakdownArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryPaymentOptionsArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  applicantCode: ApplicantCode
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryPaymentUtilityArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryPayoffDetailsArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  effectiveDate?: InputMaybe<Scalars['Date']['input']>
  numberOfDays?: InputMaybe<Scalars['Int']['input']>
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryPendingAutoPayDetailsArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
}

/** "Root-level" queries in the payment namespace. */
export type Fmcc__Payment__QueryScheduledPaymentsArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
}

/** A set of parameters for scheduling single payment request */
export type Fmcc__Payment__ScheduleSinglePaymentRequest = {
  /** AccountNumber to get data from the downstream APIs referencing receivables system.Currently maps to receivable account number */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Represents whether a customer is the primary buyer or a co-buyer. */
  applicantCode: ApplicantCode
  /**
   * The auto-generated identifier of the bank account within Ford's database.
   * This is the same value as `fmcc__bank__BankAccount.id`.
   */
  bankAccountId?: InputMaybe<Scalars['Int']['input']>
  /** Provides the master customer number */
  masterCustomerNumber: Scalars['Int']['input']
  /**
   * The payment type selected by the customer. Some example values may include:
   * [OTHER,
   * PREVIOUS_DUE,
   * PRINCIPAL_ONLY,
   * TOTAL_AMOUNT_DUE,
   * TOTAL_AMOUNT_DUE_AND_PRINCIPAL]
   */
  paymentType: Scalars['String']['input']
  /**
   * The principle amount of the payment in case customer selects principle only payment or
   * principle and Total amount due payment option.
   */
  principalAmount?: InputMaybe<Scalars['Float']['input']>
  /** Provides the scheduled amount */
  scheduledAmount: Scalars['Float']['input']
  /**
   * Must be in the format `yyyy-MM-dd`
   *
   * Use `scheduledPaymentDate`. This input has been removed from lower environments.
   * @deprecated Use `scheduledPaymentDate`. This input has been removed from lower environments.
   */
  scheduledDate?: InputMaybe<Scalars['String']['input']>
  /** The date to schedule the payment for */
  scheduledPaymentDate?: InputMaybe<Scalars['Date']['input']>
}

/** Schedule payment mutation response status and confirmation */
export type Fmcc__Payment__ScheduleSinglePaymentResponse = {
  __typename?: 'fmcc__payment__ScheduleSinglePaymentResponse'
  /** The HTTP status code for the schedule single payment response. */
  code: Scalars['Int']['output']
  /** If the request is not successful, this will contain a list of error codes from the payment API. */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** Provides error messages from business */
  errors?: Maybe<Array<Maybe<Fmcc__CommonErrorResponse>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Information confirming successful payment scheduling. This field will not be present if the mutation was unsuccessful. */
  paymentConfirmation?: Maybe<Fmcc__Payment__PaymentConfirmationResponse>
  /** Indicates whether the schedule single payment was successful. */
  success: Scalars['Boolean']['output']
}

/** A single payment that has been scheduled by a customer. */
export type Fmcc__Payment__ScheduledPayment = {
  __typename?: 'fmcc__payment__ScheduledPayment'
  /** Represents the amount. */
  amount?: Maybe<Scalars['Float']['output']>
  /** Represents the bank account nick name. */
  bankAccountNickName?: Maybe<Scalars['String']['output']>
  /** Represents the bank account number. */
  bankAccountNumber?: Maybe<Scalars['String']['output']>
  /** Represents the bank account type. */
  bankAccountType?: Maybe<Scalars['String']['output']>
  /** Represents the type of currency. */
  currency?: Maybe<Scalars['String']['output']>
  /** Indicates whether the scheduled payment can be cancellable or not. */
  isCancellable?: Maybe<Scalars['Boolean']['output']>
  /** Represents the payment confirmation number. */
  paymentConfirmationNumber?: Maybe<Scalars['String']['output']>
  /**
   * Represents the payment date.
   *
   * This field is deprecated. Use `scheduledPaymentDate`, which enforces the standard date format. This field has been removed from lower environments.
   * @deprecated Use `scheduledPaymentDate`, which enforces the standard date format. This field has been removed from lower environments.
   */
  paymentDate?: Maybe<Scalars['String']['output']>
  /** Represents the principal amount. */
  principalAmount?: Maybe<Scalars['Float']['output']>
  /** The date for which the payment is scheduled */
  scheduledPaymentDate?: Maybe<Scalars['Date']['output']>
}

/** A set of parameters for the cancel payment request */
export type Fmcc__Payment__CancelPaymentRequest = {
  /** Account Number for cancel payment request */
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  /** Master customer number for cancel payment request */
  masterCustomerNumber: Scalars['String']['input']
}

/** Cancel payment mutation response status and confirmation */
export type Fmcc__Payment__CancelSinglePaymentResponse = {
  __typename?: 'fmcc__payment__cancelSinglePaymentResponse'
  /** Information about the canceled payment. This field will not be present if the mutation was unsuccessful. */
  canceledPayment?: Maybe<Fmcc__Payment__CanceledPayment>
  /** The HTTP status code for the cancel single payment response. */
  code: Scalars['Int']['output']
  /** If the request is not successful, this will contain a list of error codes from the payment API. */
  errorCodes?: Maybe<Array<Scalars['String']['output']>>
  /** Provides error messages from business */
  errors?: Maybe<Array<Maybe<Fmcc__CommonErrorResponse>>>
  /** The status message for the change indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the cancel single payment was successful. */
  success: Scalars['Boolean']['output']
}

/**
 * A payment that has just been canceled.
 *
 * This type is returned from the `fmcc__payment__cancelSinglePayment` mutation.
 */
export type Fmcc__Payment__CanceledPayment = {
  __typename?: 'fmcc__payment__canceledPayment'
  /** Represents the amount for canceled payment */
  amount?: Maybe<Scalars['Float']['output']>
  /** Represents the principal amount for canceled payment */
  principalAmount?: Maybe<Scalars['Float']['output']>
  /**
   * Represents the scheduled date for canceled payment
   *
   * Use `scheduledPaymentDate`, which enforces the standard date format. This field has been removed from lower environments.
   * @deprecated Use `scheduledPaymentDate`, which enforces the standard date format. This field has been removed from lower environments.
   */
  scheduledDate?: Maybe<Scalars['String']['output']>
  /** The date that the payment was scheduled for */
  scheduledPaymentDate?: Maybe<Scalars['Date']['output']>
}

/** Scheduled Payment details available to the customer. */
export type Fmcc__Payment__ScheduledPaymentDetails = {
  __typename?: 'fmcc__payment__scheduledPaymentDetails'
  /** Scheduled Payment Due Amount */
  amount?: Maybe<Scalars['Float']['output']>
  /** The bank account number, masked for security reasons. */
  bankAccountNumber?: Maybe<Scalars['String']['output']>
  /** Scheduled payment bank account type */
  bankAccountType?: Maybe<Scalars['String']['output']>
  /** A randomly-generated 5-6 digit ID for the transaction. Note that this is not the actual transactionID value. */
  customerTransactionId?: Maybe<Scalars['Long']['output']>
  /** Scheduled Payment Date */
  paymentDate?: Maybe<Scalars['Date']['output']>
  /** Scheduled Payment Principal Amount */
  principalAmount?: Maybe<Scalars['Float']['output']>
}

/** Indicates whether the phone is a mobile phone or a landline phone */
export enum Fmcc__PhoneCategory {
  /** landline */
  Landline = 'LANDLINE',
  /** mobile */
  Mobile = 'MOBILE',
}

/** Indicates whether the phone location is a home phone, work phone, or other */
export enum Fmcc__PhoneLocation {
  /** home */
  Home = 'HOME',
  /** other */
  Other = 'OTHER',
  /** work */
  Work = 'WORK',
}

/** Provides the phone information for the account  */
export type Fmcc__PhoneNumber = {
  __typename?: 'fmcc__phoneNumber'
  /** Extension is added to main phone number to make direct call */
  extension?: Maybe<Scalars['String']['output']>
  /** Indicates whether this phone is a mobile phone or a landline phone. */
  phoneCategory?: Maybe<Fmcc__PhoneCategory>
  /** Phone Country Code */
  phoneCountryCode?: Maybe<Scalars['String']['output']>
  /** A proprietary ID for phone numbers. This value is used to update notification preferences. */
  phoneIDNumber?: Maybe<Scalars['String']['output']>
  /** Phone Language of Choice Code */
  phoneLanguageOfChoiceCode?: Maybe<Scalars['String']['output']>
  /** Indicates whether this is a home phone, work phone, or other. */
  phoneLocation?: Maybe<Fmcc__PhoneLocation>
  /** Phone Number of the customer */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** Indicates whether this is a primary or secondary or others */
  phoneType?: Maybe<Fmcc__PhoneType>
  /**
   * Represents the order that this phone number appears in.
   * For example the phone number with sequence number 2 is the second phone number in the list
   */
  sequenceNumber?: Maybe<Scalars['Int']['output']>
}

/** Indicates whether the phone type is a primary or secondary or other */
export enum Fmcc__PhoneType {
  /** other */
  Other = 'OTHER',
  /** primary */
  Primary = 'PRIMARY',
  /** secondary */
  Secondary = 'SECONDARY',
}

/** A record of a single transaction on an account */
export type Fmcc__Statement__AccountTransaction = {
  __typename?: 'fmcc__statement__AccountTransaction'
  /** The unit of currency for the transaction */
  currency?: Maybe<CurrencyCode>
  /** Number of days that payment was late */
  daysLate?: Maybe<Scalars['Int']['output']>
  /** Interest for the transaction */
  interest?: Maybe<Scalars['Float']['output']>
  /** Invoice due date for transaction in ISO-8601 format (yyyy-mm-dd) */
  invoiceDueDate?: Maybe<Scalars['Date']['output']>
  /** Lease funding for vehicle */
  leaseFunding?: Maybe<Scalars['Float']['output']>
  /** Lease payment for transaction */
  leasePayment?: Maybe<Scalars['Float']['output']>
  /** Amount received for payment */
  paymentReceived?: Maybe<Scalars['Float']['output']>
  /** Principal amount for this transaction */
  principal?: Maybe<Scalars['Float']['output']>
  /** Principal balance at the time of this transaction */
  principalBalance?: Maybe<Scalars['Float']['output']>
  /** Taxes for this transaction */
  taxes?: Maybe<Scalars['Float']['output']>
  /** Amount for transaction */
  transactionAmount?: Maybe<Scalars['Float']['output']>
  /** Numeric transaction code. This corresponds to the type of the transaction */
  transactionCode?: Maybe<Scalars['Int']['output']>
  /** Date of Transaction, formatted as YYYY-MM-DD */
  transactionDate?: Maybe<Scalars['Date']['output']>
  /** Description of transaction */
  transactionDescription?: Maybe<Scalars['String']['output']>
  /** Total amount of transaction */
  transactionTotalAmount?: Maybe<Scalars['Float']['output']>
}

/** Provides the combined statement date and versionNumber */
export type Fmcc__Statement__CombinedBillStatementDate = {
  __typename?: 'fmcc__statement__CombinedBillStatementDate'
  /** Provides the statement date */
  statementDate: Scalars['Date']['output']
  /** Version number */
  versionNumber: Scalars['Int']['output']
}

/** Provides the statement information */
export type Fmcc__Statement__Query = {
  __typename?: 'fmcc__statement__Query'
  /** A list of all the transactions that have taken place on the given account */
  accountTransactionHistory?: Maybe<Array<Fmcc__Statement__AccountTransaction>>
  /** Provides all the available statement dates */
  nonCombinedBillStatementDates?: Maybe<Array<Scalars['Date']['output']>>
  /** Query to retrieve the receivable account numbers and their statement dates for the provided MCN */
  statementDatesByMcn?: Maybe<Array<Fc__Statement__AccountStatementDates>>
  /**
   * A list of all the transactions that have taken place on the given account
   *
   * This field is deprecated and has been removed from all lower environments. Please use `accountTransactionHistory` instead.
   * @deprecated Use `accountTransactionHistory`. This field has been removed from all lower environments.
   */
  transactionHistory?: Maybe<Array<Fmcc__Statement__TransactionHistory>>
}

/** Provides the statement information */
export type Fmcc__Statement__QueryAccountTransactionHistoryArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  endDate?: InputMaybe<Scalars['Date']['input']>
  startDate?: InputMaybe<Scalars['Date']['input']>
}

/** Provides the statement information */
export type Fmcc__Statement__QueryNonCombinedBillStatementDatesArgs = {
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
}

/** Provides the statement information */
export type Fmcc__Statement__QueryStatementDatesByMcnArgs = {
  mcn: Scalars['fc__customer__MCN']['input']
}

/** Provides the statement information */
export type Fmcc__Statement__QueryTransactionHistoryArgs = {
  accountNumber: Scalars['String']['input']
  accountType: AccountType
  endDate?: InputMaybe<Scalars['String']['input']>
  languageCode: LanguageCode
  startDate?: InputMaybe<Scalars['String']['input']>
}

/**
 * A list of all the transactions that have taken place on this account.
 *
 * This field will not be available in prod until it is implemented and verified in QA.
 */
export type Fmcc__Statement__TransactionHistory = {
  __typename?: 'fmcc__statement__TransactionHistory'
  /** Payment days late */
  daysLate?: Maybe<Scalars['String']['output']>
  /** Interest amount */
  interest?: Maybe<Scalars['String']['output']>
  /** Date Invoice due */
  invoiceDueDate?: Maybe<Scalars['String']['output']>
  /** Lease Funding */
  leaseFunding?: Maybe<Scalars['String']['output']>
  /** Payment Amount */
  leasePayment?: Maybe<Scalars['String']['output']>
  /** Payment Received */
  paymentReceived?: Maybe<Scalars['String']['output']>
  /** Principal Amount */
  principal?: Maybe<Scalars['String']['output']>
  /** Balance Amount */
  principalBalance?: Maybe<Scalars['String']['output']>
  /** Taxes Amount */
  taxes?: Maybe<Scalars['String']['output']>
  /** Transaction Amount */
  transactionAmount?: Maybe<Scalars['String']['output']>
  /** Date of transaction, formatted as YYYY-MM-DD */
  transactionDate?: Maybe<Scalars['String']['output']>
  /** Description of transaction */
  transactionDescription?: Maybe<Scalars['String']['output']>
  /** Total amount of transaction */
  transactionTotalAmount?: Maybe<Scalars['String']['output']>
}

/** " This contains vehicle odometer data  */
export type Fmcc__Vehicle__Odometer = {
  __typename?: 'fmcc__vehicle__Odometer'
  /** Last known odometer timestamp(ISO 8601) */
  lastUpdatedTime?: Maybe<Scalars['DateTime']['output']>
  /** The unit of `value` field. This is equal to the `unit` input entered in the query, defaulting to `KILOMETERS` if no unit is specified. */
  unit: Fc__OdometerValueUnit
  /**
   * Last known odometer timestamp, formatted as `yyyy-MM-dd hh:mm aa`
   * @deprecated Use lastUpdatedTime, which is formatted with the ISO standard. This field will be removed after 2024/02/15
   */
  updateTime?: Maybe<Scalars['String']['output']>
  /** Last known odometer value. The units for this field are specified by the `unit` field */
  value?: Maybe<Scalars['Float']['output']>
}

/** Provides the vehicle information */
export type Fmcc__Vehicle__Query = {
  __typename?: 'fmcc__vehicle__Query'
  /**
   * Provides telemetry information for the requested VIN. Use sourceId \"fordpass-nonpii\"
   * This returns null if no odometer returned by domain
   */
  odometer?: Maybe<Fmcc__Vehicle__Odometer>
  /** Provides recall information for the requested VIN tag:(finsimple) */
  recall?: Maybe<Fmcc__Vehicle__Recall>
  /**
   * Get the vehicle data for a given VIN.
   *
   * If the vehicle is not found, `null` will be returned and there will be a `NOT_FOUND` error in the response.
   */
  vehicle?: Maybe<Fmcc__Vehicle__Vehicle>
  /**
   * This query  provides information about features for the specified VIN, not the associated vehicles of the customer.
   *
   * This is used for marketing purposes, so there is no authorization for this query.
   * Only current and future model VINs are eligible for this query.
   */
  vehicleFeatureInformation?: Maybe<FcVehicleFeatureInformation>
}

/** Provides the vehicle information */
export type Fmcc__Vehicle__QueryOdometerArgs = {
  sourceId: Fc__OdometerSourceId
  unit?: Fc__OdometerValueUnit
  vin: Scalars['VIN']['input']
}

/** Provides the vehicle information */
export type Fmcc__Vehicle__QueryRecallArgs = {
  applicationCode: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  language: Scalars['String']['input']
  region: Scalars['String']['input']
  script: Scalars['String']['input']
  vehStatus: Scalars['String']['input']
  vin: Scalars['VIN']['input']
}

/** Provides the vehicle information */
export type Fmcc__Vehicle__QueryVehicleArgs = {
  vin: Scalars['VIN']['input']
}

/** Provides the vehicle information */
export type Fmcc__Vehicle__QueryVehicleFeatureInformationArgs = {
  vin: Scalars['VIN']['input']
}

/**  This contains vehicle recall data  */
export type Fmcc__Vehicle__Recall = {
  __typename?: 'fmcc__vehicle__Recall'
  /** Number of recalls for the VIN */
  numberOfRecalls: Scalars['Int']['output']
}

/** Provides the vehicle information */
export type Fmcc__Vehicle__Vehicle = {
  __typename?: 'fmcc__vehicle__Vehicle'
  /** The country in which the vehicle was manufactured */
  asBuiltCountry?: Maybe<Scalars['String']['output']>
  /** Vehicle body style description (e.g. Coupe) */
  bodyStyleDescription?: Maybe<Scalars['String']['output']>
  /**
   * Provides dealer information based on VIN or Dealer Distributor Lessor Parent (DDLP) account number.
   *
   * By default, this will retrieve data for the preferred dealer based on VIN, if available.
   * Otherwise, the originating dealer will be returned instead based on the DDLP account number.
   *
   * **Tip:** Check the value of the `dealerSource` field to determine whether this is the
   * preferred or originating dealer.
   */
  dealerInfo?: Maybe<FcDealer>
  /** Vehicle drive description (e.g. 2 WHL L/H REAR DRIVE) */
  driveDescription?: Maybe<Scalars['String']['output']>
  /** Vehicle engine description (e.g. 3.7L 4V PFI V6 NA Gas) */
  engineDescription?: Maybe<Scalars['String']['output']>
  /** The localized make of the vehicle (e.g. Ford) */
  make?: Maybe<Scalars['String']['output']>
  /** The localized model of the vehicle (e.g. Mustang) */
  model?: Maybe<Scalars['String']['output']>
  /** Vehicle color/paint description (e.g. ABSOLUTE BLACK) */
  paintDescription?: Maybe<Scalars['String']['output']>
  /** Provides the product type of the vehicle  */
  productType?: Maybe<Scalars['String']['output']>
  /** Represents whether to show the Electric Vehicle battery level or not */
  showEVBatteryLevel?: Maybe<Scalars['Boolean']['output']>
  /** Represents whether to show the Vehicle fuel level or not */
  showFuelLevel?: Maybe<Scalars['Boolean']['output']>
  /** Vehicle transmission description (e.g. 6 Speed Manual Transmission-MT82) */
  transmissionDescription?: Maybe<Scalars['String']['output']>
  /** Vehicle Image Key extracted from vehicleImageURL  */
  vehicleImageKey?: Maybe<Scalars['String']['output']>
  /**
   * URL to an image of the vehicle
   * @deprecated Use `vehicleImageKey`. This field is extracted from the vehicleImageURL .
   */
  vehicleImageURL?: Maybe<Scalars['String']['output']>
  /** The localized type of the vehicle (e.g. fuel or ev) */
  vehicle_Type?: Maybe<Scalars['String']['output']>
  /** Vehicle identification number */
  vin: Scalars['VIN']['output']
  /** The model year of the vehicle (e.g. 2020) */
  year?: Maybe<Scalars['Int']['output']>
}

/** Provides the vehicle information */
export type Fmcc__Vehicle__VehicleDealerInfoArgs = {
  ddlpAccountNumber: Scalars['Int']['input']
}

/** Eligibility status available to the customer */
export type Fmcc_Payment_EligibilityStatus = {
  __typename?: 'fmcc_payment_eligibilityStatus'
  /** A list of errors regarding payment eligibility. If this list is empty, then the the account is eligible for payments. */
  eligibilityErrorList?: Maybe<Array<Maybe<Fmcc__Payment__EligibilityError>>>
  /** True if the customer is eligible to make payments otherwise False */
  status?: Maybe<Scalars['Boolean']['output']>
}

/** A set of input parameters related to address. */
export type Fpi__Address = {
  /** The first line of the address. */
  addressLine1?: InputMaybe<Scalars['String']['input']>
  /** The second line of the address. */
  addressLine2?: InputMaybe<Scalars['String']['input']>
  /** The city name in address. */
  city?: InputMaybe<Scalars['String']['input']>
  /** The stateId in the address. */
  stateId?: InputMaybe<Scalars['Int']['input']>
  /** The ZIP code in the address. */
  zip?: InputMaybe<Scalars['String']['input']>
}

/**
 * The applicable Quote coverage customization details for coverages that
 * are combined using selected and applicable coverages for a proposal and parent
 */
export type Fpi__ApplicableCoverage = {
  __typename?: 'fpi__ApplicableCoverage'
  /** The coverageId mapped in origami of the coverage ex: 10015 */
  coverageId?: Maybe<Scalars['Int']['output']>
  /** The description for the coverage ex : Liability */
  description?: Maybe<Scalars['String']['output']>
  /** The displayCode for the coverage ex: CALIAB */
  displayCode?: Maybe<Scalars['String']['output']>
  /** The rows/attributes in Origami mapped against the coverage ex CADeductible */
  fields?: Maybe<Array<Maybe<Fpi__Field>>>
  /** Id which is used when inserting/updating coverage in origami : ex ISOCAVehCovgID in selected coverage origami API response for vehicleCoverage domain */
  id?: Maybe<Scalars['ID']['output']>
  /** Indicates whether a coverage is required in the policy. */
  isRequiredCoverage?: Maybe<Scalars['Boolean']['output']>
  /** The coverageId's which are mutually exclusive to the coverage */
  mutuallyExclusiveIDs?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The coverageId's which are must when adding coverage */
  prerequisiteIDs?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
}

/** Identifying fields for an Origami Application Member" */
export type Fpi__ApplicationMemberDetails = {
  /** Authorized Representative Email address */
  authorizedRepresentativeEmail?: InputMaybe<Scalars['String']['input']>
  /** Authorized Representative First Name */
  authorizedRepresentativeFName?: InputMaybe<Scalars['String']['input']>
  /** Authorized Representative last Name */
  authorizedRepresentativeLName?: InputMaybe<Scalars['String']['input']>
  /** if present , business name other than legal name. */
  businessAlias?: InputMaybe<Scalars['String']['input']>
  /** The Name of the Business */
  businessName?: InputMaybe<Scalars['String']['input']>
  /** The code against business structure */
  businessStructureCode?: InputMaybe<Scalars['String']['input']>
  /** primary contact email address */
  contactEmail?: InputMaybe<Scalars['String']['input']>
  /** primary contact firstName */
  contactFirstName?: InputMaybe<Scalars['String']['input']>
  /** primary contact LastName */
  contactLastName?: InputMaybe<Scalars['String']['input']>
  /** primary contact phone number */
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>
  /** The Federal Employer Identification Number. */
  fein?: InputMaybe<Scalars['String']['input']>
  /** Business Owner First Name */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** This refers to the id for the configured invoice receiving options such as email, paper etc. at Origami. */
  invoiceOptionId?: InputMaybe<Scalars['Int']['input']>
  /** Is the Contact Person authorized to sign legal documents on behalf of the insured, 19150 for Yes and 19151 for No */
  isContactAuthorized?: InputMaybe<Scalars['Int']['input']>
  /** Business Owner Last Name */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** Organization Description */
  organizationDescription?: InputMaybe<Scalars['String']['input']>
  /** The text mapped to business structure like LLC when business structure code is Others */
  otherBusinessStructure?: InputMaybe<Scalars['String']['input']>
}

/** A set of response parameters containing state | policy coverages */
export type Fpi__Coverage = {
  __typename?: 'fpi__Coverage'
  /** Total premium for all the applicable vehicle coverages. */
  cost?: Maybe<Scalars['Float']['output']>
  /** The coverageHeaderId is passed as parentId when calling state applicable coverages API */
  coverageHeaderId?: Maybe<Scalars['Int']['output']>
  /** The id associated with a coverage in Origami. This is used to determine included/excluded coverages. */
  coverageId?: Maybe<Scalars['Int']['output']>
  /**
   * is included as part of default policy coverage
   * @deprecated Logic to determine excluded/included coverages is under AEM
   */
  isIncluded?: Maybe<Scalars['Boolean']['output']>
  /**
   * "Coverage header or description telling the type of coverage e.g. Non Hired for state coverage &
   * Waiver of Subrogation for policy coverage
   */
  name?: Maybe<Scalars['String']['output']>
  /** This is the Coverage Type and will be either Exclusion or Coverage */
  type?: Maybe<Fpi__CoverageType>
}

/** Indicates the type of Coverage to retrieve selected and applicable coverages for. */
export enum Fpi__CoverageCustomizationSectionInput {
  /** Indicates a Policy Coverage Customization */
  Policy = 'POLICY',
  /** Indicates a State/Extra Coverage Customization */
  State = 'STATE',
  /** Indicates a Vehicle Coverage Customization */
  Vehicle = 'VEHICLE',
}

/** Enum for determining the type of coverage */
export enum Fpi__CoverageType {
  Coverage = 'COVERAGE',
  Exclusion = 'EXCLUSION',
}

/** A digital signature and payload for the applicant's payment details needed for payment processing */
export type Fpi__DigitalSignature = {
  __typename?: 'fpi__DigitalSignature'
  /** A string representation of a JSON object containing all details of the transaction */
  payload?: Maybe<Scalars['String']['output']>
  /** The generated signature required for a payment request */
  signature?: Maybe<Scalars['String']['output']>
}

/** Metadata needed to track information regarding an applicant/quote's payment status. */
export type Fpi__DigitalSignatureMetadata = {
  /** The amount of money the applicant owes for the specific payment */
  amountDue: Scalars['Float']['input']
  /** The policyId to which the payment is related e.g 10667 */
  bindPolicyId?: InputMaybe<Scalars['Int']['input']>
  /** Invoice amount for a particular invoice item */
  invoiceAmounts?: InputMaybe<Scalars['String']['input']>
  /** Invoice number for a particular invoice item */
  invoiceNumbers?: InputMaybe<Scalars['String']['input']>
  /** The memberId of the applicant for the payment to be run against */
  memberId: Scalars['Int']['input']
  /** The proposalId for the payment to be run against */
  proposalId: Scalars['Int']['input']
}

/** An applicant's payment details needed to generate a digital signature and payload */
export type Fpi__DigitalSignatureRequest = {
  /** The amount of the transaction in cents or whatever the smallest unit of the currency is, for example $35.23 USD would be 3523. Number, not string */
  amount: Scalars['Int']['input']
  /** The consumer team name or id that is used for PubSub message subscription */
  consumerId: Scalars['String']['input']
  /** The currency of the transaction, for example usd or cad, in lower case */
  currency: Scalars['String']['input']
  /** This is a description for the payment, item, or order. It will show up in the customer's transaction view. */
  description: Scalars['String']['input']
  /** The issuer name associated with the payment info token signing key, as registered with FordPay. */
  identity: Scalars['String']['input']
  /** The Stripe Account ID of the merchant Stripe Connect account associated with the transaction. Looks like acct_something. */
  merchantAccountId: Scalars['String']['input']
  /** Metadata needed to track information regarding an applicant/quote's payment status. */
  metadata?: InputMaybe<Fpi__DigitalSignatureMetadata>
  /** A unique identifier containing the order ID for the transaction. */
  orderId: Scalars['String']['input']
  /**  This indicates with which payment processor transactions to be made. Valid values are STRIPE, BLUESNAP, PUMA. */
  psp: Scalars['String']['input']
  /** This is the description of the payment in the customer's bank statement, and should be in format COMPANY NAME - ITEM DESCRIPTION. */
  statementDescriptor?: InputMaybe<Scalars['String']['input']>
}

/** Information for Get Files document to Display */
export type Fpi__DocumentResponse = {
  __typename?: 'fpi__DocumentResponse'
  /** This field will display the name of file */
  fileName?: Maybe<Scalars['String']['output']>
}

/** Enum for determining the type of document to be retrieved */
export enum Fpi__DocumentType {
  Insurancehistory = 'INSURANCEHISTORY',
  Losshistory = 'LOSSHISTORY',
}

/** A vehicle driver and their personal information */
export type Fpi__Driver = {
  __typename?: 'fpi__Driver'
  /** The driver's date of birth represented as a String value e.g. 11/07/2000 */
  dateOfBirth?: Maybe<Scalars['String']['output']>
  driverId: Scalars['Int']['output']
  /** The driver's first name */
  firstName?: Maybe<Scalars['String']['output']>
  /** The driver's last name */
  lastName?: Maybe<Scalars['String']['output']>
  /** masked license number , only first and last 3 digits are visible */
  licenseNumber?: Maybe<Scalars['String']['output']>
  /** id mapped against license state ex: Illinois , retrieved from license state Origami API */
  licenseStateId?: Maybe<Scalars['String']['output']>
  /** The id from LicenseStatus metadata e.g. 15818 for Suspended */
  licenseStatusId?: Maybe<Scalars['String']['output']>
}

/** Fields in Origami mapped against coverage */
export type Fpi__Field = {
  __typename?: 'fpi__Field'
  /** The default value for this field : ex 100 */
  defaultValue?: Maybe<Scalars['String']['output']>
  /** The displayName of the field ex: Deductible */
  displayName?: Maybe<Scalars['String']['output']>
  /** The type for this field ex : Text  */
  fieldType?: Maybe<Scalars['String']['output']>
  /** The name of the field ex: CADeductible */
  name?: Maybe<Scalars['String']['output']>
  /** The options available to select from drop down */
  options?: Maybe<Array<Maybe<Fpi__KeyValuePair>>>
  /** The attribute that identifies if the field is a readOnly */
  readOnly?: Maybe<Scalars['Boolean']['output']>
  /** The attribute used to mandate fields which have to be added while inserting coverage */
  required?: Maybe<Scalars['Boolean']['output']>
}

/** Input to specify a key-value pair which represents a field name name and value to customize for a given coverage */
export type Fpi__KeyValue = {
  /** The key for the entry ex: Peril */
  key?: InputMaybe<Scalars['String']['input']>
  /** The value for above key ex: ALL */
  value?: InputMaybe<Scalars['String']['input']>
}

/** Dropdown Key-Value Pairs for a the user to select from for a given coverage option */
export type Fpi__KeyValuePair = {
  __typename?: 'fpi__KeyValuePair'
  /** The key for the entry ex : ALL */
  key?: Maybe<Scalars['ID']['output']>
  /** The description ex: All Perils */
  value?: Maybe<Scalars['String']['output']>
}

/** The location of a business. */
export type Fpi__LocationListItem = Address & {
  __typename?: 'fpi__LocationListItem'
  /** The first line of the street address. */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The second line of the street address. */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** Origami generated unique ID to identify a building. */
  buildingNumber?: Maybe<Scalars['String']['output']>
  /** The city name in the address. */
  city?: Maybe<Scalars['String']['output']>
  /** The country code in the address. */
  country?: Maybe<Scalars['String']['output']>
  /** This is unique record Id of a location in Origami */
  locationId: Scalars['ID']['output']
  /** Origami generated unique ID to identify a location. */
  locationNumber?: Maybe<Scalars['String']['output']>
  /**
   * This field holds the business type code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as NAICS
   */
  naicsCode?: Maybe<Scalars['String']['output']>
  /**
   * This field holds the business category code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as SIC code
   */
  sicCode?: Maybe<Scalars['String']['output']>
  /** The state in the address. */
  state?: Maybe<Scalars['String']['output']>
  /** Holds the State Id for the location (e.g : 20 for Illinois) */
  stateId?: Maybe<Scalars['Int']['output']>
  /** The ZIP code in the address. */
  zip?: Maybe<Scalars['String']['output']>
}

/** A set of response parameters containing information about a loss history record from origami */
export type Fpi__LossHistory = {
  __typename?: 'fpi__LossHistory'
  /** The amount customer has paid till date for the loss */
  amountPaidToDate?: Maybe<Scalars['String']['output']>
  /** Claims Id/Number against which the loss history record is made e.g. 12345 */
  claimsNumber?: Maybe<Scalars['String']['output']>
  /** Record ID for loss History record part of the composite key along with lossHistoryId */
  clueDriverId: Scalars['String']['output']
  /** The actual date of loss e.g. 2023-08-08T00:00:00 */
  lossDate?: Maybe<Scalars['String']['output']>
  /** The ID for loss description metadata e.g. 17942 for Burglary */
  lossDescriptionId?: Maybe<Scalars['String']['output']>
  /** Record ID for loss History record part of the composite key along with clueDriverId */
  lossHistoryId: Scalars['String']['output']
  /** The date of Order placement e.g. 2023-08-08T00:00:00 */
  orderDate?: Maybe<Scalars['String']['output']>
}

/** This holds metadata about various Origami fields */
export type Fpi__Metadata = {
  __typename?: 'fpi__Metadata'
  /** The Origami metadata key name of the item being searched for. */
  code: Scalars['String']['output']
  /** A unique ID generated at run time to enable caching with Apollo Client */
  id: Scalars['ID']['output']
  /** Contains the display code and description. */
  name: Scalars['String']['output']
}

/**
 * This holds metadata combinations about various interrelated Origami fields
 * E.g. Possible combinations of VEHICLE RADIUS, VEHICLE USE & VEHICLE SIZE
 */
export type Fpi__MetadataCombination = {
  __typename?: 'fpi__MetadataCombination'
  /** This defines the class of TTT vehicles such as TRUCKER, FOOD,WASTE, SPECIALIZED, FARMER, DUMPTRANS and etc. */
  vehicleClass?: Maybe<Scalars['String']['output']>
  vehicleOperatorExperience?: Maybe<Scalars['String']['output']>
  /** Radius covered by the vehicle, depending on the vehicle type (PPT or TTT). */
  vehicleRadius?: Maybe<Scalars['String']['output']>
  /** This defines the size class for TTT vehicles. The values  can be HEAVY, LIGHT,MEDIUM and etc. */
  vehicleSizeClass?: Maybe<Scalars['String']['output']>
  /**
   * It is a more defined categories based on vehicle class.
   * for e.g FOOD can be divided in to Fish and seafood, frozen food, etc.
   */
  vehicleSubClass?: Maybe<Scalars['String']['output']>
  /** How the vehicle is used based on vehicle Type e.g FLEET and NON-FLEET */
  vehicleUse?: Maybe<Scalars['String']['output']>
}

/** An enum representing the possible paginated metadata types to search for */
export enum Fpi__PaginatedMetadataType {
  /** The body style of the vehicle. (e.g  Crew Cab, Sport Utility). */
  VehicleBodyStyle = 'VEHICLE_BODY_STYLE',
}

/** Payment related information required to initiate payment */
export type Fpi__PaymentMetaData = {
  __typename?: 'fpi__PaymentMetaData'
  /** The amount customer needs to pay or isDue */
  amountDue?: Maybe<Scalars['Float']['output']>
  /** The policyId to which the payment is related e.g 10667 */
  bindPolicyId?: Maybe<Scalars['Int']['output']>
  /** List of invoices against the particular policy number */
  invoices?: Maybe<Array<Maybe<Fpi__Quote__Invoice>>>
  /** Member ID for Payment Related Information e.g 201 */
  memberId?: Maybe<Scalars['Int']['output']>
  /** Amount that is due for the next payment */
  nextPaymentAmount?: Maybe<Scalars['Float']['output']>
  /** Due date for next payment  */
  nextPaymentDueDate?: Maybe<Scalars['DateTime']['output']>
  /** Provides payments details */
  paymentsInfo?: Maybe<Array<Maybe<FpiPaymentsInfo>>>
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__Query = {
  __typename?: 'fpi__Query'
  /** A list indicating the form of business entity of the applicant */
  businessStructures?: Maybe<Array<Fpi__Metadata>>
  /**
   * Generates a digital signature to be used for a payment request for a specific application.
   * If the application name is not present, a key pair must be self generated by the merchant and the public key provided to the backend Fordpay team.
   * Next, the key path must be configured in the Quote Graph Service.
   */
  digitalSignature?: Maybe<Fpi__DigitalSignature>
  /** Generates a digital signature and payload to be used for a payment request with FPI Customer Portal */
  digitalSignatureFordPay?: Maybe<Fpi__DigitalSignature>
  /** Fetch the list of document files against domain Proposal from origami based upon the proposalId */
  documents?: Maybe<Array<Maybe<Fpi__DocumentResponse>>>
  /** provides the make list of vehicles registered  at JD Power for a selected year. */
  makes?: Maybe<Array<Maybe<Fpi__KeyValuePair>>>
  /** A search mechanism for Origami metadata using the metadata type (enum) and an optional keyword to search for. */
  metadata?: Maybe<Array<Maybe<Fpi__Metadata>>>
  /** A search mechanism used to determine the valid combinations of metadata for TTT vehicles. */
  metadataCombinations?: Maybe<Array<Maybe<Fpi__MetadataCombination>>>
  /** provides the all models of a selected Year and make registered at JD Power. */
  models?: Maybe<Array<Maybe<Fpi__KeyValuePair>>>
  /** A search mechanism for Origami metadata using the metadata type (enum) and an optional search criteria that includes pagination. */
  paginatedMetadata?: Maybe<Array<Maybe<Fpi__Metadata>>>
  /** Contains all necessary queries to generate a quote for an applicant */
  quote?: Maybe<Fpi__Quote__Query>
  /** Query to generate a standardized addressed based on the address provided in the input. */
  standardizedAddress?: Maybe<Fpi__StandardizedAddressResponse>
  /**
   * A list of states filtered and retrieved from Origami
   * @deprecated Logic to determine state list is under AEM
   */
  states?: Maybe<Array<Fpi__State>>
  /** A JD Power adapter to decode a VIN to retrieve the necessary vehicle information. */
  vehicleInfo?: Maybe<VehicleInfo>
  /** provides the entire list of years for all the vehicle Models registered at JD Power. */
  years?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryDigitalSignatureArgs = {
  applicationName: Fpi__ApplicationName
  payload: Scalars['String']['input']
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryDigitalSignatureFordPayArgs = {
  payload: Fpi__DigitalSignatureRequest
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryDocumentsArgs = {
  documentType?: InputMaybe<Fpi__DocumentType>
  proposalId: Scalars['Int']['input']
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryMakesArgs = {
  year: Scalars['String']['input']
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryMetadataArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>
  metadataType: Fpi__MetadataType
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryMetadataCombinationsArgs = {
  metadataCombinationType: Fpi__MetadataCombinationType
  proposalId: Scalars['Int']['input']
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryModelsArgs = {
  make: Scalars['String']['input']
  year: Scalars['String']['input']
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryPaginatedMetadataArgs = {
  paginatedMetadataType: Fpi__PaginatedMetadataType
  searchCriteria?: InputMaybe<Fpi__SearchCriteria>
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryStandardizedAddressArgs = {
  address: Fpi__StandardizedAddressRequest
}

/** Contains common use queries. Any quote query is specific for the FPI Customer Portal. */
export type Fpi__QueryVehicleInfoArgs = {
  vin: Scalars['VIN']['input']
}

/** The generic search criteria request parameters */
export type Fpi__SearchCriteria = {
  keyword?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** The user inputted full address. */
export type Fpi__StandardizedAddressRequest = {
  /** The street address or the first line of the applicant's address */
  addressLine1: Scalars['String']['input']
  /** Should contain secondary address unit designators, such as apartment, suite, room, or floor numbers. */
  addressLine2: Scalars['String']['input']
  /** The name of the applicant's city */
  city: Scalars['String']['input']
  /** The state associated with the applicant's location */
  state: Scalars['String']['input']
  /** A group of five numbers that are added to a postal address to identify the postal area */
  zip: Scalars['String']['input']
}

/** A generated standardized address */
export type Fpi__StandardizedAddressResponse = Address & {
  __typename?: 'fpi__StandardizedAddressResponse'
  /** The generated address line 1 based on the user inputted value for address line 1 and line 2. */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The generated address line 2 based on the user inputted value. */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** A numeric code representing a subdivision of the address' tract */
  censusBlock?: Maybe<Scalars['String']['output']>
  /** A numeric code representing a subdivision of the address' state */
  censusCounty?: Maybe<Scalars['String']['output']>
  /** A numeric code representing the address state */
  censusState?: Maybe<Scalars['String']['output']>
  /** A numeric code representing a subdivision of the address' county */
  censusTract?: Maybe<Scalars['String']['output']>
  /** The name of the applicant's city */
  city?: Maybe<Scalars['String']['output']>
  /** Should contain secondary address unit designators, such as apartment, suite, room, or floor numbers. */
  country?: Maybe<Scalars['String']['output']>
  /** This field informs whether the address is DELIVERABLE or UNDELIVERABLE */
  qsRating: Scalars['String']['output']
  /** A state's two letter abbreviation */
  state?: Maybe<Scalars['String']['output']>
  /** A group of 9 digits in the form of 12345-6789 to identify the postal area of the applicant */
  zip?: Maybe<Scalars['String']['output']>
}

/** The necessary information needed to display a state */
export type Fpi__State = {
  __typename?: 'fpi__State'
  /** A numerical code representing a state in Origami */
  code: Scalars['String']['output']
  /** A two letter abbreviation of the state's name */
  isoCode: Scalars['String']['output']
  /** The name of the state */
  name: Scalars['String']['output']
  /** This field tells about the insurance platform serving the corresponding state */
  serviceableBy?: Maybe<Scalars['String']['output']>
}

/** A Vehicle's metadata and information */
export type Fpi__Vehicle = {
  __typename?: 'fpi__Vehicle'
  /** The body style of the vehicle. (e.g  Crew Cab, Sport Utility) */
  bodyStyle?: Maybe<Scalars['String']['output']>
  /** The body style Id configured in Origami for the above body style. */
  bodyStyleId?: Maybe<Scalars['Int']['output']>
  /** Option to waive deductible for safety glass */
  fullSafetyGlass?: Maybe<Scalars['Boolean']['output']>
  /** The Garage location ID of the vehicle. */
  garageLocationId?: Maybe<Scalars['Int']['output']>
  /** Represents vehicle identification Number, this will hold either a VIN or SRL based on vehicle identifier Type */
  idNumber?: Maybe<Scalars['String']['output']>
  /** Represent vehicle identifier types, the possible values are VIN or SRL */
  identifierType?: Maybe<Scalars['String']['output']>
  /** The localized make of the vehicle (e.g. Ford) */
  make?: Maybe<Scalars['String']['output']>
  /** The localized model of the vehicle (e.g. Mustang) */
  model?: Maybe<Scalars['String']['output']>
  /**
   * This field defines the level of training, skill, and experience
   *  possessed by the individual or operator who operates these types of vehicles.
   * This is only applicable for PPT vehicle types.
   * NOOPER - No operator licensed less than five years
   * NOTOWNER - Operator licensed less than five years, is not owner or principal operator
   * OWNER - Owner or principal operator licensed less than five years
   */
  operatorExperience?: Maybe<Scalars['String']['output']>
  /**
   * It represents the monetary worth or value assigned to the vehicle based on
   * various factors such as its make, model, year, condition, mileage,
   * features, and market demand.
   */
  originalCostNew?: Maybe<Scalars['String']['output']>
  /** The ownership type of the vehicle. It can be vary between Self Owned, Lease or loan types. */
  ownershipTypeId?: Maybe<Scalars['String']['output']>
  /** Radius covered by the vehicle, depending on the vehicle type (PPT or TTT). */
  radius?: Maybe<Scalars['String']['output']>
  /** This defines the class of TTT vehicles such as TRUCKER, FOOD,WASTE, SPECIALIZED, FARMER, DUMPTRANS and etc. */
  vehicleClass?: Maybe<Scalars['String']['output']>
  /** This is unique record Id of a vehicle in Origami */
  vehicleId: Scalars['Int']['output']
  /** This defines the size class for TTT vehicles. The values  can be HEAVY, LIGHT,MEDIUM and etc. */
  vehicleSize?: Maybe<Scalars['String']['output']>
  /**
   * It is a more defined categories based on vehicle class.
   * for e.g FOOD can be divided in to Fish and seafood, frozen food, etc.
   */
  vehicleSubclass?: Maybe<Scalars['String']['output']>
  /**
   * Type of vehicle such as
   * PPT - Private Passenger type,
   * TTT- Truck, tractor and Trailer,
   * Public and Special.
   */
  vehicleType?: Maybe<Scalars['String']['output']>
  /** How the vehicle is used based on vehicle Type e.g FLEET and NON-FLEET */
  vehicleUse?: Maybe<Scalars['String']['output']>
  /** The model year of the vehicle (e.g. 2020) */
  year?: Maybe<Scalars['String']['output']>
}

/** Represents the basic information of a single Vehicle when retrieving a list of all vehicles for a proposal */
export type Fpi__VehicleListItem = {
  __typename?: 'fpi__VehicleListItem'
  /** The body style of the vehicle. (e.g  Crew Cab, Sport Utility) */
  bodyStyle?: Maybe<Scalars['String']['output']>
  /** premium required for the vehicle coverage */
  cost?: Maybe<Scalars['Float']['output']>
  /** Represents vehicle identification Number, this will hold either a VIN or SRL based on vehicle identifier Type */
  idNumber?: Maybe<Scalars['String']['output']>
  /** Represent vehicle identifier types, the possible values are VIN or SRL */
  identifierType?: Maybe<Scalars['String']['output']>
  /** The localized make of the vehicle (e.g. Ford) */
  make?: Maybe<Scalars['String']['output']>
  /** The localized model of the vehicle (e.g. Mustang) */
  model?: Maybe<Scalars['String']['output']>
  /** Retrieves vehicle coverage records for a given proposal Id */
  vehicleCoverages?: Maybe<Array<FpiVehicleCoverage>>
  /** This is unique record Id of a vehicle in Origami */
  vehicleId: Scalars['Int']['output']
  /** The model year of the vehicle (e.g. 2020) */
  year?: Maybe<Scalars['String']['output']>
}

export enum Fpi__ApplicationName {
  FordPay = 'FORD_PAY',
}

/** An enum representing the possible metadata combination to search for */
export enum Fpi__MetadataCombinationType {
  /** A list of all valid combinations of PPT vehicle class and subclass */
  VehicleClassSubclassPpt = 'VEHICLE_CLASS_SUBCLASS_PPT',
  /** A list of all valid combinations of TTT vehicle class and subclass */
  VehicleClassSubclassTtt = 'VEHICLE_CLASS_SUBCLASS_TTT',
  /** A list of all valid combinations for TTT vehicle radius, size, and use. */
  VehicleRadiusSizeUseTtt = 'VEHICLE_RADIUS_SIZE_USE_TTT',
}

/** An enum representing the metadata to search for. */
export enum Fpi__MetadataType {
  /** Available options for how frequently an applicant will like to be billed */
  BillingFrequency = 'BILLING_FREQUENCY',
  /** A list of possible methods to bill the applicant, such as email, paper, etc. */
  BillingMethod = 'BILLING_METHOD',
  /**
   * This field holds the business type code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as NAICS
   */
  BusinessType = 'BUSINESS_TYPE',
  /** A list of valid driver license states */
  DriverLicenseState = 'DRIVER_LICENSE_STATE',
  /** A list of valid insurance coverage carriers */
  InsuranceCoverageCarrier = 'INSURANCE_COVERAGE_CARRIER',
  /** A list of possible coverages durations available for a user to select */
  InsuranceCoverageDuration = 'INSURANCE_COVERAGE_DURATION',
  /** Options to determine if a contact person is authorized to sign legal documents on behalf of  the insured. */
  IsContactPersonAuthorized = 'IS_CONTACT_PERSON_AUTHORIZED',
  /** A list of license statuses for a user to select */
  LicenseStatus = 'LICENSE_STATUS',
  /** A list of loss history types */
  LossHistory = 'LOSS_HISTORY',
  /** A list of possible status updates when running a rating or MVR. */
  RatingStatus = 'RATING_STATUS',
  /**
   * This field holds the business category code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as SIC code
   */
  SicCode = 'SIC_CODE',
  /** The body style of the vehicle. (e.g  Crew Cab, Sport Utility). */
  VehicleBodyStyle = 'VEHICLE_BODY_STYLE',
  /** This defines the class of PPT vehicles such as TRUCKER, FOOD,WASTE, SPECIALIZED, FARMER, DUMPTRANS and etc. */
  VehicleClassPpt = 'VEHICLE_CLASS_PPT',
  /** This defines the class of TTT vehicles such as TRUCKER, FOOD,WASTE, SPECIALIZED, FARMER, DUMPTRANS and etc. */
  VehicleClassTtt = 'VEHICLE_CLASS_TTT',
  /** The type of identification number for the vehicle, such as VIN or SRL. */
  VehicleIdType = 'VEHICLE_ID_TYPE',
  /**
   * This field defines the level of training, skill, and experience
   * possessed by the individual or operator who operates these types of vehicles.
   * This is only applicable for PPT vehicle types.
   * NOOPER - No operator licensed less than five years
   * NOTOWNER - Operator licensed less than five years, is not owner or principal operator
   * OWNER - Owner or principal operator licensed less than five years
   */
  VehicleOperatorExperiencePpt = 'VEHICLE_OPERATOR_EXPERIENCE_PPT',
  /** Indicates whether a vehicle is owned, leased, or loaned. */
  VehicleOwnershipType = 'VEHICLE_OWNERSHIP_TYPE',
  /** Radius options for a PPT Vehicle */
  VehicleRadiusPpt = 'VEHICLE_RADIUS_PPT',
  /** Radius options for a TTT Vehicle */
  VehicleRadiusTtt = 'VEHICLE_RADIUS_TTT',
  /** Radius options for a PPT Vehicle */
  VehicleSizeTtt = 'VEHICLE_SIZE_TTT',
  /**
   * It is a more defined category based on PPT vehicle class.
   * for e.g FOOD can be divided in to Fish and seafood, frozen food, etc.
   */
  VehicleSubclassPpt = 'VEHICLE_SUBCLASS_PPT',
  /**
   * It is a more defined category based on TTT vehicle class.
   * for e.g FOOD can be divided in to Fish and seafood, frozen food, etc.
   */
  VehicleSubclassTtt = 'VEHICLE_SUBCLASS_TTT',
  /**
   * Type of vehicle such as
   * PPT - Private Passenger type,
   * TTT- Truck, tractor and Trailer,
   * Public and Special.
   */
  VehicleType = 'VEHICLE_TYPE',
  /** How the vehicle is used based on a TTT vehicle Type e.g FLEET and NON-FLEET */
  VehicleUsePpt = 'VEHICLE_USE_PPT',
  /** How the vehicle is used based on a PPT vehicle Type e.g FLEET and NON-FLEET */
  VehicleUseTtt = 'VEHICLE_USE_TTT',
}

/** A set of input parameters related to driver's data. */
export type Fpi__Quote__AddDriverRequest = {
  /** dateOfBirth of the Driver */
  dateOfBirth: Scalars['String']['input']
  /** firstName of the Driver */
  firstName: Scalars['String']['input']
  /** LastName of the Driver */
  lastName: Scalars['String']['input']
  /** license number of the Driver */
  licenseNumber: Scalars['String']['input']
  /** id mapped against license state ex: Illinois , retrieved from license state Origami API */
  licenseStateId: Scalars['String']['input']
  /** id mapped against the status text ex : Suspended */
  licenseStatusId: Scalars['String']['input']
}

/** A set of inputs for adding any type of vehicle to a proposal. */
export type Fpi__Quote__AddVehicleRequest = {
  /** The body style of the vehicle. (e.g  Crew Cab, Sport Utility) */
  bodyStyle?: InputMaybe<Scalars['String']['input']>
  /** The body style Id configured in Origami for the above body style. */
  bodyStyleId: Scalars['String']['input']
  /** Option to waive deductible for safety glass */
  fullSafetyGlass?: InputMaybe<Scalars['Boolean']['input']>
  /** The Garage location ID of the vehicle. */
  garageLocationId: Scalars['String']['input']
  /** Represents vehicle identifier number, this will hold either a VIN or SRL based on vehicle identifier Type */
  idNumber: Scalars['String']['input']
  /** Represents vehicle identifier types, the possible values are VIN or SRL */
  identifierType: Scalars['String']['input']
  /** The localized make of the vehicle (e.g. Ford) */
  make: Scalars['String']['input']
  /** The localized model of the vehicle (e.g. Mustang) */
  model: Scalars['String']['input']
  /**
   * This field defines the level of training, skill, and experience
   * possessed by the individual or operator who operates these types of vehicles.
   * This is only applicable for PPT vehicle types.
   * NOOPER - No operator licensed less than five years
   * NOTOWNER - Operator licensed less than five years, is not owner or principal operator
   * OWNER - Owner or principal operator licensed less than five years
   */
  operatorExperience?: InputMaybe<Scalars['String']['input']>
  /**
   * It represents the monetary worth or value assigned to the vehicle based on
   * various factors such as its make, model, year, condition, mileage,
   * features, and market demand.
   */
  originalCostNew: Scalars['String']['input']
  /** Indicates whether a vehicle is owned, leased, or loaned. */
  ownershipTypeId: Scalars['String']['input']
  /** Radius covered by the vehicle, depending on the vehicle type (PPT or TTT). the value can change  */
  radius?: InputMaybe<Scalars['String']['input']>
  /** State id for the proposal */
  stateId: Scalars['String']['input']
  /** This defines the class of TTT or PPT vehicles such as TRUCKER, FOOD, WASTE, SPECIALIZED, FARMER, DUMPTRANS and etc. */
  vehicleClass?: InputMaybe<Scalars['String']['input']>
  /** This defines the size class for TTT vehicles. The values  can be HEAVY, LIGHT,MEDIUM and etc. */
  vehicleSize?: InputMaybe<Scalars['String']['input']>
  /**
   * It is a more defined categories based on TTT or PPT vehicle class.
   * for e.g FOOD can be divided in to Fish and seafood, frozen food, etc.
   */
  vehicleSubclass?: InputMaybe<Scalars['String']['input']>
  /**
   * Type of vehicle such as
   * PPT - Private Passenger type,
   * TTT- Truck, tractor and Trailer,
   * Public and Special.
   */
  vehicleType: Scalars['String']['input']
  /** How the vehicle is used based on vehicle Type e.g FLEET and NON-FLEET */
  vehicleUse?: InputMaybe<Scalars['String']['input']>
  /** The model year of the vehicle (e.g. 2020) */
  year: Scalars['String']['input']
}

/** Address of the business owner and related fields */
export type Fpi__Quote__Address = Address & {
  __typename?: 'fpi__quote__Address'
  /** The first line of the street address. */
  addressLine1?: Maybe<Scalars['String']['output']>
  /** The second line of the street address. */
  addressLine2?: Maybe<Scalars['String']['output']>
  /** The city name in the address. */
  city?: Maybe<Scalars['String']['output']>
  /** The country code in the address. */
  country?: Maybe<Scalars['String']['output']>
  /** The state in the address. */
  state?: Maybe<Scalars['String']['output']>
  /** Origami registered stateID e.g 20 for Illinois. */
  stateId?: Maybe<Scalars['Int']['output']>
  /** The ZIP code in the address. */
  zip?: Maybe<Scalars['String']['output']>
}

/** Identifying fields for an Origami Application Member" */
export type Fpi__Quote__ApplicationMemberDetails = {
  __typename?: 'fpi__quote__ApplicationMemberDetails'
  /** Authorized Representative Email address */
  authorizedRepresentativeEmail?: Maybe<Scalars['String']['output']>
  /** Authorized Representative First Name */
  authorizedRepresentativeFName?: Maybe<Scalars['String']['output']>
  /** Authorized Representative last Name */
  authorizedRepresentativeLName?: Maybe<Scalars['String']['output']>
  /** if present , business name other than legal name. */
  businessAlias?: Maybe<Scalars['String']['output']>
  /** The Name of the Business */
  businessName?: Maybe<Scalars['String']['output']>
  /** The code against business structure */
  businessStructureCode?: Maybe<Scalars['String']['output']>
  /** primary contact email address */
  contactEmail?: Maybe<Scalars['String']['output']>
  /** primary contact firstName */
  contactFirstName?: Maybe<Scalars['String']['output']>
  /** primary contact LastName */
  contactLastName?: Maybe<Scalars['String']['output']>
  /** primary contact phone number */
  contactPhoneNumber?: Maybe<Scalars['String']['output']>
  /** The Federal Employer Identification Number. */
  fein?: Maybe<Scalars['String']['output']>
  /** Business Owner First Name */
  firstName?: Maybe<Scalars['String']['output']>
  /** This refers to the id for the configured invoice receiving options such as email, paper etc. at Origami. */
  invoiceOptionId?: Maybe<Scalars['Int']['output']>
  /** Is the Contact Person authorized to sign legal documents on behalf of the insured, 19150 for Yes and 19151 for No */
  isContactAuthorized?: Maybe<Scalars['Int']['output']>
  /** Business Owner Last Name */
  lastName?: Maybe<Scalars['String']['output']>
  /** The policy holder's name */
  name?: Maybe<Scalars['String']['output']>
  /** The organization description in the business details section. */
  organizationDescription?: Maybe<Scalars['String']['output']>
  /** The text mapped to business structure like LLC when business structure code is Others */
  otherBusinessStructure?: Maybe<Scalars['String']['output']>
}

/** Billing options for a given proposal */
export type Fpi__Quote__BillingOption = {
  __typename?: 'fpi__quote__BillingOption'
  /** A one letter code representing how often an applicant should be billed for an order. */
  billingFrequencyCode?: Maybe<Scalars['String']['output']>
  /** A charge or cost associated with spreading out the payment of a purchase or a loan over multiple installments or payments. */
  installmentFeesTotal?: Maybe<Scalars['Float']['output']>
  /** The full name of the billing frequency e.g. Monthly for M, Full for O. */
  name?: Maybe<Scalars['String']['output']>
  /** Describes how many payments will need to be processed to fulfill the total payment */
  numberOfPayments?: Maybe<Scalars['Int']['output']>
  /** The billing schedule for an applicant */
  schedule?: Maybe<Array<Maybe<Fpi__Quote__BillingSchedule>>>
  /** The initial amount of money the applicant will be required to pay upfront */
  securityDepositAmount?: Maybe<Scalars['Float']['output']>
  /** The total amount of money the applicant will pay after all payments are processed. */
  totalPayment?: Maybe<Scalars['Float']['output']>
}

export type Fpi__Quote__BillingSchedule = {
  __typename?: 'fpi__quote__BillingSchedule'
  billedAmount?: Maybe<Scalars['Float']['output']>
  dueDate?: Maybe<Scalars['String']['output']>
  isDownPayment?: Maybe<Scalars['Boolean']['output']>
  periodEnd?: Maybe<Scalars['String']['output']>
  periodStart?: Maybe<Scalars['String']['output']>
  transactionDate?: Maybe<Scalars['String']['output']>
}

/** Response message from Origami while binding quote */
export type Fpi__Quote__BindQuoteResponse = {
  __typename?: 'fpi__quote__BindQuoteResponse'
  /** The HTTP status code for bind quote response */
  code: Scalars['Int']['output']
  /** Signifies the success or error message from origami */
  message?: Maybe<Scalars['String']['output']>
  /** Policy ID of the associated proposal */
  policyId?: Maybe<Scalars['String']['output']>
  /** A flag to show the success status from origami */
  success: Scalars['Boolean']['output']
}

/** Input for providing contact info to call back a user. */
export type Fpi__Quote__CallBackUserRequest = {
  /** The first name of the user to be called back */
  contactFirstName: Scalars['String']['input']
  /** The last name of the user to be called back */
  contactLastName: Scalars['String']['input']
  /** The phone number of the user to be called back */
  contactPhoneNumber: Scalars['String']['input']
}

/** Response message for requesting a call back to a user from a fleet specialist */
export type Fpi__Quote__CallBackUserResponse = {
  __typename?: 'fpi__quote__CallBackUserResponse'
  /** The HTTP status code for Call Back API response */
  code?: Maybe<Scalars['Int']['output']>
  /** Signifies the success or error message from the Call Back API response */
  message?: Maybe<Scalars['String']['output']>
  /** A flag to show that a call back to the user has been successfully requested by Origami. */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Response message for creating a member with a proposal ID */
export type Fpi__Quote__CreateMemberResponse = {
  __typename?: 'fpi__quote__CreateMemberResponse'
  /** The HTTP status code for update insurance history response */
  code?: Maybe<Scalars['Int']['output']>
  /** Record ID representing the applicant */
  memberId?: Maybe<Scalars['Int']['output']>
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message?: Maybe<Scalars['String']['output']>
  /** Indicated whether the insurance history for the applicant was added successfully */
  success?: Maybe<Scalars['Boolean']['output']>
}

/**
 * "
 * createProposal contains attributes related to BusinessInfo, BusinessOwner, BusinessAddress,
 * PrimaryContact and BusinessDetails
 */
export type Fpi__Quote__CreateProposalRequest = {
  /** holds businessAddress related fields */
  address?: InputMaybe<Fpi__Address>
  /** Identifying fields for an Origami Application Member */
  applicationMemberDetails: Fpi__ApplicationMemberDetails
  /** Billing Frequency, values can be O for One time , M for Monthly, S for semi annually , Q for Quarterly */
  billingFrequency: Scalars['String']['input']
  /** The Name of the Business */
  businessStructure: Scalars['String']['input']
  /** It represents the policy startDate */
  expectedPolicyStartDate: Scalars['String']['input']
  /**
   * This field holds the business type code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as NAICS
   */
  naicsCode: Scalars['String']['input']
  /** It represents the policy endDate */
  policyEndDate: Scalars['String']['input']
  /**
   * This field holds the business category code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as SIC code
   */
  sicCode?: InputMaybe<Scalars['String']['input']>
}

/** Combined Result for Coverage inserts, updates and deletes from Origami */
export type Fpi__Quote__DomainCoverageResponse = {
  __typename?: 'fpi__quote__DomainCoverageResponse'
  /** Origami Response for the list of coverages which have been deleted in Origami */
  deletes?: Maybe<Array<Maybe<Fpi__Quote__IndividualCoverageStatus>>>
  /** Origami Response for the list of coverages which have been inserted in Origami */
  inserts?: Maybe<Array<Maybe<Fpi__Quote__IndividualCoverageStatus>>>
  /** Origami Response for the list of coverages which have been updated in Origami */
  updates?: Maybe<Array<Maybe<Fpi__Quote__IndividualCoverageStatus>>>
}

/** Individual Status for every coverage returned from Origami insert, update, and delete responses */
export type Fpi__Quote__IndividualCoverageStatus = {
  __typename?: 'fpi__quote__IndividualCoverageStatus'
  /** The RecordId in Origami Response for which the coverage was inserted,updated or deleted */
  id?: Maybe<Scalars['Int']['output']>
  /** Origami message if the coverage was successfully inserted,updated or deleted in Origami */
  message?: Maybe<Scalars['String']['output']>
  /** The index assigned by Origami, this number corresponds to the sequence in the insert , update and delete array passed in request  */
  orderNumber?: Maybe<Scalars['Int']['output']>
  /** Indicates if the coverage was successfully inserted,updated or deleted in Origami */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Basic information about the applicant's current insurance carrier */
export type Fpi__Quote__InsuranceHistory = {
  __typename?: 'fpi__quote__InsuranceHistory'
  /** The carrier Id configured in Origami for the user's current insurance carrier */
  carrierId?: Maybe<Scalars['String']['output']>
  /** The current coverage information Id configured in Origami for the current coverage duration */
  currentCoverageInformationId?: Maybe<Scalars['String']['output']>
  /** Has the applicant had prior insurance with standard markets for all lines of business included on the quote? */
  hadPriorInsurance?: Maybe<Scalars['Boolean']['output']>
  /** The insurance history id referencing the Id configured in Origami from adding an insurance history */
  insuranceHistoryId?: Maybe<Scalars['Int']['output']>
  /** Reason for the non-renewed coverage, applicable for <1 year, Lapse in coverage, Non-Renewed and Canceled coverage duration */
  nonRenewedReason?: Maybe<Scalars['String']['output']>
  /** The policy number for the applicant's current insurance */
  policyNumber?: Maybe<Scalars['String']['output']>
}

/** Input for adding an applicant's insurance history */
export type Fpi__Quote__InsuranceHistoryRequest = {
  /** The carrier Id configured in Origami for the user's current insurance carrier */
  carrierId: Scalars['String']['input']
  /** The current coverage information Id configured in Origami for the current coverage duration */
  currentCoverageInformationId: Scalars['String']['input']
  /** Has the applicant had prior insurance with standard markets for all lines of business included on the quote? */
  hadPriorInsurance: Scalars['Boolean']['input']
  /** Reason for the non-renewed coverage, applicable for <1 year, Lapse in coverage, Non-Renewed and Canceled coverage duration */
  nonRenewedReason?: InputMaybe<Scalars['String']['input']>
  /** The policy number for the applicant's current insurance */
  policyNumber: Scalars['String']['input']
}

/** List of Invoice related information for a particular policy */
export type Fpi__Quote__Invoice = {
  __typename?: 'fpi__quote__Invoice'
  /** Invoice amount for a particular invoice item */
  invoiceAmount?: Maybe<Scalars['Float']['output']>
  /** Invoice number for a particular invoice item */
  invoiceNumber?: Maybe<Scalars['String']['output']>
}

/** A general input type for looking up an entity against its proposal ID */
export type Fpi__Quote__LookupByProposalIdRequest = {
  /**
   * Sets the maximum number of items to be included in the response.
   * It restricts the total number of items returned.
   */
  limit?: InputMaybe<Scalars['Int']['input']>
  /**
   * It specifies the number of items that should be skipped from the beginning of the result set.
   * For example, if the offset is set to 10, the first 10 items will be skipped,
   * and the response will start from the 11th item.
   */
  offset?: InputMaybe<Scalars['Int']['input']>
  /** The proposal ID for the entity to be retrieved against */
  proposalId: Scalars['Int']['input']
}

/** A set of request parameters containing information about a loss history record to be added or updated in Origami */
export type Fpi__Quote__LossHistoryRequest = {
  /** The amount customer has paid till date for the loss */
  amountPaidToDate: Scalars['String']['input']
  /** Claims Id/Number against which the loss history record is made e.g. 12345 */
  claimsNumber: Scalars['String']['input']
  /** The actual date of loss e.g. 2023-08-08T00:00:00 */
  lossDate: Scalars['Date']['input']
  /** The ID for loss description metadata e.g. 17942 for Burglary */
  lossDescriptionId: Scalars['String']['input']
  /** The date of Order placement e.g. 2023-08-08T00:00:00 */
  orderDate: Scalars['Date']['input']
  /** Proposal ID against which the loss History record is created in Origami */
  proposalId: Scalars['Int']['input']
}

/** The policy information pulled against the policy ID */
export type Fpi__Quote__Policy = {
  __typename?: 'fpi__quote__Policy'
  /** The Name of the Business */
  businessName?: Maybe<Scalars['String']['output']>
  /** The policy end date */
  policyEndDate?: Maybe<Scalars['String']['output']>
  /** The policyId */
  policyId: Scalars['ID']['output']
  /** The date when policy was issued */
  policyIssuedDate?: Maybe<Scalars['String']['output']>
  /** The policy Number */
  policyNumber?: Maybe<Scalars['String']['output']>
  /** The policy start date */
  policyStartDate?: Maybe<Scalars['String']['output']>
}

/** The proposal for a given proposal ID. */
export type Fpi__Quote__Proposal = {
  __typename?: 'fpi__quote__Proposal'
  /** Address of the business owner and related fields */
  address?: Maybe<Fpi__Quote__Address>
  /** Identifying information for an Origami Application Member */
  applicationMemberDetails?: Maybe<Fpi__Quote__ApplicationMemberDetails>
  /** Billing Frequency, values can be O for One time , M for Monthly, S for semi annually , Q for Quarterly */
  billingFrequency?: Maybe<Scalars['String']['output']>
  /** The text mapped to business structure like LLC */
  businessStructure?: Maybe<Scalars['String']['output']>
  /** It represents the policy start Date */
  expectedPolicyStartDate?: Maybe<Scalars['String']['output']>
  /** A list of vehicle usage knockout questions with the Origami JSON field name as the key and question answer as the value */
  knockoutQuestions?: Maybe<Array<Maybe<Fpi__Quote__VehicleUsageKnockoutQuestionItem>>>
  /** Member ID */
  memberId?: Maybe<Scalars['Int']['output']>
  /**
   * This field holds the business type code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as NAICS
   */
  naicsCode?: Maybe<Scalars['String']['output']>
  /** Description for NAICS code, for example Plumbing Contractors */
  naicsDescription?: Maybe<Scalars['String']['output']>
  /** It represents the policy start Date */
  policyEndDate?: Maybe<Scalars['String']['output']>
  /** Premium of the proposed proposal, The premium value is dependant on the billing frequency selection. */
  premium?: Maybe<Scalars['String']['output']>
  /** Proposal number */
  proposalNumber?: Maybe<Scalars['String']['output']>
  /**
   * This field holds the business category code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as SIC code
   */
  sicCode?: Maybe<Scalars['String']['output']>
  /** Description for SIC code, for example Plumbing, heating, Air cooling */
  sicDescription?: Maybe<Scalars['String']['output']>
  /** A customer needs provide consent enroll in Ford Pro Telematics. If the box is checked, then the customer consents, and the value is true. */
  telematicsDataConsent?: Maybe<Scalars['Boolean']['output']>
  /** Total cost is sum of  Premium and installment Fees. */
  totalCost?: Maybe<Scalars['String']['output']>
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__Query = {
  __typename?: 'fpi__quote__Query'
  /**
   * Retrieves combined applicable and selected coverages for a given coverage type.
   * The parentId is dependent on the coverage type.
   * For vehicle, use vehicleId
   * For policy, no parentId is needed
   * For state, use coverageHeaderId
   */
  applicableCoverages?: Maybe<Array<Maybe<Fpi__ApplicableCoverage>>>
  /** Retrieves billing options for a given proposal */
  billingOptions?: Maybe<Array<Maybe<Fpi__Quote__BillingOption>>>
  /** Retrieves driver info for a given proposal and dsriver ID */
  driver?: Maybe<Fpi__Driver>
  /** Retrieves drivers for a given proposal */
  drivers?: Maybe<Array<Maybe<Fpi__Driver>>>
  /** Retrieves the insurance history for a given proposal ID */
  insuranceHistory?: Maybe<Fpi__Quote__InsuranceHistory>
  /** Validates if a created proposal id has reflected in current session's CCN user profile */
  isValidProposal: Scalars['Boolean']['output']
  /** Retrieves locations for a given proposal */
  locations?: Maybe<Array<Maybe<Fpi__LocationListItem>>>
  /** Retrieves loss history records for a given proposal */
  lossHistories?: Maybe<Array<Maybe<Fpi__LossHistory>>>
  /** Retrieves a token to be used for Origami calls */
  origamiToken?: Maybe<Scalars['String']['output']>
  /** Retrieves Payment information for a given proposal ID, required to initiate payment */
  paymentMetaData?: Maybe<Fpi__PaymentMetaData>
  /** Retrieves policy details for a given policyId */
  policy?: Maybe<Fpi__Quote__Policy>
  /** Retrieves policy coverage records for a given proposal Id */
  policyCoverage?: Maybe<Array<Maybe<Fpi__Coverage>>>
  /** Retrieves a proposal for a given ID from origami */
  proposal?: Maybe<Fpi__Quote__Proposal>
  /** Identifies fields to be shown on the Customer Portal UI based on a proposal's selected state. */
  showProposalFields: Fpi__Quote__ShowFields
  /** Retrieves state/extra coverage records for a given proposal Id */
  stateCoverage?: Maybe<Array<Maybe<Fpi__Coverage>>>
  /** Validates a user's proposalId (emailed to them) and email against proposal information. */
  validateEmailProposal: Fpi__Quote__ValidateEmailProposalResponse
  /** Retrieves vehicle info for a given proposal and vehicle ID */
  vehicle?: Maybe<Fpi__Vehicle>
  /** Retrieves vehicles for a given proposal */
  vehicles?: Maybe<Array<Maybe<Fpi__VehicleListItem>>>
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryApplicableCoveragesArgs = {
  coverageCustomization: Fpi__CoverageCustomizationSectionInput
  parentId?: InputMaybe<Scalars['Int']['input']>
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryBillingOptionsArgs = {
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryDriverArgs = {
  driverId: Scalars['Int']['input']
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryDriversArgs = {
  request?: InputMaybe<Fpi__Quote__LookupByProposalIdRequest>
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryInsuranceHistoryArgs = {
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryIsValidProposalArgs = {
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryLossHistoriesArgs = {
  request?: InputMaybe<Fpi__Quote__LookupByProposalIdRequest>
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryPaymentMetaDataArgs = {
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryPolicyArgs = {
  policyId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryPolicyCoverageArgs = {
  request?: InputMaybe<Fpi__Quote__LookupByProposalIdRequest>
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryProposalArgs = {
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryShowProposalFieldsArgs = {
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryStateCoverageArgs = {
  request?: InputMaybe<Fpi__Quote__LookupByProposalIdRequest>
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryValidateEmailProposalArgs = {
  contactEmail: Scalars['String']['input']
  proposalId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryVehicleArgs = {
  proposalId: Scalars['Int']['input']
  vehicleId: Scalars['Int']['input']
}

/** Contains all necessary queries to generate a quote for an applicant */
export type Fpi__Quote__QueryVehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  proposalId: Scalars['Int']['input']
}

/** Response message for running a rating with a given proposal ID */
export type Fpi__Quote__RateQuoteResponse = {
  __typename?: 'fpi__quote__RateQuoteResponse'
  /** The HTTP status code from origami API response */
  code?: Maybe<Scalars['Int']['output']>
  /** The run status for runDefaultCoverage can be RUN_FAILED , OPERATION_SUCCESS and more */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates if API polling needs to continue or not */
  polling?: Maybe<Scalars['Boolean']['output']>
  /** Indicated whether the api call was successfully executed */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Response message for saving a quote to continue at a later date */
export type Fpi__Quote__SaveAndContinueResponse = {
  __typename?: 'fpi__quote__SaveAndContinueResponse'
  /** The HTTP status code for Save and Continue API response */
  code?: Maybe<Scalars['Int']['output']>
  /** Signifies the success or error message from the Save and Continue API response */
  message?: Maybe<Scalars['String']['output']>
  /** A flag to show that a save and continue email was successfully sent to the user. */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** A set of response parameters from origami while adding/editing loss history records */
export type Fpi__Quote__SaveLossHistoryResponse = {
  __typename?: 'fpi__quote__SaveLossHistoryResponse'
  /** Record ID for loss History record part of the composite key along with lossHistoryId */
  clueDriverId?: Maybe<Scalars['String']['output']>
  /** The HTTP status code for update insurance history response */
  code?: Maybe<Scalars['Int']['output']>
  /** Record ID for loss History record part of the composite key along with clueDriverId */
  lossHistoryId?: Maybe<Scalars['String']['output']>
  /** Signifies the success or error message from origami */
  message?: Maybe<Scalars['String']['output']>
  /** A flag to show the success status from origami */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Shows which fields to be presented in the Customer Portal based on the state associated with a proposal */
export type Fpi__Quote__ShowFields = {
  __typename?: 'fpi__quote__ShowFields'
  /** Option to waive deductible for safety glass */
  showFullSafetyGlass?: Maybe<Scalars['Boolean']['output']>
  /** A customer needs provide consent enroll in Ford Pro Telematics. If the box is checked, then the customer consents, and the value is true. */
  showTelematicsDataConsent?: Maybe<Scalars['Boolean']['output']>
}

/** input needed to perform add,update and delete operation in Origami for vehicle,policy and state coverages */
export type Fpi__Quote__UpdateCoverage = {
  /** The CoverageId mapped in Origami and has to be taken as input from applicableCoverages query Response  */
  coverageId?: InputMaybe<Scalars['String']['input']>
  /** The user customized coverage fields which are inserted , updated and deleted in Origami for the above coverageId */
  fieldsData?: InputMaybe<Array<InputMaybe<Fpi__KeyValue>>>
  /** The id has to be taken as input from applicableCoverages query Response , it helps to identify if the coverage has to be inserted or Updated in Origami */
  id?: InputMaybe<Scalars['String']['input']>
  /**
   * The parentId is dependent on the Coverage Domain ,
   * inCase of VehicleCoverages , vehicleId has to be taken as input from vehicles query response .
   */
  parentId?: InputMaybe<Scalars['String']['input']>
}

/** placeholder for coverages that have to be inserted , updated and deleted in Origami */
export type Fpi__Quote__UpdateCoverageRequest = {
  /** List of coverages that have to be deleted in Origami */
  deletes?: InputMaybe<Array<InputMaybe<Fpi__Quote__UpdateCoverage>>>
  /** List of coverages that have to be inserted in Origami */
  inserts?: InputMaybe<Array<InputMaybe<Fpi__Quote__UpdateCoverage>>>
  /** List of coverages that have to be updated in Origami */
  updates?: InputMaybe<Array<InputMaybe<Fpi__Quote__UpdateCoverage>>>
}

/** Final Response for UpdateCoverages Api that returns the overall status with Origami Response for Insert and Update Coverages */
export type Fpi__Quote__UpdateCoverageResponse = {
  __typename?: 'fpi__quote__UpdateCoverageResponse'
  /** The Origami API Response for Inserted ,Updated and Deleted coverages */
  apiResponse?: Maybe<Fpi__Quote__DomainCoverageResponse>
  /** The HTTP status code from origami API response */
  code?: Maybe<Scalars['Int']['output']>
  /** The message indicates whether the operation was success or failed  */
  message?: Maybe<Scalars['String']['output']>
  /** Indicated whether the api call was successfully executed */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** A set of input parameters related to driver's data and are updated against a proposalId */
export type Fpi__Quote__UpdateDriverRequest = {
  /** dateOfBirth of the Driver */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>
  /** firstName of the Driver */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** LastName of the Driver */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** license number of the Driver */
  licenseNumber?: InputMaybe<Scalars['String']['input']>
  /** id mapped against license state ex: Illinois , retrieved from license state Origami API */
  licenseStateId?: InputMaybe<Scalars['String']['input']>
  /** id mapped against the status text ex : Suspended */
  licenseStatusId?: InputMaybe<Scalars['String']['input']>
}

/** A set of response parameters for updateDriver. */
export type Fpi__Quote__UpdateDriverResponse = {
  __typename?: 'fpi__quote__UpdateDriverResponse'
  /** The HTTP status code from the Origami response */
  code?: Maybe<Scalars['Int']['output']>
  /** the driverId if the request was successful or null incase of failure */
  driverId?: Maybe<Scalars['Int']['output']>
  /** The message received from origami service indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** Indicates whether the driver was updated successful. */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Response message for adding or updating an applicant's insurance history */
export type Fpi__Quote__UpdateInsuranceHistoryResponse = {
  __typename?: 'fpi__quote__UpdateInsuranceHistoryResponse'
  /** The HTTP status code for update insurance history response */
  code?: Maybe<Scalars['Int']['output']>
  /** Record ID of applicant's insurance history */
  insuranceHistoryId?: Maybe<Scalars['Int']['output']>
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message?: Maybe<Scalars['String']['output']>
  /** Indicated whether the insurance history for the applicant was added successfully */
  success?: Maybe<Scalars['Boolean']['output']>
}

/**
 * "
 * updateProposal contains attributes related to BusinessInfo, BusinessOwner, BusinessAddress,
 * PrimaryContact and BusinessDetails that have to be updated against a proposalId
 */
export type Fpi__Quote__UpdateProposalRequest = {
  /** holds businessAddress related fields */
  address?: InputMaybe<Fpi__Address>
  /** Identifying fields for an Origami Application Member */
  applicationMemberDetails?: InputMaybe<Fpi__ApplicationMemberDetails>
  /** Billing Frequency, values can be O for One time , M for Monthly, S for semi annually , Q for Quarterly */
  billingFrequency?: InputMaybe<Scalars['String']['input']>
  /** The text mapped to business structure like LLC */
  businessStructure?: InputMaybe<Scalars['String']['input']>
  /** It represents the policy startDate */
  expectedPolicyStartDate?: InputMaybe<Scalars['String']['input']>
  /** A list of Vehicle Usage knockout question answers. The value for each key should be true for 'yes' and false for 'no.'  */
  knockoutQuestions?: InputMaybe<Array<InputMaybe<Fpi__Quote__VehicleUsageKnockoutQuestion>>>
  /**
   * This field holds the business type code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as NAICS
   */
  naicsCode?: InputMaybe<Scalars['String']['input']>
  /** It represents the policy endDate */
  policyEndDate?: InputMaybe<Scalars['String']['input']>
  /**
   * This field holds the business category code configured in Origami with respect to
   * to business types such as Plumbing, heating, Air cooling. This is identified with Origami
   * as SIC code
   */
  sicCode?: InputMaybe<Scalars['String']['input']>
  /** A customer needs provide consent enroll in Ford Pro Telematics. If the box is checked, then the customer consents, and the value is true. */
  telematicsDataConsent?: InputMaybe<Scalars['Boolean']['input']>
}

/** Response type for a Proposal mutation. Used for CreateProposal and UpdateProposal. */
export type Fpi__Quote__UpdateProposalResponse = {
  __typename?: 'fpi__quote__UpdateProposalResponse'
  /** The HTTP status code from the Origami request */
  code?: Maybe<Scalars['Int']['output']>
  /** The id of a member created after a successful create proposal call. */
  memberId?: Maybe<Scalars['Int']['output']>
  /** The message received from origami service indicating whether it was successful or what type of error occurred. */
  message?: Maybe<Scalars['String']['output']>
  /** The proposalId if the request was successfully processed else null */
  proposalId?: Maybe<Scalars['Int']['output']>
  /** Indicates whether the proposal was saved successful. */
  success?: Maybe<Scalars['Boolean']['output']>
}

/** A set of inputs for updating a vehicle. */
export type Fpi__Quote__UpdateVehicleRequest = {
  /** The body style of the vehicle. (e.g  Crew Cab, Sport Utility) */
  bodyStyle?: InputMaybe<Scalars['String']['input']>
  /** The body style Id configured in Origami for the above body style. */
  bodyStyleId?: InputMaybe<Scalars['String']['input']>
  /** Option to waive deductible for safety glass */
  fullSafetyGlass?: InputMaybe<Scalars['Boolean']['input']>
  /** The Garage location ID of the vehicle. */
  garageLocationId?: InputMaybe<Scalars['String']['input']>
  /** Represents vehicle identifier number, this will hold either a VIN or SRL based on vehicle identifier Type */
  idNumber?: InputMaybe<Scalars['String']['input']>
  /** Represents vehicle identifier types, the possible values are VIN or SRL */
  identifierType?: InputMaybe<Scalars['String']['input']>
  /** The localized make of the vehicle (e.g. Ford) */
  make?: InputMaybe<Scalars['String']['input']>
  /** The localized model of the vehicle (e.g. Mustang) */
  model?: InputMaybe<Scalars['String']['input']>
  /**
   * This field defines the level of training, skill, and experience
   * possessed by the individual or operator who operates these types of vehicles.
   * This is only applicable for PPT vehicle types.
   * NOOPER - No operator licensed less than five years
   * NOTOWNER - Operator licensed less than five years, is not owner or principal operator
   * OWNER - Owner or principal operator licensed less than five years
   */
  operatorExperience?: InputMaybe<Scalars['String']['input']>
  /**
   * It represents the monetary worth or value assigned to the vehicle based on
   * various factors such as its make, model, year, condition, mileage,
   * features, and market demand.
   */
  originalCostNew?: InputMaybe<Scalars['String']['input']>
  /** Indicates whether a vehicle is owned, leased, or loaned. */
  ownershipTypeId?: InputMaybe<Scalars['String']['input']>
  /** Radius covered by the vehicle, depending on the vehicle type (PPT or TTT). the value can change  */
  radius?: InputMaybe<Scalars['String']['input']>
  /** State id for the proposal */
  stateId?: InputMaybe<Scalars['String']['input']>
  /** This defines the class of TTT or PPT vehicles such as TRUCKER, FOOD, WASTE, SPECIALIZED, FARMER, DUMPTRANS and etc. */
  vehicleClass?: InputMaybe<Scalars['String']['input']>
  /** This defines the size class for TTT vehicles. The values  can be HEAVY, LIGHT,MEDIUM and etc. */
  vehicleSize?: InputMaybe<Scalars['String']['input']>
  /**
   * It is a more defined categories based on TTT or PPT vehicle class.
   * for e.g FOOD can be divided in to Fish and seafood, frozen food, etc.
   */
  vehicleSubclass?: InputMaybe<Scalars['String']['input']>
  /**
   * Vehicle type is required because it needed to determine the Origami field name for vehicle use and radius.
   * Type of vehicle such as
   * PPT - Private Passenger type,
   * TTT- Truck, tractor and Trailer,
   * Public and Special.
   */
  vehicleType: Scalars['String']['input']
  /** How the vehicle is used based on vehicle Type e.g FLEET and NON-FLEET */
  vehicleUse?: InputMaybe<Scalars['String']['input']>
  /** The model year of the vehicle (e.g. 2020) */
  year?: InputMaybe<Scalars['String']['input']>
}

/** A set of response parameters for adding, updating, or deleting a vehicle to be included in a quote submission */
export type Fpi__Quote__UpdateVehicleResponse = {
  __typename?: 'fpi__quote__UpdateVehicleResponse'
  /** The HTTP status code for the update vehicle response */
  code?: Maybe<Scalars['Int']['output']>
  /** The status message for the change indicating whether it was successful or what type of error occurred */
  message?: Maybe<Scalars['String']['output']>
  /** Indicated whether the vehicle was added successfully */
  success?: Maybe<Scalars['Boolean']['output']>
  /** Record ID of vehicle */
  vehicleId?: Maybe<Scalars['Int']['output']>
}

/** Response message for validating a user's proposal information from an email. */
export type Fpi__Quote__ValidateEmailProposalResponse = {
  __typename?: 'fpi__quote__ValidateEmailProposalResponse'
  /** A flag to show that a user's proposal has exceeded a certain amount of time. */
  isExpired?: Maybe<Scalars['Boolean']['output']>
  /** A flag to show that a policy has already been issued to a customer */
  isPolicyIssued?: Maybe<Scalars['Boolean']['output']>
  /** A flag to show that a customer has a valid proposal number and matching email based on their proposal information. */
  isValidUser?: Maybe<Scalars['Boolean']['output']>
  /**
   * MemberID linked to the Proposal Number
   * @deprecated memberId is not used
   */
  memberId?: Maybe<Scalars['Int']['output']>
  /** ProposalID of the applicant. */
  proposalId?: Maybe<Scalars['Int']['output']>
}

/** Input for adding a vehicle usage knockout question */
export type Fpi__Quote__VehicleUsageKnockoutQuestion = {
  /** The Origami JSON field name for the vehicle usage knockout question */
  key: Scalars['String']['input']
  /** The user's answer for the vehicle usage knockout question - true for yes, false for no */
  value: Scalars['Boolean']['input']
}

/** Response for retrieving vehicle usage knockout question answers from a proposal */
export type Fpi__Quote__VehicleUsageKnockoutQuestionItem = {
  __typename?: 'fpi__quote__VehicleUsageKnockoutQuestionItem'
  /** The Origami JSON field name for the vehicle usage knockout question */
  key: Scalars['String']['output']
  /** The user's answer for the vehicle usage knockout question - true for yes, false for no */
  value?: Maybe<Scalars['Boolean']['output']>
}

export type FcFinSimpleGrowCustomerUpdateNotificationPreferencesMutationVariables = Exact<{
  input: Fc__Customer__NotificationPreferencesRequest
}>

export type FcFinSimpleGrowCustomerUpdateNotificationPreferencesMutation = {
  __typename?: 'Mutation'
  fc__customer__updateNotificationPreferences: {
    __typename?: 'fc__customer__UpdateNotificationPreferencesResponse'
    success: boolean
    code: number
    message?: string | null
  }
}

export type FcFinSimpleGrowAccountUpdateNotificationPreferencesMutationVariables = Exact<{
  input: Fc__Account__NotificationPreferencesRequest
}>

export type FcFinSimpleGrowAccountUpdateNotificationPreferencesMutation = {
  __typename?: 'Mutation'
  fc__account__updateNotificationPreferences: {
    __typename?: 'fc__account__UpdateNotificationPreferencesResponse'
    success: boolean
    code: number
    message?: string | null
  }
}

export type FcFinSimpleGrowCustomerUpdateEmailsMutationVariables = Exact<{
  input: Fmcc__Customer__EmailRequest
}>

export type FcFinSimpleGrowCustomerUpdateEmailsMutation = {
  __typename?: 'Mutation'
  fmcc__customer__updateEmails: {
    __typename?: 'fmcc__customer__EmailResponse'
    success: boolean
    code: number
    message?: string | null
  }
}

export type FcFinSimpleGrowCustomerUpdateBillingAddressMutationVariables = Exact<{
  input: Fmcc__Customer__BillingAddressRequest
}>

export type FcFinSimpleGrowCustomerUpdateBillingAddressMutation = {
  __typename?: 'Mutation'
  fmcc__customer__updateBillingAddress: {
    __typename?: 'fmcc__customer__BillingAddressResponse'
    success: boolean
    code: number
    message?: string | null
  }
}

export type FcFinSimpleGrowAccountUpdateGaragingAddressMutationVariables = Exact<{
  input: Fmcc__Account__GaragingAddressRequest
}>

export type FcFinSimpleGrowAccountUpdateGaragingAddressMutation = {
  __typename?: 'Mutation'
  fmcc__account__updateGaragingAddress: {
    __typename?: 'fmcc__account__GaragingAddressResponse'
    success: boolean
    code: number
    message?: string | null
    garagingAddress?: {
      __typename?: 'fmcc__account__Address'
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      state?: string | null
      zip?: string | null
      country?: string | null
      lastModifiedDate?: any | null
    } | null
  }
}

export type FcFinSimpleGrowCustomerUpdatePhonesMutationVariables = Exact<{
  input: Fmcc__Customer__PhoneRequest
}>

export type FcFinSimpleGrowCustomerUpdatePhonesMutation = {
  __typename?: 'Mutation'
  fmcc__customer__updatePhones: {
    __typename?: 'fmcc__customer__PhoneResponse'
    success: boolean
    code: number
    message?: string | null
  }
}

export type FcFinSimpleGrowProfileAccountsByMcnQueryVariables = Exact<{
  mcn: Scalars['fc__customer__MCN']['input']
  masterCustomerNumber: Scalars['Int']['input']
  country: Country
}>

export type FcFinSimpleGrowProfileAccountsByMcnQuery = {
  __typename?: 'Query'
  fmcc?: {
    __typename?: 'fmcc__Query'
    account?: {
      __typename?: 'fmcc__account__Query'
      accountsByMCN?: Array<{
        __typename?: 'fc__account__PinnacleAccount'
        accountNumber?: number | null
        companyBusinessCode?: number | null
        applicantType?: string | null
        vehicleIdentificationNumber?: any | null
        vehicleNickname?: string | null
        vehicleMake?: string | null
        vehicleModel?: string | null
        vehicleYear?: number | null
        accountStatus?: string | null
        accountStatusCode?: number | null
        garagingAddress?: {
          __typename?: 'fmcc__account__Address'
          addressLine1?: string | null
          addressLine2?: string | null
          city?: string | null
          state?: string | null
          zip?: string | null
          country?: string | null
        } | null
      }> | null
    } | null
    payment?: {
      __typename?: 'fmcc__payment__Query'
      multiPaymentInformation?: {
        __typename?: 'fmcc__payment__MultiPaymentInformation'
        multiPaymentAccountInformation?: Array<{
          __typename?: 'fmcc__payment__MultiPaymentAccountInformation'
          account?: { __typename?: 'fmcc__account__Account'; id?: any | null } | null
          paymentEligibilityDetails?: {
            __typename?: 'fmcc__payment__EligibilityDetails'
            isCombinedBillingAccount?: boolean | null
            isAutoPayEnrolled?: boolean | null
            isPayrollDeduct?: boolean | null
            isInBankruptcy?: boolean | null
            isAccountClosed?: boolean | null
          } | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type FcFinSimpleGrowProfileCustomerAccountRelationQueryVariables = Exact<{
  accountNumber: Scalars['fmcc__account__AccountNumber']['input']
  applicantCode: ApplicantCode
}>

export type FcFinSimpleGrowProfileCustomerAccountRelationQuery = {
  __typename?: 'Query'
  fmcc?: {
    __typename?: 'fmcc__Query'
    customer?: {
      __typename?: 'fmcc__customer__Query'
      customerAccountRelation?: {
        __typename?: 'fmcc__customer__CustomerAccountRelation'
        account: {
          __typename?: 'fmcc__account__Account'
          id?: any | null
          garagingAddress?: {
            __typename?: 'fmcc__account__Address'
            addressLine1?: string | null
            addressLine2?: string | null
            city?: string | null
            state?: string | null
            zip?: string | null
            country?: string | null
          } | null
        }
        customerProfile?: {
          __typename?: 'fmcc__customer__CustomerProfile'
          id: any
          firstName?: string | null
          lastName?: string | null
          companyName?: string | null
          digitalCommunications?: Array<{
            __typename?: 'fc__customer__DigitalCommunication'
            text?: string | null
          }> | null
          billingAddress?: {
            __typename?: 'fc__customer__BillingAddress'
            addressLine1?: string | null
            addressLine2?: string | null
            country?: string | null
            city?: string | null
            state?: string | null
            zip?: string | null
          } | null
          phoneNumbers?: Array<{
            __typename?: 'fmcc__phoneNumber'
            phoneNumber?: string | null
            extension?: string | null
            phoneType?: Fmcc__PhoneType | null
            phoneLocation?: Fmcc__PhoneLocation | null
            phoneCategory?: Fmcc__PhoneCategory | null
            sequenceNumber?: number | null
            phoneIDNumber?: string | null
          }> | null
        } | null
        notificationPreferences?: {
          __typename?: 'fc__customer__NotificationPreferences'
          customerPreferredChannel?: string | null
          customerPreferences?: Array<{
            __typename?: 'fc__customer__Preferences'
            channel: string
            permission: boolean
            permissionType: string
            paymentReminderDaysPrior?: number | null
            phoneValidated?: boolean | null
            phoneIdNumber?: string | null
          }> | null
          accountPreferences?: Array<{
            __typename?: 'fc__customer__AccountPreferences'
            preferences?: Array<{
              __typename?: 'fc__customer__Preferences'
              channel: string
              permission: boolean
              permissionType: string
              paymentReminderDaysPrior?: number | null
              phoneValidated?: boolean | null
              phoneIdNumber?: string | null
              permissionHistory?: Array<{
                __typename?: 'fc__customer__PermissionUpdateRecord'
                actualRequestTimestamp?: any | null
                updateTimestamp?: any | null
              }> | null
            }> | null
            account?: { __typename?: 'fmcc__account__Account'; id?: any | null } | null
          }> | null
        } | null
      } | null
    } | null
  } | null
}

export const FcFinSimpleGrowCustomerUpdateNotificationPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FcFinSimpleGrowCustomerUpdateNotificationPreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'fc__customer__NotificationPreferencesRequest' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fc__customer__updateNotificationPreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FcFinSimpleGrowCustomerUpdateNotificationPreferencesMutation,
  FcFinSimpleGrowCustomerUpdateNotificationPreferencesMutationVariables
>
export const FcFinSimpleGrowAccountUpdateNotificationPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FcFinSimpleGrowAccountUpdateNotificationPreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'fc__account__NotificationPreferencesRequest' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fc__account__updateNotificationPreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FcFinSimpleGrowAccountUpdateNotificationPreferencesMutation,
  FcFinSimpleGrowAccountUpdateNotificationPreferencesMutationVariables
>
export const FcFinSimpleGrowCustomerUpdateEmailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FcFinSimpleGrowCustomerUpdateEmails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'fmcc__customer__EmailRequest' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fmcc__customer__updateEmails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FcFinSimpleGrowCustomerUpdateEmailsMutation,
  FcFinSimpleGrowCustomerUpdateEmailsMutationVariables
>
export const FcFinSimpleGrowCustomerUpdateBillingAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FcFinSimpleGrowCustomerUpdateBillingAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'fmcc__customer__BillingAddressRequest' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fmcc__customer__updateBillingAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FcFinSimpleGrowCustomerUpdateBillingAddressMutation,
  FcFinSimpleGrowCustomerUpdateBillingAddressMutationVariables
>
export const FcFinSimpleGrowAccountUpdateGaragingAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FcFinSimpleGrowAccountUpdateGaragingAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'fmcc__account__GaragingAddressRequest' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fmcc__account__updateGaragingAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'garagingAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastModifiedDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FcFinSimpleGrowAccountUpdateGaragingAddressMutation,
  FcFinSimpleGrowAccountUpdateGaragingAddressMutationVariables
>
export const FcFinSimpleGrowCustomerUpdatePhonesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FcFinSimpleGrowCustomerUpdatePhones' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'fmcc__customer__PhoneRequest' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fmcc__customer__updatePhones' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FcFinSimpleGrowCustomerUpdatePhonesMutation,
  FcFinSimpleGrowCustomerUpdatePhonesMutationVariables
>
export const FcFinSimpleGrowProfileAccountsByMcnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FcFinSimpleGrowProfileAccountsByMCN' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mcn' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'fc__customer__MCN' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'masterCustomerNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'country' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Country' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fmcc' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountsByMCN' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'mcn' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'mcn' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accountNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyBusinessCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vehicleIdentificationNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vehicleNickname' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vehicleMake' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vehicleModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vehicleYear' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'accountStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'accountStatusCode' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'garagingAddress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'multiPaymentInformation' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'masterCustomerNumber' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'masterCustomerNumber' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'country' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'country' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'multiPaymentAccountInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'account' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'paymentEligibilityDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'isCombinedBillingAccount' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isAutoPayEnrolled' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isPayrollDeduct' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isInBankruptcy' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isAccountClosed' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FcFinSimpleGrowProfileAccountsByMcnQuery,
  FcFinSimpleGrowProfileAccountsByMcnQueryVariables
>
export const FcFinSimpleGrowProfileCustomerAccountRelationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FcFinSimpleGrowProfileCustomerAccountRelation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'accountNumber' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'fmcc__account__AccountNumber' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantCode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantCode' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fmcc' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerAccountRelation' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'accountNumber' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'accountNumber' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'applicantCode' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantCode' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'account' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'garagingAddress' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'customerProfile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'digitalCommunications' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'billingAddress' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phoneNumbers' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'extension' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneLocation' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneCategory' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sequenceNumber' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneIDNumber' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'notificationPreferences' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'customerPreferredChannel' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customerPreferences' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'permissionType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'paymentReminderDaysPrior' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneValidated' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneIdNumber' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'accountPreferences' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'preferences' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'permissionType' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'paymentReminderDaysPrior' },
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'phoneValidated' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'phoneIdNumber' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissionHistory' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'actualRequestTimestamp' },
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updateTimestamp' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'account' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FcFinSimpleGrowProfileCustomerAccountRelationQuery,
  FcFinSimpleGrowProfileCustomerAccountRelationQueryVariables
>
